import { Component, OnInit, Inject } from '@angular/core';
import { MatDialog, MatDialogConfig, MatDialogModule, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ModalComponent } from '../modal/modal.component';
import { ChangeSizeComponent } from '../modal/change-size/change-size.component';
import { SelectBackgroundComponent } from '../modal/select-background/select-background.component';
import { GlobalConstants } from '../../common/global-variable';
import { Flags } from '../../common/flags'
import { HttpClient } from '@angular/common/http';
import jspdf from 'jspdf';

import { ApiService } from '../../service/api.service';
import { ProgressComponent } from '../modal/progress/progress.component';
import { OrdersComponent } from 'src/app/dashboard/orders/orders.component';
import { OrderprintComponent } from '../modal/orderprint/orderprint.component';
import { DesignService } from 'src/app/service/design.service';
import { SaveDesignDialogComponent } from '../save-design-dialog/save-design-dialog.component';
import { PreviewComponent } from '../modal/preview/preview.component';
import { CheckwarningComponent } from '../modal/checkwarning/checkwarning.component';
import { AlertComponent } from '../modal/alert/alert.component';
import { DomSanitizer } from '@angular/platform-browser';
import { NgxIndexedDBService } from 'ngx-indexed-db';

declare var d3: any;
var singleModal: any;
var boxSize: any;
var background: any;

var imgSize = [3000, 2500, 2000, 1700, 1300, 1000]
var textSize = [500, 260, 220, 180, 140, 100, 70, 50]

var empty_node_setting: string;
var text_align: string;
var name_text_align: string;

var fontFamily = ['Helvetica', 'Arial', 'sans-serif']
var imgSizeGroup, flagSizeGroup, textSizeGroup;

var imgSizeGroup1 = {
    'A0': [2000, 1700, 1500, 1350, 1200, 800],
    'A1': [1600, 1400, 1250, 1100, 1000, 650],
    'A2': [1400, 1200, 1050, 900, 800, 450],
    // 'A3': [1200, 1000, 850, 700, 600, 400],
    // 'A4': [1000, 700, 500, 400, 400, 200],
    // 'Custom': [2000, 1700, 1500, 1350, 1200, 1000],
}
var flagSizeGroup1 = {
    'A0': [800, 700, 600, 500, 450, 400],
    'A1': [700, 600, 500, 450, 400, 350],
    'A2': [650, 550, 450, 400, 350, 300],
    // 'A3': [500, 400, 300, 200, 100, 100],
    // 'A4': [300, 200, 150, 120, 80, 80],
    // 'Custom': [800, 700, 600, 500, 400, 400],
}
var textSizeGroup1 = {
    'A0': [250, 250, 200, 200, 200, 150, 120, 80, 60, 70],
    'A1': [200, 180, 180, 180, 150, 100, 70, 70, 50, 50],
    'A2': [180, 150, 150, 110, 110, 70, 50, 50, 50, 50],
    // 'A3': [180, 150, 150, 110, 80, 50, 50, 50, 50, 50],
    // 'A4': [150, 130, 110, 90, 70, 50, 50, 50, 50, 50],
    // 'Custom': [250, 200, 200, 180, 140, 100, 70, 50],
}

var imgSizeGroup2 = {
    'A0': [2000, 1700, 1500, 1350, 1200, 800],
    'A1': [1600, 1400, 1250, 1100, 1000, 650],
    'A2': [1400, 1200, 1050, 900, 800, 450],
    // 'A3': [1200, 1000, 850, 700, 600, 400],
    // 'A4': [1000, 700, 500, 400, 400, 200],
    // 'Custom': [2000, 1700, 1500, 1350, 1200, 1000],
}
var flagSizeGroup2 = {
    'A0': [800, 700, 600, 500, 450, 400],
    'A1': [700, 600, 500, 450, 400, 350],
    'A2': [650, 550, 450, 400, 350, 250],
    // 'A3': [500, 400, 300, 200, 100, 100],
    // 'A4': [300, 200, 150, 120, 80, 80],
    // 'Custom': [800, 700, 600, 500, 400, 400],
}
var textSizeGroup2 = {
    'A0': [250, 250, 200, 200, 200, 150, 120, 100, 60, 70],
    'A1': [200, 180, 180, 180, 150, 100, 70, 70, 50, 50],
    'A2': [180, 150, 150, 110, 110, 70, 50, 50, 50, 50],
    // 'A3': [180, 150, 150, 110, 80, 50, 50, 50, 50, 50],
    // 'A4': [150, 130, 110, 90, 70, 50, 50, 50, 50, 50],
    // 'Custom': [250, 200, 200, 180, 140, 100, 70, 50],
}

var imgSizeGroup3 = {
    'A0': [2000, 1700, 1500, 1350, 1200, 800],
    'A1': [1600, 1400, 1250, 1100, 1000, 650],
    'A2': [1400, 1200, 1050, 900, 800, 450],
    // 'A3': [1200, 1000, 850, 700, 600, 400],
    // 'A4': [1000, 700, 500, 400, 400, 200],
    // 'Custom': [2000, 1700, 1500, 1350, 1200, 1000],
}
var flagSizeGroup3 = {
    'A0': [800, 700, 600, 500, 450, 400],
    'A1': [700, 600, 500, 450, 400, 350],
    'A2': [650, 550, 450, 400, 350, 300],
    // 'A3': [500, 400, 300, 200, 100, 100],
    // 'A4': [300, 200, 150, 120, 80, 80],
    // 'Custom': [800, 700, 600, 500, 400, 400],
}
var textSizeGroup3 = {
    'A0': [250, 250, 200, 200, 200, 150, 120, 80, 60, 70],
    'A1': [200, 180, 180, 180, 150, 100, 70, 70, 50, 50],
    'A2': [180, 150, 150, 110, 110, 70, 50, 50, 50, 50],
    // 'A3': [180, 150, 150, 110, 80, 50, 50, 50, 50, 50],
    // 'A4': [150, 130, 110, 90, 70, 50, 50, 50, 50, 50],
    // 'Custom': [250, 200, 200, 180, 140, 100, 70, 50],
}

var flagSize = []

var start_x = null;
var start_y = null;
var start_scale = 0.1;
var zoom

var node_width = 0;

var name_height = {}
var birth_height = {}
var marriage_height = {}
var death_height = {}
var note_height = {}

var papertype;
var manColor, womanColor;
var borderColor = '#000', borderWidth;
var backOpacity = 1, nodeOpacity;
var maxGeneration, treeWidth, treeHeight;
var femaleNodeColor, maleNodeColor, borderRadius;
var flag_setting, profile_setting, global_padding, warning_setting;
var partners
var children

var birthSetting, marriageSetting, deathSetting;

var maleAvatar = [GlobalConstants.male_1, GlobalConstants.male_2, GlobalConstants.male_3, GlobalConstants.male_4,
GlobalConstants.male_5, GlobalConstants.male_6, GlobalConstants.male_7, GlobalConstants.male_8, GlobalConstants.male_9,
GlobalConstants.male_10, GlobalConstants.male_11, GlobalConstants.male_12];

var femaleAvatar = [GlobalConstants.female_1, GlobalConstants.female_2, GlobalConstants.female_3, GlobalConstants.female_4,
GlobalConstants.female_5, GlobalConstants.female_6, GlobalConstants.female_7, GlobalConstants.female_8, GlobalConstants.female_9,
GlobalConstants.female_10, GlobalConstants.female_11, GlobalConstants.female_12];

function spliteText(string, length, ignore) {

    var temp = ""
    var result = []
    if (string === '-.-.-, n/a ' || string == '-.-.-, n/a') {
        result.push(string)
    }
    else {
        var list = string.split(" ");
        list.forEach((element, index) => {
            if (result.length < 2) {
                if (result.length == 0 && (temp.length + element.length < length - ignore)) {
                    temp += element + " ";
                }
                else if (temp.length + element.length < length) {
                    temp += element + " ";
                }
                else if (temp.length <= length) {
                    result.push(temp)
                    temp = element + " ";
                }
                if (index >= list.length - 1 && result.length < 2 && temp.length <= length) {
                    result.push(temp)
                }
            }
        });
        if (result[result.length - 1].charAt(result[result.length - 1].length - 2) == ",") {
            result[result.length - 1] = result[result.length - 1].slice(0, -2);
        }
    }
    return result;

}

function getMarriageDay(d) {
    if (d.c_fam) {
        let index = d.c_fam;
        let temp
        if (d.marriage && d.marriage[index] != {}) {
            if (d.marriage[index] && d.marriage[index]['dateRange']) {
                let from, to
                if (d.marriage[index]['dateRange'].from) {
                    if (d.marriage[index]['dateRange'].from.qualifier) {
                        from = (d.marriage[index]['dateRange'].from.year ? d.marriage[index]['dateRange'].from.year : "-") + (d.marriage[index]['dateRange'].from.qualifier ? "." + d.marriage[index]['dateRange'].from.qualifier : "");
                    }
                    else {
                        from = (d.marriage[index]['dateRange'].from.year ? d.marriage[index]['dateRange'].from.year : "-") + (d.marriage[index]['dateRange'].from.month ? "." + d.marriage[index]['dateRange'].from.month : ".-") + (d.marriage[index]['dateRange'].from.day ? "." + d.marriage[index]['dateRange'].from.day : ".-");
                    }
                }
                else {
                    from = "-.-.-";
                }
                if (d.marriage[index]['dateRange'].to) {
                    if (d.marriage[index]['dateRange'].to.qualifier) {
                        to = (d.marriage[index]['dateRange'].to.year ? d.marriage[index]['dateRange'].to.year : "-") + (d.marriage[index]['dateRange'].to.qualifier ? "." + d.marriage[index]['dateRange'].to.qualifier : "");
                    }
                    else {
                        to = (d.marriage[index]['dateRange'].to.year ? d.marriage[index]['dateRange'].to.year : "-") + (d.marriage[index]['dateRange'].to.month ? "." + d.marriage[index]['dateRange'].to.month : ".-") + (d.marriage[index]['dateRange'].to.day ? "." + d.marriage[index]['dateRange'].to.day : ".-");
                    }
                }
                else {
                    to = "-.-.-";
                }
                temp = from + " - " + to;
            }
            if (d.marriage[index] && d.marriage[index]['date']) {
                if (d.marriage[index]['date'].qualifier) {
                    temp = (d.marriage[index]['date'].year ? d.marriage[index]['date'].year : "-") + (d.marriage[index]['date'].qualifier ? "." + d.marriage[index]['date'].qualifier : "-");
                }
                else {
                    temp = (d.marriage[index]['date'].year ? d.marriage[index]['date'].year : "-") + (d.marriage[index]['date'].month ? "." + d.marriage[index]['date'].month : ".-") + (d.marriage[index]['date'].day ? "." + d.marriage[index]['date'].day : ".-");
                }
            }
        }
        else {
            temp = "-.-.-";
        }

        return temp;
    }
}

@Component({ selector: 'app-single', templateUrl: './single.component.html', styleUrls: ['./single.component.scss'] })
export class SingleComponent implements OnInit {
    showLoader: boolean = true;
    type: any;
    nodeinfos = {};
    coupleinfos = {};
    _id: any;
    wife: any;
    relation = {};
    p_type
    m_Color
    w_Color
    m_b_Color
    w_b_Color
    b_Color
    b_Width
    back_Opacity: number = 1
    node_Opacity
    max_generation
    cornerRound
    empty_node
    text_align
    name_text_align
    birthSetting: string = 'block'
    marriageSetting
    deathSetting
    partner_setting
    children_setting
    flag_setting
    profile_setting
    global_padding
    warning_setting
    gedcom_id: string = localStorage.getItem('gedcom_id');
    bg: string;
    existingDesignId: string;
    admin: string;
    fileUrl: any;

    nodeBornText: string;
    nodeMarriedText: string;
    nodeDeceasedText: string;
    constructor(public matDialog: MatDialog,
        public ApiService: ApiService,
        public http: HttpClient,
        private designService: DesignService,
        private dbService: NgxIndexedDBService,
        private sanitizer: DomSanitizer) { }

    saveDesignAs() {
        const dialogConfig = new MatDialogConfig();
        dialogConfig.data = {
            title: 'Save Design'
        };
        dialogConfig.disableClose = true;
        dialogConfig.autoFocus = true;
        const dialogRef = this.matDialog.open(SaveDesignDialogComponent, dialogConfig);
        dialogRef.afterClosed().subscribe(
            data => {
                console.log("Dialog output:", data.saveas)
                const doc = {
                    background: localStorage.getItem("background"),
                    manColor: localStorage.getItem('manColor') ? localStorage.getItem('manColor') : '#000',
                    womanColor: localStorage.getItem('womanColor') ? localStorage.getItem('womanColor') : '#000',
                    borderColor: localStorage.getItem('borderColor') ? localStorage.getItem('borderColor') : '#000',
                    maleNodeColor: localStorage.getItem('maleNodeColor') ? localStorage.getItem('maleNodeColor') : '#fff',
                    femaleNodeColor: localStorage.getItem('femaleNodeColor') ? localStorage.getItem('femaleNodeColor') : '#fff',
                    borderRadius: parseInt(localStorage.getItem('cornerRound') ? localStorage.getItem('cornerRound') : '50'),
                    borderWidth: parseInt(localStorage.getItem('borderWidth') ? localStorage.getItem('borderWidth') : '2'),
                    backOpacity: parseFloat(localStorage.getItem('backOpacity') ? localStorage.getItem('backOpacity') : '1'),
                    nodeOpacity: parseFloat(localStorage.getItem('nodeOpacity') ? localStorage.getItem('nodeOpacity') : '1'),
                    treeWidth: localStorage.getItem('tree_width') ? localStorage.getItem('tree_width') : 67408,
                    treeHeight: localStorage.getItem('tree_height') ? localStorage.getItem('tree_height') : 47679,
                    empty_node_setting: localStorage.getItem('empty_node_setting') ? localStorage.getItem('empty_node_setting') : "block",
                    text_align: localStorage.getItem('text_align') ? localStorage.getItem('text_align') : "middle",
                    name_text_align: localStorage.getItem('name_text_align') ? localStorage.getItem('name_text_align') : "middle",
                    birthSetting: localStorage.getItem('birth_setting') ? localStorage.getItem('birth_setting') : "block",
                    marriageSetting: localStorage.getItem('marriage_setting') ? localStorage.getItem('marriage_setting') : "block",
                    deathSetting: localStorage.getItem('death_setting') ? localStorage.getItem('death_setting') : "block",
                    flag_setting: localStorage.getItem('flag_setting') ? localStorage.getItem('flag_setting') : "SHOW",
                    profile_setting: localStorage.getItem('profile_setting') ? localStorage.getItem('profile_setting') : "SHOW",
                    warning_setting: localStorage.getItem('warning_setting') ? localStorage.getItem('warning_setting') : "SHOW",
                    global_padding: localStorage.getItem('global_padding') ? localStorage.getItem('global_padding') : '5',
                    design_name: data.saveas,
                    type: localStorage.getItem("type"),
                    id: localStorage.getItem("id"),
                    papertype: localStorage.getItem("papertype"),
                    direction: localStorage.getItem("direction"),
                    saved: new Date(),
                    maxGeneration: localStorage.getItem("maxGeneration"),
                    tree_width: localStorage.getItem("tree_width"),
                    tree_height: localStorage.getItem("tree_height"),
                    gedcom_id: localStorage.getItem("gedcom_id"),
                    gedcom_name: localStorage.getItem("gedcom_name")
                }
                this.designService.saveDesign(doc).then((d) => {
                    const dialogConfig = new MatDialogConfig();
                    dialogConfig.disableClose = true;
                    dialogConfig.id = "saveAs";
                    dialogConfig.data = {
                        title: 'Information',
                        message: "Design saved",
                        delay: 5000
                    }
                    const modalDialog = this.matDialog.open(AlertComponent, dialogConfig);
                }, err => console.log(err))
            }
        );
    }

    saveDesign() {
        if (localStorage.getItem('doc_id')) {
            let docid = localStorage.getItem('doc_id');
            const doc = {
                manColor: localStorage.getItem('manColor') ? localStorage.getItem('manColor') : '#000',
                womanColor: localStorage.getItem('womanColor') ? localStorage.getItem('womanColor') : '#000',
                borderColor: localStorage.getItem('borderColor') ? localStorage.getItem('borderColor') : '#000',
                maleNodeColor: localStorage.getItem('maleNodeColor') ? localStorage.getItem('maleNodeColor') : '#fff',
                femaleNodeColor: localStorage.getItem('femaleNodeColor') ? localStorage.getItem('femaleNodeColor') : '#fff',
                borderRadius: parseInt(localStorage.getItem('cornerRound') ? localStorage.getItem('cornerRound') : '50'),
                borderWidth: parseInt(localStorage.getItem('borderWidth') ? localStorage.getItem('borderWidth') : '2'),
                backOpacity: parseFloat(localStorage.getItem('backOpacity') ? localStorage.getItem('backOpacity') : '1'),
                nodeOpacity: parseFloat(localStorage.getItem('nodeOpacity') ? localStorage.getItem('nodeOpacity') : '1'),
                treeWidth: localStorage.getItem('tree_width') ? localStorage.getItem('tree_width') : 67408,
                treeHeight: localStorage.getItem('tree_height') ? localStorage.getItem('tree_height') : 47679,
                empty_node_setting: localStorage.getItem('empty_node_setting') ? localStorage.getItem('empty_node_setting') : "block",
                text_align: localStorage.getItem('text_align') ? localStorage.getItem('text_align') : "middle",
                name_text_align: localStorage.getItem('name_text_align') ? localStorage.getItem('name_text_align') : "middle",
                birthSetting: localStorage.getItem('birth_setting') ? localStorage.getItem('birth_setting') : "block",
                marriageSetting: localStorage.getItem('marriage_setting') ? localStorage.getItem('marriage_setting') : "block",
                deathSetting: localStorage.getItem('death_setting') ? localStorage.getItem('death_setting') : "block",
                flag_setting: localStorage.getItem('flag_setting') ? localStorage.getItem('flag_setting') : "SHOW",
                profile_setting: localStorage.getItem('profile_setting') ? localStorage.getItem('profile_setting') : "SHOW",
                warning_setting: localStorage.getItem('warning_setting') ? localStorage.getItem('warning_setting') : "SHOW",
                global_padding: localStorage.getItem('global_padding') ? localStorage.getItem('global_padding') : '5',
                type: localStorage.getItem("type"),
                id: localStorage.getItem("id"),
                papertype: localStorage.getItem("papertype"),
                direction: localStorage.getItem("direction"),
                saved: new Date(),
                maxGeneration: localStorage.getItem("maxGeneration"),
                tree_width: localStorage.getItem("tree_width"),
                tree_height: localStorage.getItem("tree_height"),
                gedcom_id: localStorage.getItem("gedcom_id"),
                gedcom_name: localStorage.getItem("gedcom_name"),
                background: localStorage.getItem("background")
            }
            this.designService.updateDesign(docid, doc).then((d) => {
                const dialogConfig = new MatDialogConfig();
                dialogConfig.disableClose = true;
                dialogConfig.id = "saveAs";
                dialogConfig.data = {
                    title: 'Information',
                    message: "Design saved",
                    delay: 5000
                }
                const modalDialog = this.matDialog.open(AlertComponent, dialogConfig);
            }, err => console.log(err))
        }
    }

    showtotal() {

        this.showLoader = true;
        const direction = localStorage.getItem("direction");
        this.selectTreeType(parseInt(direction));
    }

    reloadtree() {
        this.showLoader = true;
        window.location.reload();

        this.showLoader = false;
        // const direction = localStorage.getItem("direction");
        // this.selectTreeType(parseInt(direction));
        // if (this.bg) {
        //     setTimeout(() => {
        //         this.addbackground(this.bg)
        //     }, 2000)
        // }
    }

    openEditModal(d) {
        const dialogConfig = new MatDialogConfig();
        // The user can't close the dialog by clicking outside its body
        dialogConfig.disableClose = false;
        dialogConfig.id = "modal-component";
        if (d.depth > 3 && d.depth <= 6) dialogConfig.height = "90vh";
        else if (d.depth > 6 && d.depth <= 8) dialogConfig.height = "50vh";
        else if (d.depth > 8) dialogConfig.height = "20vh";
        else dialogConfig.height = "90vh";
        dialogConfig.width = "500px";
        dialogConfig.data = d

        const modalDialog = singleModal.open(ModalComponent, dialogConfig);
        modalDialog.afterClosed().subscribe((result) => {
            if (result) {
                document.getElementById('submit-setting').click();
                window.location.reload();
            }
        });
    };

    settingUpdate() {
        this.showLoader = true;
        manColor = localStorage.getItem('manColor') ? localStorage.getItem('manColor') : '#000';
        womanColor = localStorage.getItem('womanColor') ? localStorage.getItem('womanColor') : '#000';;
        borderColor = localStorage.getItem('borderColor') ? localStorage.getItem('borderColor') : '#000';
        maleNodeColor = localStorage.getItem('maleNodeColor') ? localStorage.getItem('maleNodeColor') : '#fff';
        femaleNodeColor = localStorage.getItem('femaleNodeColor') ? localStorage.getItem('femaleNodeColor') : '#fff';
        borderRadius = parseInt(localStorage.getItem('cornerRound') ? localStorage.getItem('cornerRound') : '50');
        borderWidth = parseInt(localStorage.getItem('borderWidth') ? localStorage.getItem('borderWidth') : '2');
        backOpacity = parseFloat(localStorage.getItem('backOpacity') ? localStorage.getItem('backOpacity') : '1');
        nodeOpacity = parseFloat(localStorage.getItem('nodeOpacity') ? localStorage.getItem('nodeOpacity') : '1');
        treeWidth = localStorage.getItem('tree_width') ? localStorage.getItem('tree_width') : 67408;
        treeHeight = localStorage.getItem('tree_height') ? localStorage.getItem('tree_height') : 47679;
        empty_node_setting = localStorage.getItem('empty_node_setting') ? localStorage.getItem('empty_node_setting') : "block";
        text_align = localStorage.getItem('text_align') ? localStorage.getItem('text_align') : "middle";
        name_text_align = localStorage.getItem('name_text_align') ? localStorage.getItem('name_text_align') : "middle";
        birthSetting = localStorage.getItem('birth_setting') ? localStorage.getItem('birth_setting') : "block";
        marriageSetting = localStorage.getItem('marriage_setting') ? localStorage.getItem('marriage_setting') : "block";
        deathSetting = localStorage.getItem('death_setting') ? localStorage.getItem('death_setting') : "block";
        flag_setting = localStorage.getItem('flag_setting') ? localStorage.getItem('flag_setting') : "SHOW";
        profile_setting = localStorage.getItem('profile_setting') ? localStorage.getItem('profile_setting') : "SHOW";
        warning_setting = localStorage.getItem('warning_setting') ? localStorage.getItem('warning_setting') : "SHOW";
        global_padding = localStorage.getItem('global_padding') ? localStorage.getItem('global_padding') : '5';

        this.m_Color = manColor
        this.w_Color = womanColor
        this.m_b_Color = maleNodeColor
        this.w_b_Color = femaleNodeColor
        this.b_Color = borderColor
        this.b_Width = borderWidth
        this.back_Opacity = backOpacity
        this.node_Opacity = nodeOpacity
        this.cornerRound = borderRadius
        this.empty_node = empty_node_setting == "block" ? "SHOW" : "HIDE"
        this.birthSetting = birthSetting == "block" ? "SHOW" : "HIDE"
        this.marriageSetting = marriageSetting == "block" ? "SHOW" : "HIDE"
        this.deathSetting = deathSetting == "block" ? "SHOW" : "HIDE"
        this.flag_setting = flag_setting
        this.profile_setting = profile_setting
        this.warning_setting = warning_setting
        this.global_padding = global_padding

        if (profile_setting == "SHOW") {
            imgSize = imgSizeGroup[papertype]
            textSize = textSizeGroup[papertype]
            flagSize = flagSizeGroup[papertype]
        } else {
            imgSize = [0, 0, 0, 0, 0, 0]
            textSize = textSizeGroup[papertype]
            flagSize = flagSizeGroup[papertype]
        }

        var nodeinfos: any;
        
        this.dbService.getByKey('nodes', 1).subscribe((nodes: any) => {
            nodeinfos = JSON.parse(nodes.nodeinfos)
        }, err => console.log(err));

        this.ApiService.getNodes(this.gedcom_id).then(data => {
            try {
                Object.values(data).forEach(element => {
                    nodeinfos[element['id']] = element
                });

                this.nodeinfos = nodeinfos
            } catch (error) {
                console.log(error);
            }

            let bornText = this.nodeBornText
            let marriedText = this.nodeMarriedText
            let deceasedText = this.nodeDeceasedText
            this.dbService.getByKey('nodes', 1).subscribe((nodes: any) => {
                this.coupleinfos = JSON.parse(nodes.coupleinfos)
    
            }, err => console.log(err));
            // this.coupleinfos = JSON.parse(localStorage.getItem('coupleinfos'));
            var direction = localStorage.getItem('direction') ? parseInt(localStorage.getItem('direction')) : 1;
            if (papertype != localStorage.getItem('papertype') || maxGeneration != parseInt(localStorage.getItem('maxGeneration'))) {
                papertype = localStorage.getItem('papertype') ? localStorage.getItem('papertype') : 'A0';
                this.p_type = papertype
                maxGeneration = parseInt(localStorage.getItem('maxGeneration') ? localStorage.getItem('maxGeneration') : '10');
                this.max_generation = maxGeneration
                this.selectTreeType(direction)
            } else {

                var nodes = d3
                    .select('body')
                    .select('svg')
                    .selectAll("g.person")

                var links = d3
                    .select('body')
                    .select('svg')
                    .selectAll("path.link")
                    .attr({
                        "display": function (d) {
                            if (d.target.id.substring(0, 5) == 'fake_') {
                                return empty_node_setting
                            } else {
                                return "block"
                            }
                        }
                    })

                nodes.selectAll('.avatar')
                    .attr({
                        'xlink:href': function (d) {
                            if (nodeinfos[d.id]) {
                                if (d.avatar_type == "sample" && typeof nodeinfos[d.id].url == 'number') {
                                    if (d.sex == 'M') {
                                        return maleAvatar[parseInt(nodeinfos[d.id].url)]
                                    } else {
                                        return femaleAvatar[parseInt(nodeinfos[d.id].url)]
                                    }
                                } else {
                                    d.url = nodeinfos[d.id].url;
                                    return nodeinfos[d.id].url;
                                }
                            } else {
                                if (typeof d.url == 'number') {
                                    if (d.sex == 'M') {
                                        return maleAvatar[parseInt(d.url)]
                                    } else {
                                        return femaleAvatar[parseInt(d.url)]
                                    }
                                } else {
                                    return d.url;
                                }
                            }
                        },
                        "display": function (d) {
                            if (nodeinfos[d.id]) d.country = nodeinfos[d.id].country
                            if (nodeinfos[d.id] && d.avatar_setting) d.avatar_setting = nodeinfos[d.id].avatar_setting
                            if (profile_setting != "SHOW") {
                                return "none"
                            }
                            else if (d.depth > 5) {
                                return "none"
                            }
                            else if (nodeinfos[d.id] && nodeinfos[d.id].avatar_setting != "SHOW") {
                                return "none"
                            }
                            else if (d.id.substring(0, 5) == 'fake_') {
                                return empty_node_setting
                            } else {
                                return "block"
                            }
                        },
                        'width': function (d) {
                            if (d.depth < 6) {
                                return imgSize[d.depth]
                            } else {
                                return 0
                            }
                        },
                        'height': function (d) {
                            if (d.depth < 6) {
                                return imgSize[d.depth]
                            } else {
                                return 0
                            }
                        },
                        "x": function (d) {
                            if (d.depth < 6) {
                                if (flag_setting != "SHOW" || d.country == "NoFlag" || d.depth > 5) {
                                    return -imgSize[d.depth] / 2
                                }
                                return -imgSize[d.depth] / 2 - flagSize[d.depth] / 2
                            } else {
                                return 0
                            }
                        },
                    }).each(function (d) {
                        d.warning = false;
                        d.height = this.getBBox().height
                        if (d.depth < 6) {
                            return d.width = this.getBBox().width + flagSize[d.depth] + 200
                        } else {
                            return d.width = this.getBBox().width
                        }
                    })

                nodes.selectAll('.wife .avatar')
                    .attr({
                        'xlink:href': function (d) {
                            if (nodeinfos[d.id]) {
                                if (d.avatar_type == "sample" && typeof nodeinfos[d.id].url == 'number') {
                                    if (d.sex == 'M') {
                                        return maleAvatar[parseInt(nodeinfos[d.id].url)]
                                    } else {
                                        return femaleAvatar[parseInt(nodeinfos[d.id].url)]
                                    }
                                } else {
                                    d.url = nodeinfos[d.id].url;
                                    return nodeinfos[d.id].url;
                                }
                            } else {
                                if (typeof d.url == 'number') {
                                    if (d.sex == 'M') {
                                        return maleAvatar[parseInt(d.url)]
                                    } else {
                                        return femaleAvatar[parseInt(d.url)]
                                    }
                                } else {
                                    return d.url;
                                }
                            }

                        },
                        "display": function (d) {
                            if (nodeinfos[d.id] && d.avatar_setting) d.avatar_setting = nodeinfos[d.id].avatar_setting
                            if (profile_setting != "SHOW") {
                                return "none"
                            }
                            else if (nodeinfos[d.id] && nodeinfos[d.id].avatar_setting != "SHOW") {
                                return "none"
                            }
                            else if (d.id.substring(0, 5) == 'fake_') {
                                return empty_node_setting
                            } else {
                                return "block"
                            }
                        },
                        'width': function (d) {
                            return imgSize[1]
                        },
                        'height': function (d) {
                            return imgSize[1]
                        },
                        "x": function (d) {
                            if (flag_setting != "SHOW" || d.country == "NoFlag") {
                                return -imgSize[1] / 2
                            }
                            return -imgSize[1] / 2 - flagSize[1] / 2
                        },
                    }).each(function (d) {
                        d.height = this.getBBox().height
                        return d.width = this.getBBox().width + flagSize[1] + 200
                    })

                nodes.selectAll('.child_1 .avatar')
                    .attr({
                        'xlink:href': function (d) {
                            if (nodeinfos[d.id]) {
                                if (d.avatar_type == "sample" && typeof nodeinfos[d.id].url == 'number') {
                                    if (d.sex == 'M') {
                                        return maleAvatar[parseInt(nodeinfos[d.id].url)]
                                    } else {
                                        return femaleAvatar[parseInt(nodeinfos[d.id].url)]
                                    }
                                } else {
                                    d.url = nodeinfos[d.id].url;
                                    return nodeinfos[d.id].url;
                                }
                            } else {
                                if (typeof d.url == 'number') {
                                    if (d.sex == 'M') {
                                        return maleAvatar[parseInt(d.url)]
                                    } else {
                                        return femaleAvatar[parseInt(d.url)]
                                    }
                                } else {
                                    return d.url;
                                }
                            }
                        },
                        "display": function (d) {
                            if (nodeinfos[d.id] && d.avatar_setting) d.avatar_setting = nodeinfos[d.id].avatar_setting
                            if (profile_setting != "SHOW") {
                                return "none"
                            }
                            else if (nodeinfos[d.id] && nodeinfos[d.id].avatar_setting != "SHOW") {
                                return "none"
                            }
                            else if (d.id.substring(0, 5) == 'fake_') {
                                return empty_node_setting
                            } else {
                                return "block"
                            }
                        },
                        'width': function (d) {
                            return imgSize[5]
                        },
                        'height': function (d) {
                            return imgSize[5]
                        },
                        "x": function (d) {
                            if (flag_setting != "SHOW" || d.country == "NoFlag") {
                                return -imgSize[5] / 2
                            }
                            return -imgSize[5] / 2 - flagSize[5] / 2
                        },
                    }).each(function (d) {
                        d.height = this.getBBox().height
                        return d.width = this.getBBox().width + flagSize[5] + 200
                    })

                nodes.selectAll('.child_2 .avatar')
                    .attr({
                        'xlink:href': function (d) {
                            if (nodeinfos[d.id]) {
                                if (d.avatar_type == "sample" && typeof nodeinfos[d.id].url == 'number') {
                                    if (d.sex == 'M') {
                                        return maleAvatar[parseInt(nodeinfos[d.id].url)]
                                    } else {
                                        return femaleAvatar[parseInt(nodeinfos[d.id].url)]
                                    }
                                } else {
                                    d.url = nodeinfos[d.id].url;
                                    return nodeinfos[d.id].url;
                                }
                            } else {
                                if (typeof d.url == 'number') {
                                    if (d.sex == 'M') {
                                        return maleAvatar[parseInt(d.url)]
                                    } else {
                                        return femaleAvatar[parseInt(d.url)]
                                    }
                                } else {
                                    return d.url;
                                }
                            }
                        },
                        "display": function (d) {
                            if (nodeinfos[d.id] && d.avatar_setting) d.avatar_setting = nodeinfos[d.id].avatar_setting
                            if (profile_setting != "SHOW") {
                                return "none"
                            }
                            else if (nodeinfos[d.id] && nodeinfos[d.id].avatar_setting != "SHOW") {
                                return "none"
                            }
                            else if (d.id.substring(0, 5) == 'fake_') {
                                return empty_node_setting
                            } else {
                                return "block"
                            }
                        },
                        'width': function (d) {
                            return imgSize[5]
                        },
                        'height': function (d) {
                            return imgSize[5]
                        },
                        "x": function (d) {
                            if (flag_setting != "SHOW" || d.country == "NoFlag") {
                                return -imgSize[5] / 2
                            }
                            return -imgSize[5] / 2 - flagSize[5] / 2
                        },
                    }).each(function (d) {
                        d.height = this.getBBox().height
                        return d.width = this.getBBox().width + flagSize[5] + 200
                    })

                nodes.selectAll('.flag')
                    .attr({
                        "display": function (d) {

                            if (flag_setting != "SHOW") {
                                return "none"
                            }
                            else if (d.country == "NoFlag") {
                                return "none"
                            }
                            else if (d.depth > 5) {
                                return "none"
                            }
                            else if (d.id.substring(0, 5) == 'fake_') {
                                return empty_node_setting
                            } else {
                                return "block"
                            }
                        },

                    }).each(function (d) {
                        if (profile_setting != "SHOW" || d.avatar_setting != "SHOW") {
                            d.height = this.getBBox().height
                        }
                    })

                nodes.selectAll('.name')
                    .attr({
                        'fill': function (d) {
                            if (d.sex == 'M') return manColor
                            else return womanColor
                        },
                        display: function (d) {
                            if (d.id.substring(0, 5) == 'fake_') {
                                return empty_node_setting
                            }
                            else return "block"
                        }
                    }).each(function (d) {
                        if (nodeinfos[d.id]) {
                            d.firstName = nodeinfos[d.id].firstName
                            d.lastName = nodeinfos[d.id].lastName
                        }
                        let font_size
                        if (d.depth <= 9) {
                            font_size = textSize[d.depth]
                        } else {
                            font_size = textSize[9]
                        }
                        let name = (d.firstName ? d.firstName : 'n/a') + " " + (d.lastName ? d.lastName : 'n/a')

                        if (name.includes('n/a')) {
                            d.warning = true;
                        }
                        if (d.type == 'wife') {
                            var length = Math.floor((treeHeight / maxGeneration + 800 * (maxGeneration / 2 - 2)) / textSize[1] * 1.5)
                            if (direction == 3 || direction == 4) {
                                length = Math.floor(treeHeight / 10 / font_size * 1.5)
                            }
                        } else if (d.type == 'child') {
                            var length = Math.floor((treeHeight / maxGeneration) / textSize[5] * 1.5)
                            if (direction == 3 || direction == 4) {
                                length = Math.floor(treeHeight / (22 + Math.max(0, children.length - 10)) / font_size * 1.5)
                            }
                        } else {
                            var length = Math.floor((node_width + 800 * ((maxGeneration / 2 - 1) - d.depth)) / font_size * 1.5)
                            if (d.depth >= 8) {
                                length = name.length + 2
                            }

                            if (direction == 3 || direction == 4) {
                                if (d.depth == 0) {
                                    length = Math.floor(treeHeight / maxGeneration / font_size * 2)
                                }
                                else if (d.depth <= 5) {
                                    length = Math.floor((treeWidth / Math.pow(2, d.depth)) / font_size * 1) + 2
                                } else {
                                    length = name.length + 2
                                }
                            }
                        }



                        var res_text = spliteText(name, length, 0);
                        d3.select(this).selectAll('tspan').remove()
                        for (let index = 0; index < res_text.length; index++) {
                            const element = res_text[index];
                            d3.select(this)
                                .append("tspan")
                                .text(function () {
                                    return element;
                                })
                                .attr({
                                    x: function () {
                                        if (index > 0) return 0
                                    },
                                    dy: function () {
                                        if (index > 0) return '1em'
                                    },
                                    'class': 'name_span',
                                })
                        }
                        if (d.width < this.getBBox().width) d.width = this.getBBox().width;
                        d.height = this.getBBox().height + d.height;
                        name_height[d.id + d.depth] = this.getBBox().height
                    })


                nodes.selectAll('.birth')
                    .attr({
                        'fill': function (d) {
                            if (d.sex == 'M') return manColor
                            else return womanColor
                        },
                        display: function (d) {
                            if (birthSetting == "none" || d.depth > 8) {
                                return "none"
                            }
                            else if (d.id.substring(0, 5) == 'fake_') {
                                return empty_node_setting
                            }
                            else return "block"
                        }
                    }).each(function (d) {
                        if (nodeinfos[d.id]) {
                            d.birth = nodeinfos[d.id].birth
                            d.birthday = nodeinfos[d.id].birthday
                        }
                        let place = (d.birth && d.birth.place) ? d.birth.place : "n/a";

                        let font_size
                        if (d.depth <= 9) {
                            font_size = textSize[d.depth]
                        } else {
                            font_size = textSize[9]
                        }
                        let birth_info = (d.birthday ? d.birthday : '-.-.-') + ", " + place

                        if (birthSetting != "none" && d.depth <= 8) {
                            if (birth_info.includes('n/a') || birth_info.includes('.-') || birth_info.includes('-.')) {
                                d.warning = true;
                            }
                        }

                        if (d.type == 'wife') {
                            var length = Math.floor((treeHeight / maxGeneration + 800 * (maxGeneration / 2 - 2)) / textSize[1] * 1.5)
                            if (direction == 3 || direction == 4) {
                                length = Math.floor(treeHeight / 10 / font_size * 1.5)
                            }
                        } else if (d.type == 'child') {
                            var length = Math.floor((treeHeight / maxGeneration) / textSize[5] * 1.5)
                            if (direction == 3 || direction == 4) {
                                length = Math.floor(treeHeight / (22 + Math.max(0, children.length - 10)) / font_size * 1.5)
                            }
                        } else {
                            var length = Math.floor((node_width + 800 * ((maxGeneration / 2 - 1) - d.depth)) / font_size * 1.5)
                            if (d.depth >= 8) {
                                length = birth_info.length + 2
                            }

                            if (direction == 3 || direction == 4) {
                                if (d.depth == 0) {
                                    length = Math.floor(treeHeight / maxGeneration / font_size * 2)
                                }
                                else if (d.depth <= 5) {
                                    length = Math.floor((treeWidth / Math.pow(2, d.depth)) / font_size * 1) + 2
                                } else {
                                    length = birth_info.length + 2
                                }
                            }
                        }



                        d3.select(this).selectAll('tspan').remove()


                        if ((localStorage.getItem('birth_hide_empty') === 'true') && birth_info === '-.-.-, n/a') {
                            console.log('empty')
                        } else {
                            if (d.depth < 6) {
                                d3.select(this)
                                    .append("tspan")
                                    .text(function () {
                                        return bornText;
                                    })
                                    .attr({
                                        'font-weight': "bold"
                                    })

                                var res_text = spliteText(birth_info, length, 6);
                                for (let index = 0; index < res_text.length; index++) {
                                    const element = res_text[index];
                                    d3.select(this)
                                        .append("tspan")
                                        .text(function () {
                                            return element;
                                        })
                                        .attr({
                                            x: function () {
                                                if (index > 0) return 0
                                            },
                                            dy: function () {
                                                if (index > 0) return '1em'
                                            },
                                            'class': function () {
                                                if (index == 0) return 'nextString'
                                            },
                                        })
                                }

                            } else {
                                d3.select(this)
                                    .append("tspan")
                                    .text(function () {
                                        return "" + bornText.slice(0, 1) + ": ";
                                    })
                                    .attr({
                                        'font-weight': "bold"
                                    })
                                d3.select(this)
                                    .append("tspan")
                                    .text(function () {
                                        return birth_info;
                                    })
                            }
                        }
                        if (birthSetting != "none" && d.depth <= 8) {
                            if (d.width < this.getBBox().width) d.width = this.getBBox().width;
                            if (d.depth <= 8) d.height = this.getBBox().height + d.height
                        }
                        birth_height[d.id + d.depth] = this.getBBox().height
                    })

                nodes.selectAll('.marriage')
                    .attr({
                        'fill': function (d) {
                            if (d.sex == 'M') return manColor
                            else return womanColor
                        },
                        display: function (d) {
                            if (marriageSetting == "none" || d.depth == 0 || d.depth > 6) {
                                return "none"
                            }
                            else if (d.id.substring(0, 5) == 'fake_') {
                                return empty_node_setting
                            }
                            else return "block"
                        }
                    }).each(function (d) {
                        if (d.depth != 0 && d.depth <= 6) {
                            if (nodeinfos[d.id]) {
                                d.marriage = nodeinfos[d.id].marriage
                            }
                            let marriage_day = getMarriageDay(d);
                            let marriage_place = d.c_fam && d.marriage[d.c_fam] && d.marriage[d.c_fam]['place'] ? d.marriage[d.c_fam]['place'] : "n/a";
                            let font_size
                            if (d.depth <= 9) {
                                font_size = textSize[d.depth]
                            } else {
                                font_size = textSize[9]
                            }
                            let marriage_info = (marriage_day ? marriage_day : '-.-.-') + ", " + marriage_place

                            if (marriageSetting != "none" && d.depth != 0 && d.depth <= 6) {
                                if (marriage_info.includes('n/a') || marriage_info.includes('.-') || marriage_info.includes('-.')) {
                                    d.warning = true;
                                }
                            }

                            let length = Math.floor((node_width + 800 * ((maxGeneration / 2 - 1) - d.depth)) / font_size * 1.5)

                            if (d.depth >= 8) {
                                length = marriage_info.length + 2
                            }

                            if (direction == 3 || direction == 4) {
                                if (d.depth <= 5) {
                                    length = Math.floor((treeWidth / Math.pow(2, d.depth)) / font_size * 1) + 2
                                } else {
                                    length = marriage_info.length + 2
                                }
                            }
                            d3.select(this).selectAll('tspan').remove()
                            // console.log(Object.keys(d.marriage))


                            if ((localStorage.getItem('marriage_hide_empty') === 'true') && marriage_info === '-.-.-, n/a') {
                                console.log('empty')
                            }
                            else {
                                if (d.depth < 6) {
                                    d3.select(this)
                                        .append("tspan")
                                        .text(function () {
                                            return marriedText;
                                        })
                                        .attr({
                                            'font-weight': "bold"
                                        })
                                    var res_text = spliteText(marriage_info, length, 9);
                                    for (let index = 0; index < res_text.length; index++) {
                                        const element = res_text[index];
                                        d3.select(this)
                                            .append("tspan")
                                            .text(function () {
                                                return element;
                                            })
                                            .attr({
                                                x: function () {
                                                    if (index > 0) return 0
                                                },
                                                dy: function () {
                                                    if (index > 0) return '1em'
                                                },
                                                'class': function () {
                                                    if (index == 0) return 'nextString'
                                                },
                                            })

                                    }
                                } else {
                                    d3.select(this)
                                        .append("tspan")
                                        .text(function () {
                                            return "" + marriedText.slice(0, 1) + ": ";
                                        })
                                        .attr({
                                            'font-weight': "bold"
                                        })
                                    var res_text = spliteText(marriage_info, length, 3);
                                    for (let index = 0; index < res_text.length; index++) {
                                        const element = res_text[index];
                                        d3.select(this)
                                            .append("tspan")
                                            .text(function () {
                                                return element;
                                            })
                                            .attr({
                                                x: function () {
                                                    if (index > 0) return 0
                                                },
                                                dy: function () {
                                                    if (index > 0) return '1em'
                                                },
                                                'class': function () {
                                                    if (index == 0) return 'nextString'
                                                },
                                            })

                                    }
                                }
                            }
                        }
                        if (marriageSetting != "none" && d.depth != 0 && d.depth <= 6) {
                            if (d.width < this.getBBox().width) d.width = this.getBBox().width;
                            if (d.depth != 0 && d.depth <= 6) d.height = this.getBBox().height + d.height
                        }
                        marriage_height[d.id + d.depth] = this.getBBox().height
                    })

                nodes.selectAll('.death')
                    .attr({
                        'fill': function (d) {
                            if (d.sex == 'M') return manColor
                            else return womanColor
                        },
                        display: function (d) {
                            if (deathSetting == "none" || d.depth > 8) {
                                return "none"
                            }
                            else if (d.id.substring(0, 5) == 'fake_') {
                                return empty_node_setting
                            }
                            else return "block"
                        }
                    }).each(function (d) {
                        if (nodeinfos[d.id]) {
                            d.death = nodeinfos[d.id].death
                            d.deathday = nodeinfos[d.id].deathday
                        }
                        let place = (d.death && d.death.place) ? d.death.place : "n/a";
                        let font_size
                        if (d.depth <= 9) {
                            font_size = textSize[d.depth]
                        } else {
                            font_size = textSize[9]
                        }
                        let death_info = (d.deathday ? d.deathday : '-.-.-') + ", " + place

                        if (deathSetting != "none" && d.depth <= 8) {
                            if (death_info.includes('n/a') || death_info.includes('.-') || death_info.includes('-.')) {
                                d.warning = true;
                            }
                        }

                        if (d.type == 'wife') {
                            var length = Math.floor((treeHeight / maxGeneration + 800 * (maxGeneration / 2 - 2)) / textSize[1] * 1.5)
                            if (direction == 3 || direction == 4) {
                                length = Math.floor(treeHeight / 10 / font_size * 1.5)
                            }
                        } else if (d.type == 'child') {
                            var length = Math.floor((treeHeight / maxGeneration) / textSize[5] * 1.5)
                            if (direction == 3 || direction == 4) {
                                length = Math.floor(treeHeight / (22 + Math.max(0, children.length - 10)) / font_size * 1.5)
                            }
                        } else {
                            var length = Math.floor((node_width + 800 * ((maxGeneration / 2 - 1) - d.depth)) / font_size * 1.5)

                            if (d.depth >= 8) {
                                length = death_info.length + 2
                            }

                            if (direction == 3 || direction == 4) {
                                if (d.depth == 0) {
                                    length = Math.floor(treeHeight / maxGeneration / font_size * 2)
                                }
                                else if (d.depth <= 5) {
                                    length = Math.floor((treeWidth / Math.pow(2, d.depth)) / font_size * 1) + 2
                                } else {
                                    length = death_info.length + 2
                                }
                            }
                        }

                        d3.select(this).selectAll('tspan').remove()
                        if ((localStorage.getItem('death_hide_empty') === 'true') && death_info === '-.-.-, n/a') {
                            console.log('empty')
                        }
                        else {
                            if (d.depth < 6) {
                                d3.select(this)
                                    .append("tspan")
                                    .text(function () {
                                        return deceasedText;
                                    })
                                    .attr({
                                        'font-weight': "bold"
                                    })
                                var res_text = spliteText(death_info, length, 9);
                                for (let index = 0; index < res_text.length; index++) {
                                    const element = res_text[index];
                                    d3.select(this)
                                        .append("tspan")
                                        .text(function () {
                                            return element;
                                        })
                                        .attr({
                                            x: function () {
                                                if (index > 0) return 0
                                            },
                                            dy: function () {
                                                if (index > 0) return '1em'
                                            },
                                            'class': function () {
                                                if (index == 0) return 'nextString'
                                            },
                                        })

                                }

                            } else {
                                d3.select(this)
                                    .append("tspan")
                                    .text(function () {
                                        return "" + deceasedText.slice(0, 1) + ": ";
                                    })
                                    .attr({
                                        'font-weight': "bold"
                                    })
                                d3.select(this)
                                    .append("tspan")
                                    .text(function () {
                                        return death_info;
                                    })
                            }
                        }
                        if (deathSetting != "none" && d.depth <= 8) {
                            if (d.width < this.getBBox().width) d.width = this.getBBox().width;
                            if (d.depth <= 8) d.height = this.getBBox().height + d.height
                        }
                        death_height[d.id + d.depth] = this.getBBox().height
                    })

                nodes.selectAll('.note')
                    .attr({
                        'fill': function (d) {
                            if (d.sex == 'M') return manColor
                            else return womanColor
                        },
                        "display": function (d) {
                            if (nodeinfos[d.id]) {
                                d.note = nodeinfos[d.id].note
                            }
                            if (d.note == "") return 'none'
                            else {
                                return 'block'
                            }
                        },
                    }).each(function (d) {
                        let note = d.note;
                        let font_size
                        if (d.depth < 9) {
                            font_size = textSize[d.depth] / 2
                        } else {
                            font_size = textSize[9] / 2
                        }

                        if (d.depth == 0) {
                            length = Math.floor((node_width + 400 * ((maxGeneration / 2 - 1) - d.depth)) / font_size * 1.5) * 1.6
                        } else if (d.depth >= 8) {
                            length = 70
                        } else {
                            if (d.type == 'wife') {
                                var length = Math.floor((treeHeight / maxGeneration + 400 * (maxGeneration / 2 - 2)) / font_size * 1.5)
                            } else if (d.type == 'child') {
                                var length = Math.floor((treeHeight / maxGeneration) / font_size * 1.5)
                            } else {
                                var length = Math.floor((node_width + 400 * ((maxGeneration / 2 - 1) - d.depth)) / font_size * 1.5)
                            }
                        }
                        var res_text = [""]
                        if (note != "" && note != null) {
                            res_text = spliteText(note, length, 1);
                        }
                        d3.select(this).selectAll('tspan').remove()
                        for (let index = 0; index < res_text.length; index++) {
                            const element = res_text[index];
                            d3.select(this)
                                .append("tspan")
                                .text(function () {
                                    return element;
                                })
                                .attr({
                                    x: function () {
                                        return 0
                                    },
                                    dy: function () {
                                        if (index > 0) return '1em'
                                    },
                                })

                        }
                        if (d.note != "") {
                            if (d.width < this.getBBox().width) d.width = this.getBBox().width;
                            d.height = this.getBBox().height + d.height
                            note_height[d.id] = this.getBBox().height
                        } else {
                            note_height[d.id] = 0
                        }
                    })

                nodes.selectAll(".avatar").attr({
                    y: function (d) {
                        if (direction == 5 && d.depth == 0 && d.type != 'wife' && d.type != 'child') return (-1) * d.height / 2 - (imgSize[0] + 5 * textSize[0])
                        return (-1) * d.height / 2
                    },
                    // opacity: nodeOpacity,
                })

                nodes.selectAll(".flag").attr({
                    'xlink:href': function (d) {
                        if (!d.country || d.country == "") {
                            return Flags.flags['Sweden']
                        } else if (d.country == "NoFlag") {
                            return Flags.flags['Sweden']
                        }
                        else if (d.country == "custom") {
                            return d.c_flag
                        }
                        else {
                            return Flags.flags[d.country]
                        }
                    },
                    'width': function (d) {
                        if (d.depth < 6) {
                            return flagSize[d.depth]
                        } else {
                            return 0
                        }
                    },
                    'height': function (d) {
                        if (d.depth < 6) {
                            return flagSize[d.depth]
                        } else {
                            return 0
                        }
                    },
                    y: function (d) {
                        if (direction == 5 && d.depth == 0 && d.type != 'wife' && d.type != 'child') return (-1) * d.height / 2 - (imgSize[0] + 5 * textSize[0])
                        return (-1) * d.height / 2
                    },
                    "x": function (d) {
                        if (d.depth < 6) {
                            if (d.avatar_setting != "SHOW") return -flagSize[d.depth] / 2
                            return imgSize[d.depth] / 2 - flagSize[d.depth] / 2 + 100
                        } else {
                            return 0
                        }
                    },
                    // opacity: nodeOpacity,
                })

                nodes.selectAll(".wife .flag").attr({
                    'width': function (d) {
                        return flagSize[1]
                    },
                    'height': function (d) {
                        return flagSize[1]
                    },
                    y: function (d) {
                        return (-1) * d.height / 2
                    },
                    x: function (d) {
                        if (flag_setting != "SHOW" || d.country == "NoFlag" || d.depth > 5) {
                            return -imgSize[1] / 2
                        }
                        return imgSize[1] / 2 - flagSize[1] / 2
                    },
                    // opacity: nodeOpacity,
                })

                nodes.selectAll(".child_1 .flag").attr({
                    'width': function (d) {
                        return flagSize[5]
                    },
                    'height': function (d) {
                        return flagSize[5]
                    },
                    y: function (d) {
                        return (-1) * d.height / 2
                    },
                    x: function (d) {
                        if (flag_setting != "SHOW" || d.country == "NoFlag" || d.depth > 5) {
                            return -imgSize[5] / 2
                        }
                        return imgSize[5] / 2 - flagSize[5] / 2
                    },
                    // opacity: nodeOpacity,
                })

                nodes.selectAll(".child_2 .flag").attr({
                    'width': function (d) {
                        return flagSize[5]
                    },
                    'height': function (d) {
                        return flagSize[5]
                    },
                    y: function (d) {
                        return (-1) * d.height / 2
                    },
                    x: function (d) {
                        if (flag_setting != "SHOW" || d.country == "NoFlag" || d.depth > 5) {
                            return -imgSize[5] / 2
                        }
                        return imgSize[5] / 2 - flagSize[5] / 2
                    },
                    // opacity: nodeOpacity,
                })

                nodes.selectAll("tspan").attr({
                    dx: function (d) {
                        switch (text_align) {
                            case 'middle':
                                return 0;
                            case 'start':
                                return (-1) * d.width / 2;
                            default:
                                return d.width / 2;
                        }
                    },
                    "text-anchor": text_align,
                    // opacity: nodeOpacity,
                })

                nodes.selectAll(".name_span").attr({
                    dx: function (d) {
                        switch (name_text_align) {
                            case 'middle':
                                return 0;
                            case 'start':
                                return (-1) * d.width / 2;
                            default:
                                return d.width / 2;
                        }
                    },
                    "text-anchor": name_text_align
                })

                nodes.selectAll(".nextString").attr({
                    dx: 0
                })

                nodes.selectAll(".name").attr({
                    dy: function (d) {
                        if (direction == 5 && d.depth == 0 && d.type != 'wife' && d.type != 'child') {
                            if (d.avatar_setting != "SHOW") {
                                return (-1) * d.height / 2 + textSize[0] - (imgSize[0] + 5 * textSize[0])
                            }
                            return (-1) * d.height / 2 + imgSize[0] + textSize[0] - (imgSize[0] + 5 * textSize[0])
                        } else if (d.depth < 6) {
                            if (d.avatar_setting != "SHOW" || profile_setting != "SHOW") {
                                if (flag_setting != "SHOW" || d.country == "NoFlag") {
                                    return (-1) * d.height / 2 + textSize[d.depth]
                                } else {
                                    return (-1) * d.height / 2 + flagSize[d.depth] + textSize[d.depth]
                                }
                            } else {
                                return (-1) * d.height / 2 + imgSize[d.depth] + textSize[d.depth]
                            }
                        } else if (d.depth <= 9) {
                            return (-1) * d.height / 2 + textSize[d.depth]
                        } else {
                            return (-1) * d.height / 2 + textSize[9]
                        }
                    },
                })

                nodes.selectAll(".birth").attr({
                    dy: function (d) {
                        if (direction == 5 && d.depth == 0 && d.type != 'wife' && d.type != 'child') {
                            if (d.avatar_setting != "SHOW") {
                                return (-1) * d.height / 2 + textSize[d.depth] + name_height[d.id + d.depth] - (imgSize[0] + 5 * textSize[0])
                            }
                            if ((profile_setting != "SHOW" || d.avatar_setting != "SHOW") && flag_setting == "SHOW") return (-1) * d.height / 2 + flagSize[d.depth] + textSize[d.depth] + name_height[d.id + d.depth] - (imgSize[0] + 5 * textSize[0])
                            return (-1) * d.height / 2 + imgSize[d.depth] + textSize[d.depth] + name_height[d.id + d.depth] - (imgSize[0] + 5 * textSize[0])
                        } else if (d.depth < 6) {
                            if (d.avatar_setting != "SHOW" || profile_setting != "SHOW") {
                                if (flag_setting != "SHOW" || d.country == "NoFlag") {
                                    return (-1) * d.height / 2 + textSize[d.depth] + name_height[d.id + d.depth]
                                } else {
                                    return (-1) * d.height / 2 + flagSize[d.depth] + textSize[d.depth] + name_height[d.id + d.depth]
                                }
                            } else {
                                return (-1) * d.height / 2 + imgSize[d.depth] + textSize[d.depth] + name_height[d.id + d.depth]
                            }
                        } else if (d.depth <= 9) {
                            return (-1) * d.height / 2 + textSize[d.depth] + name_height[d.id + d.depth]
                        } else {
                            return (-1) * d.height / 2 + textSize[9] + name_height[d.id + d.depth]
                        }
                    },

                })

                nodes.selectAll(".marriage").attr({
                    dy: function (d) {
                        if (birthSetting == 'none') {
                            if (d.depth < 6) {
                                if (d.avatar_setting != "SHOW" || profile_setting != "SHOW") {
                                    if (flag_setting != "SHOW" || d.country == "NoFlag") {
                                        return (-1) * d.height / 2 + textSize[d.depth] + name_height[d.id + d.depth]
                                    } else {
                                        return (-1) * d.height / 2 + flagSize[d.depth] + textSize[d.depth] + name_height[d.id + d.depth]
                                    }
                                } else {
                                    return (-1) * d.height / 2 + imgSize[d.depth] + textSize[d.depth] + name_height[d.id + d.depth]
                                }
                            } else if (d.depth <= 9) {
                                return (-1) * d.height / 2 + textSize[d.depth] + name_height[d.id + d.depth]
                            } else {
                                return (-1) * d.height / 2 + textSize[9] + name_height[d.id + d.depth]
                            }

                        } else {
                            if (d.depth < 6) {
                                if (d.avatar_setting != "SHOW" || profile_setting != "SHOW") {
                                    if (flag_setting != "SHOW" || d.country == "NoFlag") {
                                        return (-1) * d.height / 2 + textSize[d.depth] + name_height[d.id + d.depth] + birth_height[d.id + d.depth]
                                    } else {
                                        return (-1) * d.height / 2 + flagSize[d.depth] + textSize[d.depth] + name_height[d.id + d.depth] + birth_height[d.id + d.depth]
                                    }
                                } else {
                                    return (-1) * d.height / 2 + imgSize[d.depth] + textSize[d.depth] + name_height[d.id + d.depth] + birth_height[d.id + d.depth]
                                }
                            } else if (d.depth <= 9) {
                                return (-1) * d.height / 2 + textSize[d.depth] + name_height[d.id + d.depth] + birth_height[d.id + d.depth]
                            } else {
                                return (-1) * d.height / 2 + textSize[9] + name_height[d.id + d.depth] + birth_height[d.id + d.depth]
                            }
                        }

                    },

                })

                nodes.selectAll(".death").attr({
                    dy: function (d) {

                        var temp = 0
                        if (direction == 5 && d.depth == 0 && d.type != 'wife' && d.type != 'child') {
                            if (d.avatar_setting != "SHOW") {
                                if (flag_setting == "SHOW") {
                                    temp = flagSize[d.depth] + textSize[d.depth] + name_height[d.id + d.depth] - (imgSize[0] + 5 * textSize[0])
                                } else {
                                    temp = textSize[d.depth] + name_height[d.id + d.depth] - (imgSize[0] + 5 * textSize[0])
                                }
                            } else if (profile_setting != "SHOW" && flag_setting == "SHOW") {
                                temp = flagSize[d.depth] + textSize[d.depth] + name_height[d.id + d.depth] - (imgSize[0] + 5 * textSize[0])
                            } else {
                                temp = imgSize[d.depth] + textSize[d.depth] + name_height[d.id + d.depth] - (imgSize[0] + 5 * textSize[0])
                            }
                        } else if (d.depth < 6) {
                            if (d.avatar_setting != "SHOW" || profile_setting != "SHOW") {
                                if (flag_setting == "SHOW" && d.country != "NoFlag") {
                                    temp = flagSize[d.depth] + textSize[d.depth] + name_height[d.id + d.depth]
                                } else {
                                    temp = textSize[d.depth] + name_height[d.id + d.depth]
                                }
                            } else {
                                temp = imgSize[d.depth] + textSize[d.depth] + name_height[d.id + d.depth]
                            }
                        } else if (d.depth <= 9) {
                            temp = textSize[d.depth] + name_height[d.id + d.depth]
                        } else {
                            temp = textSize[9] + name_height[d.id + d.depth]
                        }

                        if (birthSetting != 'none') {
                            temp += birth_height[d.id + d.depth]
                        }
                        if (marriageSetting != 'none') {
                            if (d.depth > 0 && d.depth < 7 && marriage_height[d.id + d.depth]) {
                                temp += marriage_height[d.id + d.depth]
                            }
                        }

                        return (-1) * d.height / 2 + temp
                    },

                })

                nodes.selectAll(".note").attr({
                    dy: function (d) {
                        var temp = 0
                        if (direction == 5 && d.depth == 0 && d.type != 'wife' && d.type != 'child') {
                            if (d.avatar_setting != "SHOW") {
                                if (flag_setting == "SHOW") {
                                    temp = flagSize[d.depth] + textSize[d.depth] / 2 + name_height[d.id + d.depth] - (imgSize[0] + 5 * textSize[0])
                                } else {
                                    temp = textSize[d.depth] / 2 + name_height[d.id + d.depth] - (imgSize[0] + 5 * textSize[0])
                                }
                            } else if (profile_setting != "SHOW" && flag_setting == "SHOW") {
                                temp = flagSize[d.depth] + textSize[d.depth] / 2 + name_height[d.id + d.depth] - (imgSize[0] + 5 * textSize[0])
                            } else {
                                temp = imgSize[d.depth] + textSize[d.depth] / 2 + name_height[d.id + d.depth] - (imgSize[0] + 5 * textSize[0])
                            }

                        } else if (d.depth < 6) {
                            if (d.avatar_setting != "SHOW" || profile_setting != "SHOW") {
                                if (flag_setting == "SHOW" && d.country != "NoFlag") {
                                    temp = flagSize[d.depth] + textSize[d.depth] / 2 + name_height[d.id + d.depth]
                                } else {
                                    temp = textSize[d.depth] / 2 + name_height[d.id + d.depth]
                                }
                            } else {
                                temp = imgSize[d.depth] + textSize[d.depth] / 2 + name_height[d.id + d.depth]
                            }
                        } else if (d.depth <= 9) {
                            temp = textSize[d.depth] / 2 + name_height[d.id + d.depth]
                        } else {
                            temp = textSize[9] / 2 + name_height[d.id + d.depth]
                        }

                        if (birthSetting != 'none' && d.depth < 9) {
                            temp += birth_height[d.id + d.depth]
                        }
                        if (marriageSetting != 'none') {
                            if (d.depth > 0 && d.depth < 7 && marriage_height[d.id + d.depth]) {
                                temp += marriage_height[d.id + d.depth]
                            }
                        }
                        if (deathSetting != 'none' && d.depth < 9) {
                            temp += death_height[d.id + d.depth]
                        }

                        return (-1) * d.height / 2 + temp
                    },
                })

                nodes.selectAll(".note .etc").attr({
                    dy: function (d) {
                        return (-1) * d.height / 2 + textSize[1] / 2
                    },
                })

                var partner_setting = localStorage.getItem('partner_setting') ? localStorage.getItem('partner_setting') : "SHOW";
                var children_setting = localStorage.getItem('children_setting') ? localStorage.getItem('children_setting') : "SHOW";

                if (partner_setting == this.partner_setting) {
                    nodes.selectAll(".wife .name").attr({
                        dy: function (d) {
                            if (d.avatar_setting != "SHOW") {
                                return (-1) * d.height / 2 + textSize[1]
                            }
                            if ((profile_setting != "SHOW" || d.avatar_setting != "SHOW") && flag_setting == "SHOW") return (-1) * d.height / 2 + flagSize[1] + textSize[1]
                            return (-1) * d.height / 2 + imgSize[1] + textSize[1]
                        },
                    })

                    nodes.selectAll(".wife .birth").attr({
                        dy: function (d) {
                            if (d.avatar_setting != "SHOW") {
                                return (-1) * d.height / 2 + textSize[1] + name_height[d.id + d.depth]
                            }
                            if ((profile_setting != "SHOW" || d.avatar_setting != "SHOW") && flag_setting == "SHOW") return (-1) * d.height / 2 + flagSize[1] + textSize[1] + name_height[d.id + d.depth]
                            return (-1) * d.height / 2 + imgSize[1] + textSize[1] + name_height[d.id + d.depth]
                        },

                    })

                    nodes.selectAll(".wife .death").attr({
                        dy: function (d) {
                            var temp = 0
                            if (d.avatar_setting != "SHOW") {
                                if (flag_setting == "SHOW") {
                                    temp = flagSize[1] + textSize[1] + name_height[d.id + d.depth]
                                } else {
                                    temp = textSize[1] + name_height[d.id + d.depth]
                                }
                            } else if (profile_setting != "SHOW" && flag_setting == "SHOW") {
                                temp = flagSize[1] + textSize[1] + name_height[d.id + d.depth]
                            } else {
                                temp = imgSize[1] + textSize[1] + name_height[d.id + d.depth]
                            }
                            if (birthSetting != 'none') {
                                temp += birth_height[d.id + d.depth]
                            }
                            return (-1) * d.height / 2 + temp
                        },
                    })

                    nodes.selectAll(".wife .note").attr({
                        dy: function (d) {
                            var temp = 0
                            if (d.avatar_setting != "SHOW") {
                                if (flag_setting == "SHOW") {
                                    temp = flagSize[1] + textSize[1] / 2 + name_height[d.id + d.depth]
                                } else {
                                    temp = textSize[1] / 2 + name_height[d.id + d.depth]
                                }
                            } else if (profile_setting != "SHOW" && flag_setting == "SHOW") {
                                temp = flagSize[1] + textSize[1] / 2 + name_height[d.id + d.depth]
                            } else {
                                temp = imgSize[1] + textSize[1] / 2 + name_height[d.id + d.depth]
                            }

                            if (birthSetting != 'none') {
                                temp += birth_height[d.id + d.depth]
                            }

                            if (deathSetting != 'none') {
                                temp += death_height[d.id + d.depth]
                            }

                            return (-1) * d.height / 2 + temp
                        },
                    })
                } else if (partner_setting == "SHOW") {
                    this.addwife();
                    d3.selectAll(".child_1").remove()
                    d3.selectAll(".child_2").remove()
                    this.addchildren();
                } else {
                    d3.selectAll(".wife").remove()
                    d3.selectAll(".child_1").remove()
                    d3.selectAll(".child_2").remove()
                    this.addchildren();
                }

                if (children_setting == this.children_setting) {
                    nodes.selectAll(".child_2 .name").attr({
                        dy: function (d) {
                            if (d.avatar_setting != "SHOW") {
                                return (-1) * d.height / 2 + textSize[5]
                            }
                            if ((profile_setting != "SHOW" || d.avatar_setting != "SHOW") && flag_setting == "SHOW") return (-1) * d.height / 2 + flagSize[5] + textSize[5]
                            return (-1) * d.height / 2 + imgSize[5] + textSize[5]
                        },
                    })

                    nodes.selectAll(".child_2 .birth").attr({
                        dy: function (d) {
                            if (d.avatar_setting != "SHOW") {
                                return (-1) * d.height / 2 + textSize[5] + name_height[d.id + d.depth]
                            }
                            if ((profile_setting != "SHOW" || d.avatar_setting != "SHOW") && flag_setting == "SHOW") return (-1) * d.height / 2 + flagSize[5] + textSize[5] + name_height[d.id + d.depth]
                            return (-1) * d.height / 2 + imgSize[5] + textSize[5] + name_height[d.id + d.depth]
                        },

                    })

                    nodes.selectAll(".child_2 .death").attr({
                        dy: function (d) {
                            var temp = 0
                            if (d.avatar_setting != "SHOW") {
                                if (flag_setting == "SHOW") {
                                    temp = flagSize[5] + textSize[5] + name_height[d.id + d.depth]
                                } else {
                                    temp = textSize[5] + name_height[d.id + d.depth]
                                }
                            } else if (profile_setting != "SHOW" && flag_setting == "SHOW") {
                                temp = flagSize[5] + textSize[5] + name_height[d.id + d.depth]
                            } else {
                                temp = imgSize[5] + textSize[5] + name_height[d.id + d.depth]
                            }
                            if (birthSetting != 'none') {
                                temp += birth_height[d.id + d.depth]
                            }
                            return (-1) * d.height / 2 + temp
                        },
                    })

                    nodes.selectAll(".child_2 .note").attr({
                        dy: function (d) {
                            var temp = 0
                            if (d.avatar_setting != "SHOW") {
                                if (flag_setting == "SHOW") {
                                    temp = flagSize[5] + textSize[5] / 2 + name_height[d.id + d.depth]
                                } else {
                                    temp = textSize[5] / 2 + name_height[d.id + d.depth]
                                }
                            } else if (profile_setting != "SHOW" && flag_setting == "SHOW") {
                                temp = flagSize[5] + textSize[5] / 2 + name_height[d.id + d.depth]
                            } else {
                                temp = imgSize[5] + textSize[5] / 2 + name_height[d.id + d.depth]
                            }

                            if (birthSetting != 'none') {
                                temp += birth_height[d.id + d.depth]
                            }

                            if (deathSetting != 'none') {
                                temp += death_height[d.id + d.depth]
                            }

                            return (-1) * d.height / 2 + temp
                        },
                    })

                    nodes.selectAll(".child_1 .name").attr({
                        dy: function (d) {
                            if (d.avatar_setting != "SHOW") {
                                return (-1) * d.height / 2 + textSize[5]
                            }
                            if ((profile_setting != "SHOW" || d.avatar_setting != "SHOW") && flag_setting == "SHOW") return (-1) * d.height / 2 + flagSize[5] + textSize[5]
                            return (-1) * d.height / 2 + imgSize[5] + textSize[5]
                        },
                    })

                    nodes.selectAll(".child_1 .birth").attr({
                        dy: function (d) {
                            if (d.avatar_setting != "SHOW") {
                                return (-1) * d.height / 2 + textSize[5] + name_height[d.id + d.depth]
                            }
                            if ((profile_setting != "SHOW" || d.avatar_setting != "SHOW") && flag_setting == "SHOW") return (-1) * d.height / 2 + flagSize[5] + textSize[5] + name_height[d.id + d.depth]
                            return (-1) * d.height / 2 + imgSize[5] + textSize[5] + name_height[d.id + d.depth]
                        },

                    })

                    nodes.selectAll(".child_1 .death").attr({
                        dy: function (d) {
                            var temp = 0
                            if (d.avatar_setting != "SHOW") {
                                if (flag_setting == "SHOW") {
                                    temp = flagSize[5] + textSize[5] + name_height[d.id + d.depth]
                                } else {
                                    temp = textSize[5] + name_height[d.id + d.depth]
                                }
                            } else if (profile_setting != "SHOW" && flag_setting == "SHOW") {
                                temp = flagSize[5] + textSize[5] + name_height[d.id + d.depth]
                            } else {
                                temp = imgSize[5] + textSize[5] + name_height[d.id + d.depth]
                            }
                            if (birthSetting != 'none') {
                                temp += birth_height[d.id + d.depth]
                            }
                            return (-1) * d.height / 2 + temp
                        },
                    })

                    nodes.selectAll(".child_1 .note").attr({
                        dy: function (d) {
                            var temp = 0
                            if (d.avatar_setting != "SHOW") {
                                if (flag_setting == "SHOW") {
                                    temp = flagSize[5] + textSize[5] / 2 + name_height[d.id + d.depth]
                                } else {
                                    temp = textSize[5] / 2 + name_height[d.id + d.depth]
                                }
                            } else if (profile_setting != "SHOW" && flag_setting == "SHOW") {
                                temp = flagSize[5] + textSize[5] / 2 + name_height[d.id + d.depth]
                            } else {
                                temp = imgSize[5] + textSize[5] / 2 + name_height[d.id + d.depth]
                            }

                            if (birthSetting != 'none') {
                                temp += birth_height[d.id + d.depth]
                            }

                            if (deathSetting != 'none') {
                                temp += death_height[d.id + d.depth]
                            }

                            return (-1) * d.height / 2 + temp
                        },
                    })
                } else if (children_setting == "SHOW") {
                    this.addchildren();
                } else {
                    d3.selectAll(".child_1").remove()
                    d3.selectAll(".child_2").remove()
                }

                this.partner_setting = partner_setting
                this.children_setting = children_setting

                nodes
                    .select("rect")
                    .attr({
                        x: function (d) {
                            return -(d.width * 1.1 + 20) / 2;
                        },
                        fill: function (d) {
                            if (d.sex == 'M') return maleNodeColor
                            else return femaleNodeColor
                        },
                        y: function (d) {
                            if (direction == 5 && d.depth == 0 && d.type != 'wife' && d.type != 'child') return -(d.height + 20) / 2 - (imgSize[0] + 5 * textSize[0])
                            return -(d.height + 20) / 2;
                        },
                        width: function (d) {
                            return d.width * 1.1 + 20;
                        },
                        height: function (d) {
                            return d.height + 20;
                        },
                        "transform": function (d) {
                            if (d.depth > 5 && (direction == 3 || direction == 4)) {
                                return "rotate(90)"
                            }
                        },
                        stroke: function (d) {
                            return borderColor
                        },
                        // display: function (d) {
                        //     if (d.id.substring(0, 5) == 'fake_') {
                        //         return empty_node_setting
                        //     }
                        // },
                        rx: function (d) {
                            return borderRadius;
                        },
                        "fill-opacity": function (d) {
                            if (d.id.substring(0, 5) == 'fake_' && empty_node_setting == 'none') {
                                return 0
                            }
                        },
                        "stroke-width": function (d) {
                            return borderWidth;
                        }
                    })

                nodes
                    .selectAll('.warning')
                    .attr({
                        "x": function (d) {
                            if (d.depth > 5) return -(d.width * 1.1 + 20) / 2 - imgSize[5] / d.depth / 2
                            return -(d.width * 1.1 + 20) / 2 - imgSize[d.depth] / 4;
                        },
                        y: function (d) {
                            return (direction == 5 && d.depth == 0) ? -(d.height + 20) / 2 - (imgSize[0] + 5 * textSize[0]) : -(d.height + 20) / 2;
                        },
                        "display": function (d) {
                            if (d.warning && warning_setting == "SHOW") {
                                if (d.id.substring(0, 5) == 'fake_') {
                                    return empty_node_setting
                                }
                                return 'block';
                            } else {
                                return 'none';
                            }
                        },
                        "transform": function (d) {
                            if (d.depth > 5 && (direction == 3 || direction == 4)) {
                                return "rotate(90)"
                            }
                        },
                    })
                nodes
                    .selectAll('.child_1 .warning')
                    .attr({
                        "x": function (d) {
                            return -(d.width * 1.1 + 20) / 2 - imgSize[5] / 4;
                        },
                        y: function (d) {
                            return -(d.height + 20) / 2;
                        },
                        "display": function (d) {
                            if (d.warning && warning_setting == "SHOW") {
                                if (d.id.substring(0, 5) == 'fake_') {
                                    return empty_node_setting
                                }
                                return 'block';
                            } else {
                                return 'none';
                            }
                        },
                        "transform": function (d) {
                            if (d.depth > 5 && (direction == 3 || direction == 4)) {
                                return "rotate(90)"
                            }
                        },
                    })

                nodes
                    .selectAll('.child_2 .warning')
                    .attr({
                        "x": function (d) {
                            return -(d.width * 1.1 + 20) / 2 - imgSize[5] / 4;
                        },
                        y: function (d) {
                            return -(d.height + 20) / 2;
                        },
                        "display": function (d) {
                            if (d.warning && warning_setting == "SHOW") {
                                if (d.id.substring(0, 5) == 'fake_') {
                                    return empty_node_setting
                                }
                                return 'block';
                            } else {
                                return 'none';
                            }
                        },
                        "transform": function (d) {
                            if (d.depth > 5 && (direction == 3 || direction == 4)) {
                                return "rotate(90)"
                            }
                        },
                    })

                nodes
                    .selectAll('.wife .warning')
                    .attr({
                        "x": function (d) {
                            return -(d.width * 1.1 + 20) / 2 - imgSize[1] / 4;
                        },
                        y: function (d) {
                            return -(d.height + 20) / 2;
                        },
                        "display": function (d) {
                            if (d.warning && warning_setting == "SHOW") {
                                if (d.id.substring(0, 5) == 'fake_') {
                                    return empty_node_setting
                                }
                                return 'block';
                            } else {
                                return 'none';
                            }
                        },
                        "transform": function (d) {
                            if (d.depth > 5 && (direction == 3 || direction == 4)) {
                                return "rotate(90)"
                            }
                        },
                    })
            }
            this.showLoader = false;
            console.log('Loader off')
        })
    }

    selectBackground() {
        const dialogConfig = new MatDialogConfig();
        // The user can't close the dialog by clicking outside its body
        dialogConfig.disableClose = false;
        dialogConfig.id = "select-background-component";
        dialogConfig.maxHeight = "90vh";
        dialogConfig.data = localStorage.getItem('direction')

        const modalDialog = singleModal.open(SelectBackgroundComponent, dialogConfig);
        modalDialog.afterClosed().subscribe((result) => {
            if (result) {
                this.addbackground(result)
            }
        });
    }

    checkWarning() {
        let warningData = []
        let nodeData
        this.dbService.getByKey('nodes', 1).subscribe((nodes: any) => {
            nodeData = JSON.parse(nodes.nodeinfos)
            console.log(nodeData)
       
            Object.values(nodeData).forEach(element => {
                if (element['mainDisplay'] && element['warning']) {
                    warningData.push(element)
                }
            });

            if (warningData.length) {
                const dialogConfig = new MatDialogConfig();
                // The user can't close the dialog by clicking outside its body
                dialogConfig.disableClose = false;
                dialogConfig.height = "500px";
                dialogConfig.width = "700px";
                dialogConfig.id = "checkwarning-component";
                dialogConfig.data = warningData;
                const modalDialog = singleModal.open(CheckwarningComponent, dialogConfig);
                modalDialog.afterClosed().subscribe((result) => {
                    if (result) {
                        this.orderPrint()
                    } else {
                        this.reloadtree()
                    }
                });

            } else {
                this.orderPrint()
            }
        }, err => console.log(err));
    }

    orderPrint() {


        const doc = {
            manColor: localStorage.getItem('manColor') ? localStorage.getItem('manColor') : '#000',
            docid: localStorage.getItem('doc_id'),
            womanColor: localStorage.getItem('womanColor') ? localStorage.getItem('womanColor') : '#000',
            borderColor: localStorage.getItem('borderColor') ? localStorage.getItem('borderColor') : '#000',
            maleNodeColor: localStorage.getItem('maleNodeColor') ? localStorage.getItem('maleNodeColor') : '#fff',
            femaleNodeColor: localStorage.getItem('femaleNodeColor') ? localStorage.getItem('femaleNodeColor') : '#fff',
            borderRadius: parseInt(localStorage.getItem('cornerRound') ? localStorage.getItem('cornerRound') : '50'),
            borderWidth: parseInt(localStorage.getItem('borderWidth') ? localStorage.getItem('borderWidth') : '2'),
            backOpacity: parseFloat(localStorage.getItem('backOpacity') ? localStorage.getItem('backOpacity') : '1'),
            nodeOpacity: parseFloat(localStorage.getItem('nodeOpacity') ? localStorage.getItem('nodeOpacity') : '1'),
            treeWidth: localStorage.getItem('tree_width') ? localStorage.getItem('tree_width') : 67408,
            treeHeight: localStorage.getItem('tree_height') ? localStorage.getItem('tree_height') : 47679,
            empty_node_setting: localStorage.getItem('empty_node_setting') ? localStorage.getItem('empty_node_setting') : "block",
            text_align: localStorage.getItem('text_align') ? localStorage.getItem('text_align') : "middle",
            name_text_align: localStorage.getItem('name_text_align') ? localStorage.getItem('name_text_align') : "middle",
            birthSetting: localStorage.getItem('birth_setting') ? localStorage.getItem('birth_setting') : "block",
            marriageSetting: localStorage.getItem('marriage_setting') ? localStorage.getItem('marriage_setting') : "block",
            deathSetting: localStorage.getItem('death_setting') ? localStorage.getItem('death_setting') : "block",
            flag_setting: localStorage.getItem('flag_setting') ? localStorage.getItem('flag_setting') : "SHOW",
            profile_setting: localStorage.getItem('profile_setting') ? localStorage.getItem('profile_setting') : "SHOW",
            warning_setting: localStorage.getItem('warning_setting') ? localStorage.getItem('warning_setting') : "SHOW",
            global_padding: localStorage.getItem('global_padding') ? localStorage.getItem('global_padding') : '5',
            type: localStorage.getItem("type"),
            id: localStorage.getItem("id"),
            papertype: localStorage.getItem("papertype"),
            direction: localStorage.getItem("direction"),
            saved: new Date(),
            maxGeneration: localStorage.getItem("maxGeneration"),
            tree_width: localStorage.getItem("tree_width"),
            tree_height: localStorage.getItem("tree_height"),
            gedcom_id: localStorage.getItem("gedcom_id"),
            gedcom_name: localStorage.getItem("gedcom_name"),
            background: localStorage.getItem("background")
        }

        const dialogConfig = new MatDialogConfig();
        // The user can't close the dialog by clicking outside its body
        dialogConfig.disableClose = false;
        dialogConfig.height = "80vh";
        dialogConfig.width = "96vw";
        dialogConfig.id = "orderprint-component";
        dialogConfig.data = doc;
        const modalDialog = singleModal.open(OrderprintComponent, dialogConfig);
        modalDialog.afterClosed().subscribe((result) => {
            if (result) {
            }
        });
    }

    generateRelation(parent, depth, temp = []) {
        const nodeinfos_t = this.nodeinfos;
        if (depth >= (maxGeneration - 1)) return;
        if (this.nodeinfos[parent.father] || this.nodeinfos[parent.mother]) {

            if (this.nodeinfos[parent.father]) {
                this.nodeinfos[parent.father]['c_fam'] = parent.famc;
                temp.push(JSON.parse(JSON.stringify(this.nodeinfos[parent.father])));
                this.nodeinfos[parent.father].mainDisplay = true
            } else {
                let buf = JSON.parse(JSON.stringify(GlobalConstants.node_structure));
                buf['id'] = 'fake_' + this.nodeinfos[parent.mother]['id']
                this.nodeinfos[parent.id]['father'] = buf['id']
                if (nodeinfos_t[buf['id']]) {
                    buf = nodeinfos_t[buf['id']]
                    buf['id'] = 'fake_' + this.nodeinfos[parent.mother]['id']
                } else {
                    buf['c_fam'] = parent.famc
                    buf['marriage'] = this.nodeinfos[parent.mother]['marriage']
                    buf['sex'] = 'M'
                    buf['url'] = Math.floor(Math.random() * Math.floor(12));
                }
                this.nodeinfos[buf['id']] = buf
                temp.push(JSON.parse(JSON.stringify(buf)));
            }
            if (this.nodeinfos[parent.mother]) {
                this.nodeinfos[parent.mother]['c_fam'] = parent.famc;
                this.nodeinfos[parent.mother].mainDisplay = true
                temp.push(JSON.parse(JSON.stringify(this.nodeinfos[parent.mother])));

            } else {
                let buf = JSON.parse(JSON.stringify(GlobalConstants.node_structure));
                buf['id'] = 'fake_' + this.nodeinfos[parent.father]['id']
                this.nodeinfos[parent.id]['mother'] = buf['id']
                if (nodeinfos_t[buf['id']]) {

                    buf = nodeinfos_t[buf['id']]
                    buf['id'] = 'fake_' + this.nodeinfos[parent.father]['id']
                } else {
                    buf['c_fam'] = parent.famc
                    buf['marriage'] = this.nodeinfos[parent.father]['marriage']
                    buf['sex'] = 'F'
                    buf['url'] = Math.floor(Math.random() * Math.floor(12));
                }
                this.nodeinfos[buf['id']] = buf

                temp.push(JSON.parse(JSON.stringify(buf)));
            }
        } else {
            let buf = JSON.parse(JSON.stringify(GlobalConstants.node_structure));
            buf['id'] = 'fake_father_' + parent['id']
            this.nodeinfos[parent.id]['father'] = buf['id']
            if (nodeinfos_t[buf['id']]) {
                buf = nodeinfos_t[buf['id']]
                buf['id'] = 'fake_father_' + parent['id']
            } else {
                buf['c_fam'] = 'fake_fam_' + parent['id']
                buf['sex'] = 'M'
                buf['url'] = Math.floor(Math.random() * Math.floor(12));
            }

            this.nodeinfos[buf['id']] = buf
            temp.push(JSON.parse(JSON.stringify(buf)));

            let buff = JSON.parse(JSON.stringify(GlobalConstants.node_structure));
            buff['id'] = 'fake_mother_' + parent['id']
            this.nodeinfos[parent.id]['mother'] = buff['id']
            if (nodeinfos_t[buff['id']]) {
                buff = nodeinfos_t[buff['id']]
                buff['id'] = 'fake_mother_' + parent['id']
            } else {
                buff['c_fam'] = 'fake_fam_' + parent['id']
                buff['sex'] = 'F'
                buff['url'] = Math.floor(Math.random() * Math.floor(12));
            }

            this.nodeinfos[buff['id']] = buff
            temp.push(JSON.parse(JSON.stringify(buff)));
        }

        parent._parents = temp;
        if (parent._parents[0]) {
            this.generateRelation(parent._parents[0], depth + 1);
        }
        if (parent._parents[1]) {
            this.generateRelation(parent._parents[1], depth + 1);
        }
    }

    parentRelation(parent, depth, temp = []) {
        if (depth >= (maxGeneration - 2)) return;
        if (this.nodeinfos[parent.father] || this.nodeinfos[parent.mother]) {

            if (this.nodeinfos[parent.father]) {
                this.nodeinfos[parent.father]['c_fam'] = parent.famc;
                this.nodeinfos[parent.father].mainDisplay = true
                temp.push(JSON.parse(JSON.stringify(this.nodeinfos[parent.father])));
            } else {
                let buf = JSON.parse(JSON.stringify(GlobalConstants.node_structure));
                buf['id'] = 'fake_' + this.nodeinfos[parent.mother]['id']
                this.nodeinfos[parent.id]['father'] = buf['id']
                if (this.nodeinfos[buf['id']]) {
                    buf = this.nodeinfos[buf['id']]
                } else {
                    buf['c_fam'] = parent.famc
                    buf['marriage'] = this.nodeinfos[parent.mother]['marriage']
                    buf['sex'] = 'M'
                    buf['url'] = Math.floor(Math.random() * Math.floor(12));
                }
                this.nodeinfos[buf['id']] = buf
                temp.push(JSON.parse(JSON.stringify(buf)));
            }
            if (this.nodeinfos[parent.mother]) {
                this.nodeinfos[parent.mother]['c_fam'] = parent.famc;
                this.nodeinfos[parent.mother].mainDisplay = true
                temp.push(JSON.parse(JSON.stringify(this.nodeinfos[parent.mother])));
            } else {
                let buf = JSON.parse(JSON.stringify(GlobalConstants.node_structure));
                buf['id'] = 'fake_' + this.nodeinfos[parent.father]['id']
                this.nodeinfos[parent.id]['mother'] = buf['id']

                if (this.nodeinfos[buf['id']]) {
                    buf = this.nodeinfos[buf['id']]
                } else {
                    buf['c_fam'] = parent.famc
                    buf['marriage'] = this.nodeinfos[parent.father]['marriage']
                    buf['sex'] = 'F'
                    buf['url'] = Math.floor(Math.random() * Math.floor(12));
                }

                this.nodeinfos[buf['id']] = buf
                temp.push(JSON.parse(JSON.stringify(buf)));
            }

        } else {
            let buf = JSON.parse(JSON.stringify(GlobalConstants.node_structure));
            buf['id'] = 'fake_father_' + parent['id']
            this.nodeinfos[parent.id]['father'] = buf['id']

            if (this.nodeinfos[buf['id']]) {
                buf = this.nodeinfos[buf['id']]
            } else {
                buf['c_fam'] = 'fake_fam_' + parent['id']
                buf['sex'] = 'M'
                buf['url'] = Math.floor(Math.random() * Math.floor(12));
            }

            this.nodeinfos[buf['id']] = buf
            temp.push(JSON.parse(JSON.stringify(buf)));

            let buff = JSON.parse(JSON.stringify(GlobalConstants.node_structure));
            buff['id'] = 'fake_mother_' + parent['id']
            this.nodeinfos[parent.id]['mother'] = buff['id']

            if (this.nodeinfos[buff['id']]) {
                buff = this.nodeinfos[buff['id']]
                buff['id'] = 'fake_mother_' + parent['id']
            } else {
                buff['c_fam'] = 'fake_fam_' + parent['id']
                buff['sex'] = 'F'
                buff['url'] = Math.floor(Math.random() * Math.floor(12));
            }

            this.nodeinfos[buff['id']] = buff
            temp.push(JSON.parse(JSON.stringify(buff)));

        }
        parent._parents = temp;
        if (parent._parents[0]) {
            this.parentRelation(parent._parents[0], depth + 1);
        }
        if (parent._parents[1]) {
            this.parentRelation(parent._parents[1], depth + 1);
        }
    }

    childrenRelation(child, depth, temp = []) {
        if (depth >= (maxGeneration - 2)) return;
        if (this.nodeinfos[child.father] || this.nodeinfos[child.mother]) {

            if (this.nodeinfos[child.father]) {
                this.nodeinfos[child.father]['c_fam'] = child.famc;
                this.nodeinfos[child.father].mainDisplay = true
                temp.push(JSON.parse(JSON.stringify(this.nodeinfos[child.father])));
            } else {
                let buf = JSON.parse(JSON.stringify(GlobalConstants.node_structure));
                buf['id'] = 'fake_' + this.nodeinfos[child.mother]['id']
                this.nodeinfos[child.id]['father'] = buf['id']
                if (this.nodeinfos[buf['id']]) {
                    buf = this.nodeinfos[buf['id']]
                } else {
                    buf['c_fam'] = child.famc
                    buf['marriage'] = this.nodeinfos[child.mother]['marriage']
                    buf['sex'] = 'M'
                    buf['url'] = Math.floor(Math.random() * Math.floor(12));
                }

                this.nodeinfos[buf['id']] = buf
                temp.push(JSON.parse(JSON.stringify(buf)));
            }
            if (this.nodeinfos[child.mother]) {
                this.nodeinfos[child.mother]['c_fam'] = child.famc;
                this.nodeinfos[child.mother].mainDisplay = true
                temp.push(JSON.parse(JSON.stringify(this.nodeinfos[child.mother])));
            } else {
                let buf = JSON.parse(JSON.stringify(GlobalConstants.node_structure));
                buf['id'] = 'fake_' + this.nodeinfos[child.father]['id']
                this.nodeinfos[child.id]['mother'] = buf['id']

                if (this.nodeinfos[buf['id']]) {
                    buf = this.nodeinfos[buf['id']]
                } else {
                    buf['c_fam'] = child.famc
                    buf['marriage'] = this.nodeinfos[child.father]['marriage']
                    buf['sex'] = 'F'
                    buf['url'] = Math.floor(Math.random() * Math.floor(12));
                }

                this.nodeinfos[buf['id']] = buf
                temp.push(JSON.parse(JSON.stringify(buf)));
            }

        } else {
            let buf = JSON.parse(JSON.stringify(GlobalConstants.node_structure));
            buf['id'] = 'fake_father_' + child['id']
            this.nodeinfos[child.id]['father'] = buf['id']
            if (this.nodeinfos[buf['id']]) {
                buf = this.nodeinfos[buf['id']]
            } else {
                buf['c_fam'] = 'fake_fam_' + child['id']
                buf['sex'] = 'M'
                buf['url'] = Math.floor(Math.random() * Math.floor(12));
            }

            this.nodeinfos[buf['id']] = buf
            temp.push(JSON.parse(JSON.stringify(buf)));

            let buff = JSON.parse(JSON.stringify(GlobalConstants.node_structure));
            buff['id'] = 'fake_mother_' + child['id']
            this.nodeinfos[child.id]['mother'] = buff['id']

            if (this.nodeinfos[buff['id']]) {
                buff = this.nodeinfos[buff['id']]
            } else {
                buff['c_fam'] = 'fake_fam_' + child['id']
                buff['sex'] = 'F'
                buff['url'] = Math.floor(Math.random() * Math.floor(12));
            }

            this.nodeinfos[buff['id']] = buff
            temp.push(JSON.parse(JSON.stringify(buff)));
        }
        child._children = temp;
        if (child._children[0]) {
            this.childrenRelation(child._children[0], depth + 1);
        }
        if (child._children[1]) {
            this.childrenRelation(child._children[1], depth + 1);
        }
    }

    addwife() {
        var direction = parseInt(localStorage.getItem('direction'));
        var partners = this.nodeinfos[this._id]['sex'] == "M" ? this.nodeinfos[this._id]['wife'] : this.nodeinfos[this._id]['husb']
        var partner = this.nodeinfos[partners[0]]

        for (let index = 0; index < partners.length; index++) {
            if (index < partners.length - 1) {
                let temp = [];
                temp.push(this.nodeinfos[partners[index + 1]])
                this.nodeinfos[partners[index]]._partner = temp
            }
        }

        let bornText = this.nodeBornText
        let deceasedText = this.nodeDeceasedText
        var s_node_width = treeWidth / (Math.pow(2, maxGeneration - 2))
        var s_node_height = treeHeight / maxGeneration

        if (direction == 1 || direction == 2 || direction == 5) {
            s_node_height = imgSize[0] + 5 * textSize[0]
        } else {
            s_node_height = treeHeight / 12
        }

        var tree = d3
            .layout
            .tree()
            .nodeSize([s_node_width, s_node_height])
            .separation(function () {
                return .5;
            })
            .children(function (person) {
                return person._partner;
            });

        if (partner) {
            draw(tree, partner, 'wife', direction)
        }

        function draw(tree, root, displayClass, direction) {

            function openEditModal(d) {
                const dialogConfig = new MatDialogConfig();
                // The user can't close the dialog by clicking outside its body
                dialogConfig.disableClose = false;
                dialogConfig.id = "modal-component";
                if (d.depth > 3 && d.depth <= 6) dialogConfig.height = "70vh";
                else if (d.depth > 6 && d.depth <= 8) dialogConfig.height = "50vh";
                else if (d.depth > 8) dialogConfig.height = "20vh";
                else dialogConfig.height = "90vh";
                dialogConfig.width = "500px";
                dialogConfig.data = d

                const modalDialog = singleModal.open(ModalComponent, dialogConfig);
                modalDialog.afterClosed().subscribe((result) => {
                    if (result) {
                        document.getElementById('submit-setting').click();
                        window.location.reload();
                    }
                });
            };

            var svg = d3.select('body').select('g')
            var nodes = tree.nodes(root)

            var node = svg
                .selectAll("g.person." + displayClass)
                .data(nodes)
                .enter()
                .append("g")
                .attr("class", "person " + displayClass)
                .attr("transform", function (d) {
                    switch (direction) {
                        case 3:
                            return "translate(" + (d.y + treeHeight / maxGeneration * 1.1) + "," + d.x + ")";
                        case 1:
                            return "translate(" + d.x + "," + (d.y + (imgSizeGroup[papertype][0] + 6 * textSize[0])) + ")";
                        case 2:
                            return "translate(" + d.x + "," + (d.y + (imgSizeGroup[papertype][0] + 6 * textSize[0])) + ")";
                        case 5:
                            return "translate(" + d.x + "," + (-1) * (d.y + (imgSizeGroup[papertype][1] + 6 * textSize[1]) * 2.5) + ")";
                        default:
                            return "translate(" + (d.y + treeHeight / maxGeneration * 1.1) + "," + d.x + ")";
                    }
                })
                .on('click', openEditModal);

            node
                .append("rect")

            node.attr({
                "opacity": function (d) {
                    if (d.id.substring(0, 5) == 'fake_' && empty_node_setting == 'none') {
                        return 0
                    }
                    else {
                        return 1
                    }
                },
                "fill-opacity": nodeOpacity,
            })

            //image
            node
                .append('image')
                .attr({
                    'class': 'avatar',
                    'xlink:href': function (d) {
                        if (d.avatar_type == "sample") {
                            if (d.sex == 'M') {
                                return maleAvatar[parseInt(d.url)]
                            } else {
                                return femaleAvatar[parseInt(d.url)]
                            }
                        } else {
                            return d.url;
                        }
                    },
                    'width': function (d) {
                        return imgSize[1]
                    },
                    'height': function (d) {
                        return imgSize[1]
                    },
                    "x": function (d) {
                        if (flag_setting != "SHOW" || d.country == "NoFlag") {
                            return -imgSize[1] / 2
                        }
                        return -imgSize[1] / 2 - flagSize[1] / 2 - 100
                    },
                    "display": function (d) {
                        if (profile_setting != "SHOW") {
                            return "none"
                        }
                        if (d.avatar_setting != "SHOW") {
                            return "none"
                        }
                    },

                }).each(function (d) {
                    d.type = "wife"
                    d.height = this.getBBox().height
                    d.width = this.getBBox().width + flagSize[1] + 200
                })

            //flag
            node
                .append('image')
                .attr({
                    'class': 'flag',
                    'xlink:href': function (d) {
                        if (!d.country || d.country == "") {
                            return Flags.flags['Sweden']
                        } else if (d.country == "NoFlag") {
                            return Flags.flags['Sweden']
                        }
                        else if (d.country == "custom") {
                            return d.c_flag
                        }
                        else {
                            return Flags.flags[d.country]
                        }
                    },
                    'width': function (d) {
                        return flagSize[1]
                    },
                    "x": function (d) {
                        if (d.avatar_setting != "SHOW") return -flagSize[1] / 2
                        return imgSize[1] / 2 - flagSize[1] / 2 + 100
                    },
                    "display": function (d) {
                        if (flag_setting != "SHOW") {
                            return "none"
                        }
                        else if (d.country == "NoFlag") {
                            return "none"
                        }
                        else {
                            return "block"
                        }
                    },
                }).each(function (d) {
                    if (profile_setting != "SHOW" || d.avatar_setting != "SHOW") {
                        d.height = this.getBBox().height
                    }
                })

            // first and last name
            node
                .append("text")
                .attr({
                    'class': 'name',
                    'fill': function (d) {
                        if (d.sex == 'M') return manColor
                        else return womanColor
                    },
                    "display": function (d) {
                        if (d.id.substring(0, 5) == 'fake_') {
                            return empty_node_setting
                        }
                    },
                    'font-size': function (d) {
                        return textSize[1]
                    },
                    'font-family': fontFamily,
                })
                .each(function (d) {
                    let font_size
                    font_size = textSize[1]
                    let name = (d.firstName ? d.firstName : 'n/a') + " " + (d.lastName ? d.lastName : 'n/a')

                    if (name.includes('n/a')) {
                        d.warning = true;
                    }

                    let length = Math.floor((treeHeight / maxGeneration + 800 * (maxGeneration / 2 - 2)) / font_size * 1.5)
                    if (direction == '3' || direction == '4') {
                        length = Math.floor(treeHeight / 10 / font_size * 1.5)
                    }
                    var res_text = spliteText(name, length, 0);
                    for (let index = 0; index < res_text.length; index++) {
                        const element = res_text[index];
                        d3.select(this)
                            .append("tspan")
                            .text(function () {
                                return element;
                            })
                            .attr({
                                x: function () {
                                    if (index > 0) return 0
                                },
                                dy: function () {
                                    if (index > 0) return '1em'
                                },
                                'class': 'name_span',
                            })
                    }

                    if (d.width < this.getBBox().width) d.width = this.getBBox().width;
                    d.height = this.getBBox().height + d.height;
                    if (!name_height[d.id + d.depth]) name_height[d.id + d.depth] = this.getBBox().height
                });

            // birthday and place
            node
                .append("text")
                .attr({
                    'class': 'birth',
                    'fill': function (d) {
                        if (d.sex == 'M') return manColor
                        else return womanColor
                    },
                    'font-size': function (d) {
                        return textSize[1]
                    },
                    'font-family': fontFamily,
                })
                .each(function (d) {
                    let place = (d.birth && d.birth.place) ? d.birth.place : "n/a";
                    let font_size
                    font_size = textSize[1]
                    let birth_info = (d.birthday ? d.birthday : '-.-.-') + ", " + place
                    if (birthSetting != "none") {
                        if (birth_info.includes('n/a') || birth_info.includes('.-') || birth_info.includes('-.')) {
                            d.warning = true;
                        }
                    }
                    let length = Math.floor((treeHeight / maxGeneration + 800 * (maxGeneration / 2 - 2)) / font_size * 1.5)
                    if (direction == '3' || direction == '4') {
                        length = Math.floor(treeHeight / 10 / font_size * 1.5)
                    }

                    if ((localStorage.getItem('birth_hide_empty') === 'true') && birth_info === '-.-.-, n/a') {
                        console.log('empty')
                    }
                    else {
                        d3.select(this)
                            .append("tspan")
                            .text(function () {
                                return bornText;
                            })
                            .attr({
                                'font-weight': "bold"
                            })
                        var res_text = spliteText(birth_info, length, 6);
                        for (let index = 0; index < res_text.length; index++) {
                            const element = res_text[index];
                            d3.select(this)
                                .append("tspan")
                                .text(function () {
                                    return element;
                                })
                                .attr({
                                    x: function () {
                                        if (index > 0) return 0
                                    },
                                    dy: function () {
                                        if (index > 0) return '1em'
                                    },
                                    'class': function () {
                                        if (index == 0) return 'nextString'
                                    },
                                })
                        }
                        if (birthSetting != "none") {
                            if (d.width < this.getBBox().width) d.width = this.getBBox().width;
                            if (d.depth <= 8) d.height = this.getBBox().height + d.height
                        }
                        if (!birth_height[d.id + d.depth]) birth_height[d.id + d.depth] = this.getBBox().height
                    }
                })

            // death day and place
            node
                .append("text")
                .attr({
                    'class': 'death',
                    'fill': function (d) {
                        if (d.sex == 'M') return manColor
                        else return womanColor
                    },
                    'font-size': function (d) {
                        return textSize[1]
                    },
                    'font-family': fontFamily,
                })
                .each(function (d) {
                    let place = (d.death && d.death.place) ? d.death.place : "n/a";
                    let font_size = textSize[1]
                    let death_info = (d.deathday ? d.deathday : '-.-.-') + ", " + place

                    if (deathSetting != "none") {
                        if (death_info.includes('n/a') || death_info.includes('.-') || death_info.includes('-.')) {
                            d.warning = true;
                        }
                    }

                    let length = Math.floor((treeHeight / maxGeneration + 800 * (maxGeneration / 2 - 2)) / font_size * 1.5)
                    if (direction == '3' || direction == '4') {
                        length = Math.floor(treeHeight / 10 / font_size * 1.5)
                    }
                    if ((localStorage.getItem('death_hide_empty') === 'true') && death_info === '-.-.-, n/a') {
                        console.log('empty')
                    }
                    else {
                        d3.select(this)
                            .append("tspan")
                            .text(function () {
                                return deceasedText;
                            })
                            .attr({
                                'font-weight': "bold"
                            })
                        var res_text = spliteText(death_info, length, 9);
                        for (let index = 0; index < res_text.length; index++) {
                            const element = res_text[index];
                            d3.select(this)
                                .append("tspan")
                                .text(function () {
                                    return element;
                                })
                                .attr({
                                    x: function () {
                                        if (index > 0) return 0
                                    },
                                    dy: function () {
                                        if (index > 0) return '1em'
                                    },
                                    'class': function () {
                                        if (index == 0) return 'nextString'
                                    },
                                })
                        }
                        if (deathSetting != "none" && d.depth <= 8) {
                            if (d.width < this.getBBox().width) d.width = this.getBBox().width;
                            d.height = this.getBBox().height + d.height
                        }
                        if (!death_height[d.id + d.depth]) death_height[d.id + d.depth] = this.getBBox().height
                    }
                });

            // note
            node
                .append("text")
                .attr({
                    'class': 'note',
                    'fill': function (d) {
                        if (d.sex == 'M') return manColor
                        else return womanColor
                    },
                    'font-size': function (d) {
                        return textSize[1] / 2
                    },
                    'font-family': fontFamily,
                    "display": function (d) {
                        if (d.note == "") return 'none'
                        else return 'block'
                    },
                })
                .each(function (d) {
                    let note = d.note;
                    let font_size = textSize[1] / 2

                    let length = Math.floor((treeHeight / maxGeneration + 800 * (maxGeneration / 2 - 2)) / font_size * 1.5)
                    if (direction == '3' || direction == '4') {
                        length = Math.floor(treeHeight / 10 / font_size * 1.5)
                    }
                    var res_text = [""]
                    if (note != "" && note != null) {
                        res_text = spliteText(note, length, 1);
                    }

                    for (let index = 0; index < res_text.length; index++) {
                        const element = res_text[index];
                        d3.select(this)
                            .append("tspan")
                            .text(function () {
                                return element;
                            })
                            .attr({
                                x: function () {
                                    return 0
                                },
                                dy: function () {
                                    if (index > 0) return '1em'
                                },
                            })

                    }
                    if (d.note != "") {
                        if (d.width < this.getBBox().width) d.width = this.getBBox().width;
                        d.height = this.getBBox().height + d.height
                        note_height[d.id] = this.getBBox().height
                    } else {
                        note_height[d.id] = 0
                    }
                });

            node.selectAll(".avatar").attr({
                y: function (d) {
                    return (-1) * d.height / 2
                },
                // opacity: nodeOpacity,
            })

            node.selectAll(".flag").attr({
                y: function (d) {
                    return (-1) * d.height / 2
                },
                // opacity: nodeOpacity,
            })

            node.selectAll("tspan").attr({
                dx: function (d) {
                    switch (text_align) {
                        case 'middle':
                            return 0;
                        case 'start':
                            return (-1) * d.width / 2;
                        default:
                            return d.width / 2;
                    }
                },
                "text-anchor": text_align,
                // opacity: nodeOpacity,
            })

            node.selectAll(".name_span").attr({
                dx: function (d) {
                    switch (name_text_align) {
                        case 'middle':
                            return 0;
                        case 'start':
                            return (-1) * d.width / 2;
                        default:
                            return d.width / 2;
                    }
                },
                "text-anchor": name_text_align
            })

            node.selectAll(".nextString").attr({
                dx: 0
            })

            node.selectAll(".name").attr({
                dy: function (d) {
                    if (d.avatar_setting != "SHOW" || profile_setting != "SHOW") {
                        if (flag_setting != "SHOW" || d.country == "NoFlag") {
                            return (-1) * d.height / 2 + textSize[1]
                        } else {
                            return (-1) * d.height / 2 + flagSize[1] + textSize[1]
                        }
                    } else {
                        return (-1) * d.height / 2 + imgSize[1] + textSize[1]
                    }
                },
            })

            node.selectAll(".birth").attr({
                dy: function (d) {
                    if (d.avatar_setting != "SHOW" || profile_setting != "SHOW") {
                        if (flag_setting != "SHOW" || d.country == "NoFlag") {
                            return (-1) * d.height / 2 + textSize[1] + name_height[d.id + d.depth]
                        } else {
                            return (-1) * d.height / 2 + flagSize[1] + textSize[1] + name_height[d.id + d.depth]
                        }
                    } else {
                        return (-1) * d.height / 2 + imgSize[1] + textSize[1] + name_height[d.id + d.depth]
                    }
                },
                display: function (d) {
                    if (birthSetting == "none") {
                        return "none"
                    }
                }
            })

            node.selectAll(".death").attr({
                dy: function (d) {
                    var temp = 0
                    if (d.avatar_setting != "SHOW" || profile_setting != "SHOW") {
                        if (flag_setting == "SHOW" && d.country != "NoFlag") {
                            temp = flagSize[1] + textSize[1] + name_height[d.id + d.depth]
                        } else {
                            temp = textSize[1] + name_height[d.id + d.depth]
                        }
                    } else {
                        temp = imgSize[1] + textSize[1] + name_height[d.id + d.depth]
                    }

                    if (birthSetting != 'none') {
                        temp += birth_height[d.id + d.depth]
                    }

                    return (-1) * d.height / 2 + temp
                },
                display: function (d) {
                    if (deathSetting == "none") {
                        return "none"
                    }
                }
            })

            node.selectAll(".note").attr({
                dy: function (d) {
                    var temp = 0
                    if (d.avatar_setting != "SHOW" || profile_setting != "SHOW") {
                        if (flag_setting == "SHOW" && d.country != "NoFlag") {
                            temp = flagSize[1] + textSize[1] / 2 + name_height[d.id + d.depth]
                        } else {
                            temp = textSize[1] / 2 + name_height[d.id + d.depth]
                        }
                    } else {
                        temp = imgSize[1] + textSize[1] / 2 + name_height[d.id + d.depth]
                    }

                    if (birthSetting != 'none') {
                        temp += birth_height[d.id + d.depth]
                    }
                    if (deathSetting != 'none') {
                        temp += death_height[d.id + d.depth]
                    }
                    return (-1) * d.height / 2 + temp
                },
            })

            node
                .select("rect")
                .attr({
                    x: function (d) {
                        return -(d.width * 1.1 + 20) / 2;
                    },
                    fill: function (d) {
                        if (d.sex == 'M') return maleNodeColor
                        else return femaleNodeColor
                    },
                    y: function (d) {
                        return -(d.height + 20) / 2;
                    },
                    width: function (d) {
                        return d.width * 1.1 + 20;
                    },
                    height: function (d) {
                        return d.height + 20;
                    },
                    stroke: function (d) {
                        return borderColor
                    },
                    // display: function (d) {
                    //     if (d.id.substring(0, 5) == 'fake_') {
                    //         return empty_node_setting
                    //     }
                    // },
                    rx: function (d) {
                        return borderRadius;
                    },
                    "stroke-width": function (d) {
                        return borderWidth;
                    },
                    "fill-opacity": function (d) {
                        if (d.id.substring(0, 5) == 'fake_' && empty_node_setting == 'none') {
                            return 0
                        }
                    },
                })

            node
                .append('image')
                .attr({
                    'class': 'warning',
                    'xlink:href': function (d) {
                        return GlobalConstants.warning
                    },
                    'width': function (d) {
                        return imgSize[1] / 2
                    },
                    'height': function (d) {
                        return imgSize[1] / 2
                    },
                    "x": function (d) {
                        return -(d.width * 1.1 + 20) / 2 - imgSize[1] / 4;
                    },
                    y: function (d) {
                        return -(d.height + 20) / 2;
                    },
                    "display": function (d) {
                        if (d.warning && warning_setting == "SHOW") {
                            if (d.id.substring(0, 5) == 'fake_') {
                                return empty_node_setting
                            }
                            return 'block';
                        } else {
                            return 'none';
                        }
                    },
                })
        }
    }

    addchildren() {
        // this.nodeinfos = JSON.parse(localStorage.getItem('nodeinfos'));
        this.dbService.getByKey('nodes', 1).subscribe((nodes: any) => {
            this.nodeinfos = JSON.parse(nodes.nodeinfos)
        }, err => console.log(err));
        var direction = parseInt(localStorage.getItem('direction'));
        partners = this.nodeinfos[this._id]['sex'] == "M" ? this.nodeinfos[this._id]['wife'] : this.nodeinfos[this._id]['husb']
        children = this.nodeinfos[this._id]['child_info']

        var child_1_id = 0
        var child_2_id = 0

        var partner_setting = localStorage.getItem('partner_setting') ? localStorage.getItem('partner_setting') : "SHOW";

        if (direction == 5 || partner_setting != "SHOW") {
            child_2_id = Math.floor(children.length / 2)

            for (let index = 0; index < child_2_id; index++) {
                if (index < child_2_id - 1) {
                    let temp = [];
                    temp.push(this.nodeinfos[children[index + 1]])
                    if (temp) this.nodeinfos[children[index]]['_child_1'] = temp
                }
            }

            for (let index = child_2_id; index < children.length; index++) {
                if (index < children.length - 1) {
                    let temp = [];
                    temp.push(this.nodeinfos[children[index + 1]])
                    if (temp) this.nodeinfos[children[index]]['_child_2'] = temp
                }
            }

        } else if (partners.length >= children.length) {
            for (let index = 0; index < children.length; index++) {
                if (index < children.length - 1) {
                    let temp = [];
                    temp.push(this.nodeinfos[children[index + 1]])
                    if (temp) this.nodeinfos[children[index]]['_child_1'] = temp
                }
            }

        } else {
            child_2_id = Math.floor((children.length - partners.length) / 2 + partners.length)

            for (let index = 0; index < child_2_id; index++) {
                if (index < child_2_id - 1) {
                    let temp = [];
                    temp.push(this.nodeinfos[children[index + 1]])
                    if (temp) this.nodeinfos[children[index]]['_child_1'] = temp
                }
            }

            for (let index = child_2_id; index < children.length; index++) {
                if (index < children.length - 1) {
                    let temp = [];
                    temp.push(this.nodeinfos[children[index + 1]])
                    if (temp) this.nodeinfos[children[index]]['_child_2'] = temp
                }
            }

        }

        var s_node_width = treeWidth / (Math.pow(2, maxGeneration - 2))
        var s_node_height = treeHeight / maxGeneration

        if (direction == 1 || direction == 2 || direction == 5) {
            s_node_height = imgSize[5] + 5 * textSize[5]
        } else {
            s_node_height = treeHeight / (20 + Math.max(0, children.length - 10))
        }

        var tree_1 = d3
            .layout
            .tree()
            .nodeSize([s_node_width, s_node_height])
            .separation(function () {
                return .5;
            })
            .children(function (person) {
                return person._child_1;
            });

        var tree_2 = d3
            .layout
            .tree()
            .nodeSize([s_node_width, s_node_height])
            .separation(function () {
                return .5;
            })
            .children(function (person) {
                return person._child_2;
            });

        if (this.nodeinfos[children[child_1_id]]) {
            this.child_draw(tree_1, this.nodeinfos[children[child_1_id]], 'child_1', direction, 1, partner_setting)
        }
        if (child_2_id != 0 && this.nodeinfos[children[child_2_id]]) {
            this.child_draw(tree_2, this.nodeinfos[children[child_2_id]], 'child_2', direction, 2, partner_setting)
        }


    }

    child_draw(tree, root, displayClass, direction, dd, pair_setting) {
        function openEditModal(d) {
            const dialogConfig = new MatDialogConfig();
            // The user can't close the dialog by clicking outside its body
            dialogConfig.disableClose = false;
            dialogConfig.id = "modal-component";
            if (d.depth > 3 && d.depth <= 6) dialogConfig.height = "70vh";
            else if (d.depth > 6 && d.depth <= 8) dialogConfig.height = "50vh";
            else if (d.depth > 8) dialogConfig.height = "20vh";
            else dialogConfig.height = "90vh";
            dialogConfig.width = "500px";
            dialogConfig.data = d

            const modalDialog = singleModal.open(ModalComponent, dialogConfig);
            modalDialog.afterClosed().subscribe((result) => {
                if (result) {
                    document.getElementById('submit-setting').click();
                    window.location.reload();
                }
            });
        };

        let bornText = this.nodeBornText
        let deceasedText = this.nodeDeceasedText

        var svg = d3.select('body').select('g')
        var nodes = tree.nodes(root)

        var node = svg
            .selectAll("g.person." + displayClass)
            .data(nodes)
            .enter()
            .append("g")
            .attr("class", "person " + displayClass)
            .attr("transform", function (d) {
                switch (direction) {
                    case 3:
                        if (dd == 1) {
                            return "translate(" + (-d.y - treeHeight / maxGeneration * 1.1) + "," + d.x + ")";
                        } else {
                            if (pair_setting != "SHOW") return "translate(" + (d.y + treeHeight / maxGeneration * 1.1) + "," + d.x + ")";
                            else return "translate(" + (d.y + treeHeight / maxGeneration * 1.1 + treeHeight / 12 * (partners.length)) + "," + d.x + ")";
                        }

                    case 1:
                        if (dd == 1) {
                            return "translate(" + d.x + "," + (-d.y - (imgSizeGroup[papertype][0] + 5 * textSize[0])) + ")";
                        } else {
                            if (pair_setting != "SHOW") return "translate(" + d.x + "," + (d.y + (imgSizeGroup[papertype][0] + 5 * textSize[0])) + ")";
                            else return "translate(" + d.x + "," + (d.y + (imgSizeGroup[papertype][0] + 5 * textSize[0]) * (partners.length + 1)) + ")";
                        }
                    case 2:
                        if (dd == 1) {
                            return "translate(" + d.x + "," + (-d.y - (imgSizeGroup[papertype][0] + 5 * textSize[0])) + ")";
                        } else {
                            if (pair_setting != "SHOW") return "translate(" + d.x + "," + (d.y + (imgSizeGroup[papertype][0] + 5 * textSize[0])) + ")";
                            else return "translate(" + d.x + "," + (d.y + (imgSizeGroup[papertype][0] + 5 * textSize[0]) * (partners.length + 1)) + ")";
                        }
                    case 5:
                        if (dd == 1) {
                            return "translate(" + (d.x - treeHeight / maxGeneration / 2 * 1.1) + "," + (d.y + (imgSizeGroup[papertype][1] + 6 * textSize[1])) + ")";
                        } else {
                            return "translate(" + (d.x + treeHeight / maxGeneration / 2 * 1.1) + "," + (d.y + (imgSizeGroup[papertype][1] + 6 * textSize[1])) + ")";
                        }

                    default:
                        if (dd == 1) {
                            return "translate(" + (-d.y - treeHeight / maxGeneration * 1.1) + "," + d.x + ")";
                        } else {
                            if (pair_setting != "SHOW") return "translate(" + (d.y + treeHeight / maxGeneration * 1.1) + "," + d.x + ")";
                            else return "translate(" + (d.y + treeHeight / maxGeneration * 1.1 + treeHeight / 12 * (partners.length)) + "," + d.x + ")";
                        }
                }
            })
            .on('click', openEditModal);

        node
            .append("rect")

        node.attr({
            "opacity": function (d) {
                if (d.id.substring(0, 5) == 'fake_' && empty_node_setting == 'none') {
                    return 0
                }
                else {
                    return 1
                }
            },
            "fill-opacity": nodeOpacity,
        })

        //image
        node
            .append('image')
            .attr({
                'class': 'avatar',
                'xlink:href': function (d) {
                    if (d.avatar_type == "sample") {
                        if (d.sex == 'M') {
                            return maleAvatar[parseInt(d.url)]
                        } else {
                            return femaleAvatar[parseInt(d.url)]
                        }
                    } else {
                        return d.url;
                    }
                },
                'width': function (d) {
                    return imgSize[5]
                },
                'height': function (d) {
                    return imgSize[5]
                },
                "x": function (d) {
                    if (flag_setting != "SHOW" || d.country == "NoFlag") {
                        return -imgSize[5] / 2 - 100
                    }
                    return -imgSize[5] / 2 - flagSize[5] / 2 - 100
                },
                "display": function (d) {
                    if (profile_setting != "SHOW") {
                        return "none"
                    }
                    if (d.avatar_setting != "SHOW") {
                        return "none"
                    }
                },

            }).each(function (d) {
                d.type = "child"
                d.height = this.getBBox().height
                d.width = this.getBBox().width + flagSize[1] + 200
            })

        //flag
        node
            .append('image')
            .attr({
                'class': 'flag',
                'xlink:href': function (d) {
                    if (!d.country || d.country == "") {
                        return Flags.flags['Sweden']
                    } else if (d.country == "NoFlag") {
                        return Flags.flags['Sweden']
                    }
                    else if (d.country == "custom") {
                        return d.c_flag
                    }
                    else {
                        return Flags.flags[d.country]
                    }
                },
                'width': function (d) {
                    return flagSize[5]
                },
                "x": function (d) {
                    if (d.avatar_setting != "SHOW") return -flagSize[5] / 2
                    return imgSize[5] / 2 - flagSize[5] / 2 + 100
                },
                "display": function (d) {
                    if (flag_setting != "SHOW") {
                        return "none"
                    }
                    else if (d.country == "NoFlag") {
                        return "none"
                    }
                    else {
                        return "block"
                    }
                },
            }).each(function (d) {
                if (profile_setting != "SHOW" || d.avatar_setting != "SHOW") {
                    d.height = this.getBBox().height
                }
            })

        // first and last name
        node
            .append("text")
            .attr({
                'class': 'name',
                'fill': function (d) {
                    if (d.sex == 'M') return manColor
                    else return womanColor
                },
                "display": function (d) {
                    if (d.id.substring(0, 5) == 'fake_') {
                        return empty_node_setting
                    }
                },
                'font-size': function (d) {
                    return textSize[5]
                },
                'font-family': fontFamily,
            })
            .each(function (d) {
                let font_size
                font_size = textSize[5]
                let name = (d.firstName ? d.firstName : 'n/a') + " " + (d.lastName ? d.lastName : 'n/a')

                if (name.includes('n/a')) {
                    d.warning = true;
                }

                let length = Math.floor((treeHeight / maxGeneration) / font_size * 1.5)
                if (direction == '3' || direction == '4') {
                    length = Math.floor(treeHeight / (22 + Math.max(0, children.length - 10)) / font_size * 1.5)
                }
                var res_text = spliteText(name, length, 0);
                for (let index = 0; index < res_text.length; index++) {
                    const element = res_text[index];
                    d3.select(this)
                        .append("tspan")
                        .text(function () {
                            return element;
                        })
                        .attr({
                            x: function () {
                                if (index > 0) return 0
                            },
                            dy: function () {
                                if (index > 0) return '1em'
                            },
                            'class': 'name_span',
                        })
                }

                if (d.width < this.getBBox().width) d.width = this.getBBox().width;
                d.height = this.getBBox().height + d.height;
                if (!name_height[d.id + d.depth]) name_height[d.id + d.depth] = this.getBBox().height
            });

        // birthday and place
        node
            .append("text")
            .attr({
                'class': 'birth',
                'fill': function (d) {
                    if (d.sex == 'M') return manColor
                    else return womanColor
                },
                'font-size': function (d) {
                    return textSize[5]
                },
                'font-family': fontFamily,
            })
            .each(function (d) {
                let place = (d.birth && d.birth.place) ? d.birth.place : "n/a";
                let font_size
                font_size = textSize[5]
                let birth_info = (d.birthday ? d.birthday : '-.-.-') + ", " + place
                if (birthSetting != "none") {
                    if (birth_info.includes('n/a') || birth_info.includes('.-') || birth_info.includes('-.')) {
                        d.warning = true;
                    }
                }
                let length = Math.floor((treeHeight / maxGeneration) / font_size * 1.5)
                if (direction == '3' || direction == '4') {
                    length = Math.floor(treeHeight / (22 + Math.max(0, children.length - 10)) / font_size * 1.5)
                }

                if ((localStorage.getItem('birth_hide_empty') === 'true') && birth_info === '-.-.-, n/a') {
                    console.log('empty')
                }
                else {
                    d3.select(this)
                        .append("tspan")
                        .text(function () {
                            return bornText;
                        })
                        .attr({
                            'font-weight': "bold"
                        })
                    var res_text = spliteText(birth_info, length, 6);
                    for (let index = 0; index < res_text.length; index++) {
                        const element = res_text[index];
                        d3.select(this)
                            .append("tspan")
                            .text(function () {
                                return element;
                            })
                            .attr({
                                x: function () {
                                    if (index > 0) return 0
                                },
                                dy: function () {
                                    if (index > 0) return '1em'
                                },
                                'class': function () {
                                    if (index == 0) return 'nextString'
                                },
                            })
                    }
                    if (birthSetting != "none") {
                        if (d.width < this.getBBox().width) d.width = this.getBBox().width;
                        if (d.depth <= 8) d.height = this.getBBox().height + d.height
                    }
                    if (!birth_height[d.id + d.depth]) birth_height[d.id + d.depth] = this.getBBox().height
                }
            })

        // death day and place
        node
            .append("text")
            .attr({
                'class': 'death',
                'fill': function (d) {
                    if (d.sex == 'M') return manColor
                    else return womanColor
                },
                'font-size': function (d) {
                    return textSize[5]
                },
                'font-family': fontFamily,
            })
            .each(function (d) {
                let place = (d.death && d.death.place) ? d.death.place : "n/a";
                let font_size = textSize[5]
                let death_info = (d.deathday ? d.deathday : '-.-.-') + ", " + place

                if (deathSetting != "none") {
                    if (death_info.includes('n/a') || death_info.includes('.-') || death_info.includes('-.')) {
                        d.warning = true;
                    }
                }

                let length = Math.floor((treeHeight / maxGeneration) / font_size * 1.5)
                if (direction == '3' || direction == '4') {
                    length = Math.floor(treeHeight / (22 + Math.max(0, children.length - 10)) / font_size * 1.5)
                }
                if ((localStorage.getItem('death_hide_empty') === 'true') && death_info === '-.-.-, n/a') {
                    console.log('empty')
                }
                else {
                    d3.select(this)
                        .append("tspan")
                        .text(function () {
                            return deceasedText;
                        })
                        .attr({
                            'font-weight': "bold"
                        })
                    var res_text = spliteText(death_info, length, 9);
                    for (let index = 0; index < res_text.length; index++) {
                        const element = res_text[index];
                        d3.select(this)
                            .append("tspan")
                            .text(function () {
                                return element;
                            })
                            .attr({
                                x: function () {
                                    if (index > 0) return 0
                                },
                                dy: function () {
                                    if (index > 0) return '1em'
                                },
                                'class': function () {
                                    if (index == 0) return 'nextString'
                                },
                            })
                    }
                    if (deathSetting != "none" && d.depth <= 8) {
                        if (d.width < this.getBBox().width) d.width = this.getBBox().width;
                        d.height = this.getBBox().height + d.height
                    }
                    if (!death_height[d.id + d.depth]) death_height[d.id + d.depth] = this.getBBox().height
                }
            });

        // note
        node
            .append("text")
            .attr({
                'class': 'note',
                'fill': function (d) {
                    if (d.sex == 'M') return manColor
                    else return womanColor
                },
                'font-size': function (d) {
                    return textSize[5] / 2
                },
                'font-family': fontFamily,
                "display": function (d) {
                    if (d.note == "") return 'none'
                    else return 'block'
                },
            })
            .each(function (d) {
                let note = d.note;
                let font_size = textSize[5] / 2

                let length = Math.floor((treeHeight / maxGeneration) / font_size * 1.5)
                if (direction == '3' || direction == '4') {
                    length = Math.floor(treeHeight / (22 + Math.max(0, children.length - 10)) / font_size * 1.5)
                }
                var res_text = [""]
                if (note != "" && note != null) {
                    res_text = spliteText(note, length, 1);
                }

                for (let index = 0; index < res_text.length; index++) {
                    const element = res_text[index];
                    d3.select(this)
                        .append("tspan")
                        .text(function () {
                            return element;
                        })
                        .attr({
                            x: function () {
                                return 0
                            },
                            dy: function () {
                                if (index > 0) return '1em'
                            },
                        })

                }
                if (d.note != "") {
                    if (d.width < this.getBBox().width) d.width = this.getBBox().width;
                    d.height = this.getBBox().height + d.height
                    note_height[d.id] = this.getBBox().height
                } else {
                    note_height[d.id] = 0
                }
            });

        node.selectAll(".avatar").attr({
            y: function (d) {
                return (-1) * d.height / 2
            },
            // opacity: nodeOpacity,
        })

        node.selectAll(".flag").attr({
            y: function (d) {
                return (-1) * d.height / 2
            },
            // opacity: nodeOpacity,
        })

        node.selectAll("tspan").attr({
            dx: function (d) {
                switch (text_align) {
                    case 'middle':
                        return 0;
                    case 'start':
                        return (-1) * d.width / 2;
                    default:
                        return d.width / 2;
                }
            },
            "text-anchor": text_align,
            // opacity: nodeOpacity,
        })

        node.selectAll(".name_span").attr({
            dx: function (d) {
                switch (name_text_align) {
                    case 'middle':
                        return 0;
                    case 'start':
                        return (-1) * d.width / 2;
                    default:
                        return d.width / 2;
                }
            },
            "text-anchor": name_text_align
        })

        node.selectAll(".nextString").attr({
            dx: 0
        })

        node.selectAll(".name").attr({
            dy: function (d) {
                if (d.avatar_setting != "SHOW" || profile_setting != "SHOW") {
                    if (flag_setting != "SHOW" || d.country == "NoFlag") {
                        return (-1) * d.height / 2 + textSize[5]
                    } else {
                        return (-1) * d.height / 2 + flagSize[5] + textSize[5]
                    }
                } else {
                    return (-1) * d.height / 2 + imgSize[5] + textSize[5]
                }
            },
        })

        node.selectAll(".birth").attr({
            dy: function (d) {
                if (d.avatar_setting != "SHOW" || profile_setting != "SHOW") {
                    if (flag_setting != "SHOW" || d.country == "NoFlag") {
                        return (-1) * d.height / 2 + textSize[5] + name_height[d.id + d.depth]
                    } else {
                        return (-1) * d.height / 2 + flagSize[5] + textSize[5] + name_height[d.id + d.depth]
                    }
                } else {
                    return (-1) * d.height / 2 + imgSize[5] + textSize[5] + name_height[d.id + d.depth]
                }
            },
            display: function (d) {
                if (birthSetting == "none") {
                    return "none"
                }
            }
        })

        node.selectAll(".death").attr({
            dy: function (d) {
                var temp = 0
                if (d.avatar_setting != "SHOW" || profile_setting != "SHOW") {
                    if (flag_setting == "SHOW" && d.country != "NoFlag") {
                        temp = flagSize[5] + textSize[5] + name_height[d.id + d.depth]
                    } else {
                        temp = textSize[5] + name_height[d.id + d.depth]
                    }
                } else {
                    temp = imgSize[5] + textSize[5] + name_height[d.id + d.depth]
                }

                if (birthSetting != 'none') {
                    temp += birth_height[d.id + d.depth]
                }

                return (-1) * d.height / 2 + temp
            },
            display: function (d) {
                if (deathSetting == "none") {
                    return "none"
                }
            }
        })

        node.selectAll(".note").attr({
            dy: function (d) {
                var temp = 0
                if (d.avatar_setting != "SHOW" || profile_setting != "SHOW") {
                    if (flag_setting == "SHOW" && d.country != "NoFlag") {
                        temp = flagSize[5] + textSize[5] / 2 + name_height[d.id + d.depth]
                    } else {
                        temp = textSize[5] / 2 + name_height[d.id + d.depth]
                    }
                } else {
                    temp = imgSize[5] + textSize[5] / 2 + name_height[d.id + d.depth]
                }

                if (birthSetting != 'none') {
                    temp += birth_height[d.id + d.depth]
                }
                if (deathSetting != 'none') {
                    temp += death_height[d.id + d.depth]
                }
                return (-1) * d.height / 2 + temp
            },
        })

        node
            .select("rect")
            .attr({
                x: function (d) {
                    return -(d.width * 1.1 + 20) / 2;
                },
                fill: function (d) {
                    if (d.sex == 'M') return maleNodeColor
                    else return femaleNodeColor
                },
                y: function (d) {
                    return -(d.height + 20) / 2;
                },
                width: function (d) {
                    return d.width * 1.1 + 20;
                },
                height: function (d) {
                    return d.height + 20;
                },
                stroke: function (d) {
                    return borderColor
                },
                // display: function (d) {
                //     if (d.id.substring(0, 5) == 'fake_') {
                //         return empty_node_setting
                //     }
                // },
                rx: function (d) {
                    return borderRadius;
                },
                "stroke-width": function (d) {
                    return borderWidth;
                },
                "fill-opacity": function (d) {
                    if (d.id.substring(0, 5) == 'fake_' && empty_node_setting == 'none') {
                        return 0
                    }
                },
            })

        node
            .append('image')
            .attr({
                'class': 'warning',
                'xlink:href': function (d) {
                    return GlobalConstants.warning
                },
                'width': function (d) {
                    return imgSize[5] / 2
                },
                'height': function (d) {
                    return imgSize[5] / 2
                },
                "x": function (d) {
                    return -(d.width * 1.1 + 20) / 2 - imgSize[5] / 4;
                },
                y: function (d) {
                    return -(d.height + 20) / 2;
                },
                "display": function (d) {
                    if (d.warning && warning_setting == "SHOW") {
                        if (d.id.substring(0, 5) == 'fake_') {
                            return empty_node_setting
                        }
                        return 'block';
                    } else {
                        return 'none';
                    }
                },
            })
    }

    addbackground(data) {
        localStorage.setItem('background', data)
        this.showLoader = true;
        d3
            .select('svg')
            .select('g')
            .select('image')
            .attr('width', 0)
            .attr('height', 0)
            .attr('x', 0)
            .attr('y', 0)
        d3
            .select('svg')
            .select('g')
            .select('rect')
            .attr('width', 0)
            .attr('height', 0)
            .attr('x', 0)
            .attr('y', 0)

        var svgt = document.querySelector('svg');
        const gg = svgt.querySelector('g')
        boxSize = gg.getBBox()
        if (data[0] != '#') {
            background = data

            var xhr = new XMLHttpRequest();
            xhr.open("GET", background, true);
            xhr.responseType = "blob";
            xhr.onload = function (e) {
                var reader = new FileReader();
                reader.onload = function (event) {
                    var res = event.target.result;
                    let image = res;
                    var img = new Image();
                    img.src = image.toString();
                    img.onload = async function () {


                        let w2 = boxSize.width * (1 + 0.01 * parseFloat(global_padding));
                        let h2 = boxSize.height * (1 + 0.01 * parseFloat(global_padding));

                        let w1 = img.width;
                        let h1 = img.height;

                        let rate = Math.max(w2 / w1, h2 / h1)

                        let x = boxSize.x - (w1 * rate - boxSize.width) / 2;
                        let y = boxSize.y - (h1 * rate - boxSize.height) / 2;

                        d3
                            .select('svg')
                            .select('g')
                            .select('image')
                            .attr('xlink:href', image)
                            .attr('width', w1 * rate)
                            .attr('height', h1 * rate)
                            .attr('x', x)
                            .attr('y', y)

                    }
                }
                var file = this.response;
                reader.readAsDataURL(file)
            };
            xhr.send()
        } else if (data[0] === '#' || data == "transparent") {

            var backgroundColor = data;
            d3
                .select('svg')
                .select('g')
                .select('rect')
                .attr('fill', backgroundColor)
                .attr('width', boxSize.width * 1.05)
                .attr('height', boxSize.height * 1.05)
                .attr('x', boxSize.x - boxSize.width * 0.025)
                .attr('y', boxSize.y - boxSize.height * 0.025)
        }
        this.showLoader = false; console.log('Loader off')
    }

    generate() {
        var svg = document.querySelector('svg'); // clone your original svg
        var g = svg.querySelector('g') // select the parent g

        d3.select('body')
            .select('svg')
            .append('text')
            .attr({
                "x": 0,
                "y": 0,
                "text-anchor": "middle",
                'class': 'watermark',
                'fill': function (d) {
                    return '#000'
                },
                'font-size': function (d) {
                    switch (papertype) {
                        case "A1":
                            return 400;
                        case "A2":
                            return 300;
                        case "A3":
                            return 200;
                        case "A4":
                            return 100;
                        case "A0":
                            return 500;
                        default:
                            return 500;
                    }
                },
                'font-family': fontFamily,
                "transform": "translate(" + g.getBBox().width / 2 * (0.1) + ", " + g.getBBox().height / 2 * 0.1 + ") rotate(-45) ",
                'opacity': this.back_Opacity
            })
            .text(function (d) {
                return "Ancytree Preview";
            })

        svg = document.querySelector('svg'); // clone your original svg
        g = svg.querySelector('g') // select the parent g

        let width = g.getBBox().width / 10 + 100
        let height = g.getBBox().height / 10 + 100

        var pdf
        if (width > height) {
            pdf = new jspdf('l', 'pt', [width, height]);
        }
        else {
            pdf = new jspdf('p', 'pt', [width, height]);
        }

        g.setAttribute('transform', "translate(" + Math.abs(g.getBBox().x / 10 - 50) + "," + Math.abs(g.getBBox().y / 10 - 50) + ") scale(0.1)") // clean transform
        svg.setAttribute('width', (g.getBBox().width / 10 + 100).toString()) // set svg to be the g dimensions
        svg.setAttribute('height', (g.getBBox().height / 10 + 100).toString())
        const svgAsXML = (new XMLSerializer).serializeToString(svg);

        const svgData = `data:image/svg+xml,${encodeURIComponent(svgAsXML)}`
        const dialogConfig = new MatDialogConfig();
        // The user can't close the dialog by clicking outside its body
        dialogConfig.disableClose = false;
        dialogConfig.data = svgData;

        let previewDialog = this.matDialog.open(PreviewComponent, dialogConfig);
        previewDialog.afterClosed().subscribe((result) => {
            d3.select('.watermark').remove();
        });
    }
    saveSvg() {
        var svg = document.querySelector('svg'); // clone your original svg
        var g = svg.querySelector('g') // select the parent g

        svg = document.querySelector('svg'); // clone your original svg
        g = svg.querySelector('g') // select the parent g

        g.setAttribute('transform', "translate(" + Math.abs(g.getBBox().x / 10 - 50) + "," + Math.abs(g.getBBox().y / 10 - 50) + ") scale(0.1)") // clean transform
        svg.setAttribute('width', (g.getBBox().width / 10 + 100).toString()) // set svg to be the g dimensions
        svg.setAttribute('height', (g.getBBox().height / 10 + 100).toString())
        const svgAsXML = (new XMLSerializer).serializeToString(svg);

        const svgData = `data:image/svg+xml,${encodeURIComponent(svgAsXML)}`
        let svgSource = svgAsXML

        //add name spaces.
        if (!svgSource.match(/^<svg[^>]+xmlns="http\:\/\/www\.w3\.org\/2000\/svg"/)) {
            svgSource = svgSource.replace(/^<svg/, '<svg xmlns="http://www.w3.org/2000/svg"');
        }
        if (!svgSource.match(/^<svg[^>]+"http\:\/\/www\.w3\.org\/1999\/xlink"/)) {
            svgSource = svgSource.replace(/^<svg/, '<svg xmlns:xlink="http://www.w3.org/1999/xlink"');
        }

        //add xml declaration
        svgSource = '<?xml version="1.0" standalone="no"?>\r\n' + svgSource;

        const blob = new Blob([svgSource], {
            type: ''
        });
        this.fileUrl = this.sanitizer.bypassSecurityTrustResourceUrl(window.URL.createObjectURL(blob));
    }

    selectTreeType(direction) {
        this.showLoader = true;

        name_height = {}
        birth_height = {}
        marriage_height = {}
        death_height = {}
        d3
            .select('svg')
            .remove()
        localStorage.setItem("direction", direction);
        this.ApiService.getNodes(this.gedcom_id).then(data => {
            try {
                Object.values(data).forEach(element => {
                    this.nodeinfos[element['id']] = element
                });
                
                if (direction == 5) {
                    this.fromCenterTree()
                    imgSizeGroup = imgSizeGroup3, flagSizeGroup = flagSizeGroup3, textSizeGroup = textSizeGroup3;
                }
                else {
                    if (direction == 1 || direction == 2) {
                        imgSizeGroup = imgSizeGroup1, flagSizeGroup = flagSizeGroup1, textSizeGroup = textSizeGroup1;
                    } else if (direction == 3 || direction == 4) {
                        imgSizeGroup = imgSizeGroup2, flagSizeGroup = flagSizeGroup2, textSizeGroup = textSizeGroup2;
                    }
                    this.buildTree(direction)
                }

            } catch (error) {
                console.log(error);

            }
        })
    }

    // zoom
    fromCenterTree() {
        let bornText = this.nodeBornText
        let marriedText = this.nodeMarriedText
        let deceasedText = this.nodeDeceasedText
        node_width = treeWidth / (2 * maxGeneration - 2.5)

        this.relation = this.nodeinfos[this._id];
        var father_relation = this.nodeinfos[this.nodeinfos[this._id]['father']]
        father_relation['c_fam'] = this.nodeinfos[this._id].famc
        this.parentRelation(this.nodeinfos[this.nodeinfos[this._id]['father']], 0);
        var mother_relation = this.nodeinfos[this.nodeinfos[this._id]['mother']]
        mother_relation['c_fam'] = this.nodeinfos[this._id].famc
        this.childrenRelation(this.nodeinfos[this.nodeinfos[this._id]['mother']], 0)

        this.relation['_children'] = [];
        this.relation['_parents'] = [];
        this.relation['_children'].push(mother_relation);
        this.relation['_parents'].push(father_relation);
        let nodeData = this.nodeinfos
        
        var dirction_t = 1;
        var ancestorRoot,
            descendantRoot;

        var duration = 750;
        var zoom = d3
            .behavior
            .zoom()
            .scaleExtent([.1, 10])
            .on('zoom', function () {
                svg.attr("transform", "translate(" + d3.event.translate + ") scale(" + d3.event.scale / 10 + ")");
                start_x = d3.event.translate[0];
                start_y = d3.event.translate[1];
                start_scale = d3.event.scale / 10;
            })

        var svg = d3
            .select('body .tree-body')
            .append('svg')
            .attr('width', '100%')
            .attr('height', '100%')
            .call(zoom)
            .append('g')
            .attr("transform", "translate(400,200)")
            .attr("padding", 100);

        svg.append('rect')
            .attr({
                width: 0,
                height: 0,
                x: 0,
                y: 0
            })

        svg.append('image')
            .attr('width', 0)
            .attr('height', 0)
            .attr('x', 0)
            .attr('y', 0)
            .attr('opacity', this.back_Opacity)

        svg
            .append('style')
            .text(`
            text {
            }
            
            .person {
                cursor: pointer;
            }
            
            .link {
                fill: none;
                stroke: #ccc;
                stroke-width: 20px;
            }`);

        svg.append('line')
            .style("stroke", "#ccc")
            .style("stroke-width", "20px")
            .attr("x1", 0)
            .attr("y1", 0)
            .attr("x2", 0)
            .attr("y2", -imgSize[1] - 3 * textSize[1]);
        var ancestorsTree = d3
            .layout
            .tree()
            .nodeSize([treeHeight / Math.pow(2, (maxGeneration - 3)), node_width])
            .separation(function () {
                return .5;
            })
            .children(function (person) {
                return person._parents;
            });
        var descendantsTree = d3
            .layout
            .tree()
            .nodeSize([treeHeight / Math.pow(2, (maxGeneration - 3)), node_width])
            .separation(function () {
                return .5;
            })
            .children(function (person) {
                return person._children;
            });
        ancestorRoot = rootProxy(this.relation);
        descendantRoot = rootProxy(this.relation);

        drawAncestors();
        drawDescendants();

        function rootProxy(root) {
            return {
                avatar_type: typeof root.url == 'number' ? 'sample' : 'updated',
                firstName: root.firstName,
                lastName: root.lastName,
                country: root.country,
                sex: root.sex,
                birth: root.birth,
                death: root.death,
                marriage: root.marriage,
                birthday: root.birthday,
                deathday: root.deathday,
                url: root.url,
                id: root.id,
                x0: 0,
                y0: 0,
                note: root.note,
                avatar_setting: root.avatar_setting,
                _children: root._children,
                _parents: root._parents
            };
        }

        function drawAncestors() {
            draw(ancestorsTree, ancestorRoot, 'ancestor', 1);
        }

        function drawDescendants() {
            draw(descendantsTree, descendantRoot, 'descendant', -1);
        }

        async function draw(tree, root, displayClass, direction) {

            var nodes = tree.nodes(root);
            for (let index = 0; index < nodes.length; index++) {
                const element = nodes[index];
                const half = (maxGeneration - 2) / 2;
                if (element.depth != 0) {
                    nodes[index].y += 400 * (half * element.depth - (Math.pow(element.depth - 1, 2) + element.depth + 1) / 2)
                    nodes[index].y -= 250
                }
            }
            var links = tree.links(nodes);

            var link = svg
                .selectAll("path.link." + displayClass)
                .data(links);
            link
                .enter()
                .append("path")
                .attr({
                    "class": "link " + displayClass,
                    "display": function (d) {
                        if (d.target.id.substring(0, 5) == 'fake_') {
                            return empty_node_setting
                        } else {
                            return "block"
                        }
                    }
                })
            link
                .transition()
                .duration(duration)
                .attr("d", function (d) {
                    return elbow(d, direction);
                });

            var node = svg
                .selectAll("g.person." + displayClass)
                .data(nodes);

            var nodeEnter = node
                .enter()
                .append("g")
                .attr("class", "person " + displayClass)
                .on('click', editModal);

            function editModal(d) {

                const dialogConfig = new MatDialogConfig();
                // The user can't close the dialog by clicking outside its body
                dialogConfig.disableClose = false;
                dialogConfig.id = "modal-component";
                if (d.depth > 3 && d.depth <= 6) dialogConfig.height = "70vh";
                else if (d.depth > 6 && d.depth <= 8) dialogConfig.height = "50vh";
                else if (d.depth > 8) dialogConfig.height = "20vh";
                else dialogConfig.height = "90vh";
                dialogConfig.width = "500px";
                dialogConfig.data = d

                const modalDialog = singleModal.open(ModalComponent, dialogConfig);
                modalDialog.afterClosed().subscribe((result) => {
                    if (result) {
                        document.getElementById('submit-setting').click();
                        window.location.reload();

                    }
                });
            };

            nodeEnter
                .append("rect")


            //hide empty nodes and apply opacity to node background
            nodeEnter.attr({
                "opacity": function (d) {
                    if (d.id.substring(0, 5) == 'fake_' && empty_node_setting == 'none') {
                        return 0
                    }
                    else {
                        return 1
                    }
                },
                "fill-opacity": function (d) {
                    if (d.depth == 0 && displayClass == 'descendant') {
                        return 0
                    }
                    else {
                        return nodeOpacity
                    }
                },
            })

            var nodeUpdate = node
                .transition()
                .duration(duration)
                .attr("transform", function (d) {
                    switch (dirction_t) {
                        case 1:
                            return "translate(" + (direction * d.y) + "," + d.x + ")";
                        default:
                            return "translate(" + d.x + "," + (direction * d.y) + ")";
                    }

                });
            node.each(function (d) {
                if (nodeData[d.id]) {
                    nodeData[d.id].mainDisplay = true
                    let warning = false
                    let name = (d.firstName ? d.firstName : 'n/a') + " " + (d.lastName ? d.lastName : 'n/a')

                    if (name.includes('n/a')) {
                        warning = true;
                    }

                    let place = (d.birth && d.birth.place) ? d.birth.place : "n/a";
                    let birth_info = (d.birthday ? d.birthday : '-.-.-') + ", " + place
                    if (birthSetting != "none" && d.depth <= 8) {
                        if (birth_info.includes('n/a') || birth_info.includes('.-') || birth_info.includes('-.')) {
                            warning = true;
                        }
                    }

                    let deathplace = (d.death && d.death.place) ? d.death.place : "n/a";
                    let death_info = (d.deathday ? d.deathday : '-.-.-') + ", " + deathplace
                    if (deathSetting != "none" && d.depth <= 8) {
                        if (death_info.includes('n/a') || death_info.includes('.-') || death_info.includes('-.')) {
                            warning = true;
                        }
                    }

                    if (warning) {
                        nodeData[d.id].warning = true
                        d.warning = true
                    } else {
                        nodeData[d.id].warning = false
                        d.warning = false
                    }
                }
            })
           
            //image
            node
                .append('image')
                .attr({
                    'class': 'avatar',
                    'xlink:href': function (d) {
                        if (d.avatar_type == "sample") {
                            if (d.sex == 'M') {
                                return maleAvatar[parseInt(d.url)]
                            } else {
                                return femaleAvatar[parseInt(d.url)]
                            }
                        } else if (typeof d.url == "number") {
                            if (d.sex == 'M') {
                                return maleAvatar[parseInt(d.url)]
                            } else {
                                return femaleAvatar[parseInt(d.url)]
                            }
                        } else {
                            return d.url;
                        }
                    },
                    'width': function (d) {
                        if (d.depth < 6) {
                            return imgSize[d.depth]
                        } else {
                            return 0
                        }
                    },
                    'height': function (d) {
                        if (d.depth < 6) {
                            return imgSize[d.depth]
                        } else {
                            return 0
                        }
                    },
                    "x": function (d) {
                        if (d.depth < 6) {
                            if (flag_setting != "SHOW" || d.country == "NoFlag" || d.depth > 5) {
                                return -imgSize[d.depth] / 2 - 100
                            }
                            return -imgSize[d.depth] / 2 - flagSize[d.depth] / 2 - 100
                        } else {
                            return 0
                        }
                    },
                    "display": function (d) {
                        if (profile_setting != "SHOW") {
                            return "none"
                        }
                        else if (d.depth > 5) {
                            return "none"
                        }
                        else if (d.avatar_setting != "SHOW") {
                            return "none"
                        }
                        else if (d.id.substring(0, 5) == 'fake_') {
                            return empty_node_setting
                        }
                        else {
                            return "block"
                        }
                    },

                }).each(function (d) {
                    d.height = this.getBBox().height
                    if (d.depth < 6) {
                        if (flag_setting != "SHOW" || d.country == "NoFlag" || d.depth > 5) {
                            return d.width = this.getBBox().width + 200
                        }
                        return d.width = this.getBBox().width + flagSize[d.depth] + 200
                    } else {
                        return d.width = this.getBBox().width
                    }
                })
            //flag
            node
                .append('image')
                .attr({
                    'class': 'flag',
                    'xlink:href': function (d) {
                        if (!d.country || d.country == "") {
                            return Flags.flags['Sweden']
                        } else if (d.country == "NoFlag") {
                            return Flags.flags['Sweden']
                        } else if (d.country == "custom") {
                            return d.c_flag
                        }
                        else {
                            return Flags.flags[d.country]
                        }
                    },
                    'width': function (d) {
                        if (d.depth < 6) {
                            return flagSize[d.depth]
                        } else {
                            return 0
                        }
                    },
                    "x": function (d) {
                        if (d.depth < 6) {
                            return imgSize[d.depth] / 2 - flagSize[d.depth] / 2 + 100
                        } else {
                            return 0
                        }
                    },
                    "display": function (d) {
                        if (flag_setting != "SHOW") {
                            return "none"
                        }
                        else if (d.country == "NoFlag") {
                            return "none"
                        }
                        else if (d.depth > 5) {
                            return "none"
                        }
                        else if (d.id.substring(0, 5) == 'fake_') {
                            return empty_node_setting
                        }
                        else {
                            return 'block'
                        }

                    },

                }).each(function (d) {
                    if (profile_setting != "SHOW" || d.avatar_setting != "SHOW") {
                        d.height = this.getBBox().height
                    }
                })

            //first name and last name
            node
                .append("text")
                .attr({
                    "dx": 0,
                    "text-anchor": "middle",
                    'class': 'name',
                    'fill': function (d) {
                        if (d.sex == 'M') return manColor
                        else return womanColor
                    },
                    "display": function (d) {
                        if (d.id.substring(0, 5) == 'fake_') {
                            return empty_node_setting
                        }
                    },
                    'font-size': function (d) {
                        let font_size
                        if (d.depth <= 9) {
                            font_size = textSize[d.depth]
                        } else {
                            font_size = textSize[9]
                        }
                        return font_size
                    },
                    'font-family': fontFamily,
                })
                .each(function (d) {
                    let font_size
                    if (d.depth <= 9) {
                        font_size = textSize[d.depth]
                    } else {
                        font_size = textSize[9]
                    }
                    let name = (d.firstName ? d.firstName : 'n/a') + " " + (d.lastName ? d.lastName : 'n/a')

                    if (name.includes('n/a')) {
                        d.warning = true;
                    }

                    let length
                    if (d.depth == 0) {
                        length = Math.floor((node_width + 400 * ((maxGeneration / 2 - 1) - d.depth)) / font_size * 1.5)
                    } else if (d.depth >= 8) {
                        length = 70
                    }
                    else {
                        length = Math.floor((node_width + 400 * ((maxGeneration / 2 - 1) - d.depth)) / font_size * 1.6)
                    }



                    var res_text = spliteText(name, length, 0);
                    for (let index = 0; index < res_text.length; index++) {
                        const element = res_text[index];
                        d3.select(this)
                            .append("tspan")
                            .text(function () {
                                return element;
                            })
                            .attr({
                                x: function () {
                                    if (index > 0) return 0
                                },
                                dy: function () {
                                    if (index > 0) return '1em'
                                },
                                'class': 'name_span',
                            })

                    }


                    if (d.width < this.getBBox().width) d.width = this.getBBox().width;
                    d.height = this.getBBox().height + d.height
                    if (!name_height[d.id + d.depth]) name_height[d.id + d.depth] = this.getBBox().height
                });

            // birthday and place
            node
                .append("text")
                .attr({
                    "dx": 0,
                    "text-anchor": "middle",
                    'class': 'birth',
                    'fill': function (d) {
                        if (d.sex == 'M') return manColor
                        else return womanColor
                    },
                    'font-size': function (d) {
                        if (d.depth <= 9) {
                            return textSize[d.depth]
                        } else {
                            return textSize[9]
                        }
                    },
                    'font-family': fontFamily,
                    "display": function (d) {
                        if (d.depth > 8) {
                            return "none"
                        }
                        if (d.id.substring(0, 5) == 'fake_') {
                            return empty_node_setting
                        }

                    },
                })

                .each(function (d) {
                    let place = (d.birth && d.birth.place) ? d.birth.place : "n/a";

                    let font_size
                    if (d.depth < 9) {
                        font_size = textSize[d.depth]
                    } else {
                        font_size = textSize[9]
                    }
                    let birth_info = (d.birthday ? d.birthday : '-.-.-') + ", " + place

                    if (birthSetting != "none" && d.depth <= 8) {
                        if (birth_info.includes('n/a') || birth_info.includes('.-') || birth_info.includes('-.')) {
                            d.warning = true;
                        }
                    }

                    if (d.depth == 0) {
                        length = Math.floor((node_width + 400 * ((maxGeneration / 2 - 1) - d.depth)) / font_size * 1.5)
                    } else if (d.depth >= 8) {
                        length = 70
                    } else {
                        length = Math.floor((node_width + 400 * ((maxGeneration / 2 - 1) - d.depth)) / font_size * 1.6)
                    }
                    if ((localStorage.getItem('birth_hide_empty') === 'true') && birth_info === '-.-.-, n/a') {
                        console.log('empty')
                    }
                    else {
                        if (d.depth < 6) {
                            d3.select(this)
                                .append("tspan")
                                .text(function () {
                                    return bornText;
                                })
                                .attr({
                                    'font-weight': "bold"
                                })
                            var res_text = spliteText(birth_info, length, 6);
                            for (let index = 0; index < res_text.length; index++) {
                                const element = res_text[index];
                                d3.select(this)
                                    .append("tspan")
                                    .text(function () {
                                        return element;
                                    })
                                    .attr({
                                        x: function () {
                                            if (index > 0) return 0
                                        },
                                        dy: function () {
                                            if (index > 0) return '1em'
                                        },
                                        'class': function () {
                                            if (index == 0) return 'nextString'
                                        },
                                    })

                            }
                        }
                        else {
                            d3.select(this)
                                .append("tspan")
                                .text(function () {
                                    return "" + bornText.slice(0, 1) + ": ";
                                })
                                .attr({
                                    'font-weight': "bold"
                                })
                            var res_text = spliteText(birth_info, length, 3);
                            for (let index = 0; index < res_text.length; index++) {
                                const element = res_text[index];
                                d3.select(this)
                                    .append("tspan")
                                    .text(function () {
                                        return element;
                                    })
                                    .attr({
                                        x: function () {
                                            if (index > 0) return 0
                                        },
                                        dy: function () {
                                            if (index > 0) return '1em'
                                        },
                                        'class': function () {
                                            if (index == 0) return 'nextString'
                                        },
                                    })

                            }
                        }
                    }

                    if (birthSetting != "none" && d.depth <= 8) {
                        if (d.width < this.getBBox().width) d.width = this.getBBox().width;
                        if (d.depth <= 8) d.height = this.getBBox().height + d.height
                    }
                    if (!birth_height[d.id + d.depth]) birth_height[d.id + d.depth] = this.getBBox().height
                });

            //marriage day and place
            node
                .append("text")
                .attr({
                    "dx": 0,
                    "text-anchor": "middle",
                    'class': 'marriage',
                    'fill': function (d) {
                        if (d.sex == 'M') return manColor
                        else return womanColor
                    },
                    'font-size': function (d) {
                        if (d.depth <= 9) {
                            return textSize[d.depth]
                        } else {
                            return textSize[9]
                        }
                    },
                    'font-family': fontFamily,
                    "display": function (d) {
                        if (d.depth == 0 || d.depth > 6) {
                            return "none"
                        }
                        if (d.id.substring(0, 5) == 'fake_') {
                            return empty_node_setting
                        }

                    },
                })
                .each(function (d) {
                    if (d.depth != 0 && d.depth <= 6) {
                        let marriage_day = getMarriageDay(d);
                        let marriage_place = d.c_fam ? (d.marriage[d.c_fam] ? d.marriage[d.c_fam]['place'] : "n/a") : "n/a";
                        let font_size
                        if (d.depth < 9) {
                            font_size = textSize[d.depth]
                        } else {
                            font_size = textSize[9]
                        }
                        let marriage_info = (marriage_day ? marriage_day : '-.-.-') + ", " + marriage_place

                        if (marriageSetting != "none" && d.depth != 0 && d.depth <= 6) {
                            if (marriage_info.includes('n/a') || marriage_info.includes('.-') || marriage_info.includes('-.')) {
                                d.warning = true;
                            }
                        }

                        if (d.depth == 0) {
                            length = Math.floor((node_width + 400 * ((maxGeneration / 2 - 1) - d.depth)) / font_size * 1.5) * 1.6
                        } else if (d.depth >= 8) {
                            length = 70
                        } else {
                            length = Math.floor((node_width + 400 * ((maxGeneration / 2 - 1) - d.depth)) / font_size * 1.6)
                        }

                        if ((localStorage.getItem('marriage_hide_empty') === 'true') && marriage_info === '-.-.-, n/a') {
                            console.log('empty')
                        }
                        else {
                            if (d.depth < 6) {
                                d3.select(this)
                                    .append("tspan")
                                    .text(function () {
                                        return marriedText;
                                    })
                                    .attr({
                                        'font-weight': "bold"
                                    })
                                var res_text = spliteText(marriage_info, length, 9);
                                for (let index = 0; index < res_text.length; index++) {
                                    const element = res_text[index];
                                    d3.select(this)
                                        .append("tspan")
                                        .text(function () {
                                            return element;
                                        })
                                        .attr({
                                            x: function () {
                                                if (index > 0) return 0
                                            },
                                            dy: function () {
                                                if (index > 0) return '1em'
                                            },
                                            'class': function () {
                                                if (index == 0) return 'nextString'
                                            },
                                        })

                                }
                            } else {
                                d3.select(this)
                                    .append("tspan")
                                    .text(function () {
                                        return "" + marriedText.slice(0, 1) + ": ";
                                    })
                                    .attr({
                                        'font-weight': "bold"
                                    })
                                var res_text = spliteText(marriage_info, length, 3);
                                for (let index = 0; index < res_text.length; index++) {
                                    const element = res_text[index];
                                    d3.select(this)
                                        .append("tspan")
                                        .text(function () {
                                            return element;
                                        })
                                        .attr({
                                            x: function () {
                                                if (index > 0) return 0
                                            },
                                            dy: function () {
                                                if (index > 0) return '1em'
                                            },
                                            'class': function () {
                                                if (index == 0) return 'nextString'
                                            },
                                        })

                                }
                            }
                        }
                    }
                    if (marriageSetting != "none" && d.depth != 0 && d.depth <= 6) {
                        if (d.width < this.getBBox().width) d.width = this.getBBox().width;
                        if (d.depth != 0 && d.depth <= 6) d.height = this.getBBox().height + d.height
                    }
                    if (!marriage_height[d.id + d.depth]) marriage_height[d.id + d.depth] = this.getBBox().height
                });



            // death day and place
            node
                .append("text")
                .attr({
                    "dx": 0,
                    "text-anchor": "middle",
                    'class': 'death',
                    'fill': function (d) {
                        if (d.sex == 'M') return manColor
                        else return womanColor
                    },
                    'font-size': function (d) {
                        if (d.depth <= 9) {
                            return textSize[d.depth]
                        } else {
                            return textSize[9]
                        }
                    },
                    'font-family': fontFamily,
                    "display": function (d) {
                        if (d.depth > 8) {
                            return "none"
                        }
                        if (d.id.substring(0, 5) == 'fake_') {
                            return empty_node_setting
                        }

                    },
                })
                .each(function (d) {
                    let place = (d.death && d.death.place) ? d.death.place : "n/a";
                    let font_size
                    if (d.depth < 9) {
                        font_size = textSize[d.depth]
                    } else {
                        font_size = textSize[9]
                    }
                    let death_info = (d.deathday ? d.deathday : '-.-.-') + ", " + place

                    if (deathSetting != "none" && d.depth <= 8) {
                        if (death_info.includes('n/a') || death_info.includes('.-') || death_info.includes('-.')) {
                            d.warning = true;
                        }
                    }

                    if (d.depth == 0) {
                        length = Math.floor((node_width + 400 * ((maxGeneration / 2 - 1) - d.depth)) / font_size * 1.5)
                    } else if (d.depth >= 8) {
                        length = 70
                    } else {
                        length = Math.floor((node_width + 400 * ((maxGeneration / 2 - 1) - d.depth)) / font_size * 1.6)
                    }
                    if ((localStorage.getItem('death_hide_empty') === 'true') && death_info === '-.-.-, n/a') {
                        console.log('empty')
                    }
                    else {
                        if (d.depth < 6) {
                            d3.select(this)
                                .append("tspan")
                                .text(function () {
                                    return deceasedText;
                                })
                                .attr({
                                    'font-weight': "bold"
                                })
                            var res_text = spliteText(death_info, length, 9);
                            for (let index = 0; index < res_text.length; index++) {
                                const element = res_text[index];
                                d3.select(this)
                                    .append("tspan")
                                    .text(function () {
                                        return element;
                                    })
                                    .attr({
                                        x: function () {
                                            if (index > 0) return 0
                                        },
                                        dy: function () {
                                            if (index > 0) return '1em'
                                        },
                                        'class': function () {
                                            if (index == 0) return 'nextString'
                                        },
                                    })

                            }
                        } else {

                            d3.select(this)
                                .append("tspan")
                                .text(function () {
                                    return "" + deceasedText.slice(0, 1) + ": ";
                                })
                                .attr({
                                    'font-weight': "bold"
                                })
                            var res_text = spliteText(death_info, length, 3);
                            for (let index = 0; index < res_text.length; index++) {
                                const element = res_text[index];
                                d3.select(this)
                                    .append("tspan")
                                    .text(function () {
                                        return element;
                                    })
                                    .attr({
                                        x: function () {
                                            if (index > 0) return 0
                                        },
                                        dy: function () {
                                            if (index > 0) return '1em'
                                        },
                                        'class': function () {
                                            if (index == 0) return 'nextString'
                                        },
                                    })
                            }
                        }

                        if (deathSetting != "none" && d.depth <= 8) {
                            if (d.width < this.getBBox().width) d.width = this.getBBox().width;
                            if (d.depth <= 8) d.height = this.getBBox().height + d.height
                        }
                        if (!death_height[d.id + d.depth]) death_height[d.id + d.depth] = this.getBBox().height
                    }
                });

            // note
            node
                .append("text")
                .attr({
                    "dx": 0,
                    'class': 'note',
                    'fill': function (d) {
                        if (d.sex == 'M') return manColor
                        else return womanColor
                    },
                    'font-size': function (d) {
                        if (d.depth <= 9) {
                            return textSize[d.depth] / 2
                        } else {
                            return textSize[9] / 2
                        }
                    },
                    'font-family': fontFamily,
                    "display": function (d) {
                        if (d.note == "") return 'none'
                        else return 'block'
                    },
                })
                .each(function (d) {
                    let note = d.note;
                    let font_size
                    if (d.depth < 9) {
                        font_size = textSize[d.depth] / 2
                    } else {
                        font_size = textSize[9] / 2
                    }

                    if (d.depth == 0) {
                        length = Math.floor((node_width + 400 * ((maxGeneration / 2 - 1) - d.depth)) / font_size * 1.5) * 1.6
                    } else if (d.depth >= 8) {
                        length = 70
                    } else {
                        length = Math.floor((node_width + 400 * ((maxGeneration / 2 - 1) - d.depth)) / font_size * 1.6)
                    }
                    var res_text = [""]
                    if (note != "" && note != null) {
                        res_text = spliteText(note, length, 1);
                    }

                    for (let index = 0; index < res_text.length; index++) {
                        const element = res_text[index];
                        d3.select(this)
                            .append("tspan")
                            .text(function () {
                                return element;
                            })
                            .attr({
                                x: function () {
                                    return 0
                                },
                                dy: function () {
                                    if (index > 0) return '1em'
                                },
                            })

                    }
                    if (d.note != "") {
                        if (d.width < this.getBBox().width) d.width = this.getBBox().width;
                        d.height = this.getBBox().height + d.height
                        note_height[d.id] = this.getBBox().height
                    } else {
                        note_height[d.id] = 0
                    }
                });

            node.selectAll("tspan").attr({
                dx: function (d) {
                    switch (text_align) {
                        case 'middle':
                            return 0;
                        case 'start':
                            return (-1) * d.width / 2;
                        default:
                            return d.width / 2;
                    }
                },
                "text-anchor": text_align,
                // opacity: nodeOpacity
            })

            node.selectAll(".name_span").attr({
                dx: function (d) {
                    switch (name_text_align) {
                        case 'middle':
                            return 0;
                        case 'start':
                            return (-1) * d.width / 2;
                        default:
                            return d.width / 2;
                    }
                },
                "text-anchor": name_text_align
            })

            node.selectAll(".nextString").attr({
                dx: 0
            })

            node.selectAll(".avatar").attr({
                y: function (d) {
                    if (d.depth == 0) {
                        return (-1) * d.height / 2 - (imgSize[0] + 5 * textSize[0])
                    }
                    return (-1) * d.height / 2
                },
                // opacity: nodeOpacity,
            })
            node.selectAll(".flag").attr({
                y: function (d) {
                    if (d.depth == 0) {
                        return (-1) * d.height / 2 - (imgSize[0] + 5 * textSize[0])
                    }
                    return (-1) * d.height / 2
                },
                // opacity: nodeOpacity,
            })

            node.selectAll(".name").attr({
                dy: function (d) {
                    if (d.depth == 0) {
                        if (d.avatar_setting != "SHOW") {
                            return (-1) * d.height / 2 + textSize[0] - (imgSize[0] + 5 * textSize[0])
                        }
                        else if (profile_setting != "SHOW" && flag_setting == "SHOW") {
                            return (-1) * d.height / 2 + flagSize[d.depth] + textSize[d.depth] - (imgSize[0] + 5 * textSize[0])
                        }
                        else {
                            return (-1) * d.height / 2 + imgSize[0] + textSize[0] - (imgSize[0] + 5 * textSize[0])
                        }
                    } else if (d.depth < 6) {
                        if (d.avatar_setting != "SHOW") {
                            return (-1) * d.height / 2 + textSize[d.depth]
                        }
                        if ((profile_setting != "SHOW" || d.avatar_setting != "SHOW") && flag_setting == "SHOW") return (-1) * d.height / 2 + flagSize[d.depth] + textSize[d.depth]
                        return (-1) * d.height / 2 + imgSize[d.depth] + textSize[d.depth]
                    } else if (d.depth <= 9) {
                        return (-1) * d.height / 2 + textSize[d.depth]
                    } else {
                        return (-1) * d.height / 2 + textSize[9]
                    }
                },
                dx: function (d) {
                    switch (name_text_align) {
                        case 'middle':
                            return 0;
                        case 'start':
                            return (-1) * d.width / 2;
                        default:
                            return d.width / 2;
                    }
                },
                "text-anchor": name_text_align
            })

            node.selectAll(".birth").attr({
                dy: function (d) {
                    if (d.depth == 0) {
                        if (d.avatar_setting != "SHOW") {
                            return (-1) * d.height / 2 + textSize[d.depth] + name_height[d.id + d.depth] - (imgSize[0] + 5 * textSize[0])
                        }
                        if ((profile_setting != "SHOW" || d.avatar_setting != "SHOW") && flag_setting == "SHOW") return (-1) * d.height / 2 + flagSize[d.depth] + textSize[d.depth] + name_height[d.id + d.depth] - (imgSize[0] + 5 * textSize[0])
                        return (-1) * d.height / 2 + imgSize[d.depth] + textSize[d.depth] + name_height[d.id + d.depth] - (imgSize[0] + 5 * textSize[0])
                    } else if (d.depth < 6) {
                        if (d.avatar_setting != "SHOW") {
                            return (-1) * d.height / 2 + textSize[d.depth] + name_height[d.id + d.depth]
                        }
                        if ((profile_setting != "SHOW" || d.avatar_setting != "SHOW") && flag_setting == "SHOW") return (-1) * d.height / 2 + flagSize[d.depth] + textSize[d.depth] + name_height[d.id + d.depth]
                        return (-1) * d.height / 2 + imgSize[d.depth] + textSize[d.depth] + name_height[d.id + d.depth]
                    } else if (d.depth <= 9) {
                        return (-1) * d.height / 2 + textSize[d.depth] + name_height[d.id + d.depth]
                    } else {
                        return (-1) * d.height / 2 + textSize[9] + name_height[d.id + d.depth]
                    }
                },
                display: function (d) {
                    if (birthSetting == "none") {
                        return "none"
                    }
                    if (d.depth > 8) {
                        return "none"
                    }
                    if (d.id.substring(0, 5) == 'fake_') {
                        return empty_node_setting
                    }
                }
            })
            node.selectAll(".marriage").attr({
                dy: function (d) {
                    if (birthSetting == 'none') {
                        if (d.depth == 0) {
                            if (d.avatar_setting != "SHOW") {
                                return (-1) * d.height / 2 + textSize[d.depth] + name_height[d.id + d.depth] - (imgSize[0] + 5 * textSize[0])
                            }
                            if ((profile_setting != "SHOW" || d.avatar_setting != "SHOW") && flag_setting == "SHOW") return (-1) * d.height / 2 + flagSize[d.depth] + textSize[d.depth] + name_height[d.id + d.depth] - (imgSize[0] + 5 * textSize[0])
                            return (-1) * d.height / 2 + imgSize[d.depth] + textSize[d.depth] + name_height[d.id + d.depth] - (imgSize[0] + 5 * textSize[0])
                        } else if (d.depth < 6) {
                            if (d.avatar_setting != "SHOW") {
                                return (-1) * d.height / 2 + textSize[d.depth] + name_height[d.id + d.depth]
                            }
                            if ((profile_setting != "SHOW" || d.avatar_setting != "SHOW") && flag_setting == "SHOW") return (-1) * d.height / 2 + flagSize[d.depth] + textSize[d.depth] + name_height[d.id + d.depth]
                            return (-1) * d.height / 2 + imgSize[d.depth] + textSize[d.depth] + name_height[d.id + d.depth]
                        } else if (d.depth <= 9) {
                            return (-1) * d.height / 2 + textSize[d.depth] + name_height[d.id + d.depth]
                        } else {
                            return (-1) * d.height / 2 + textSize[9] + name_height[d.id + d.depth]
                        }
                    } else {
                        if (d.depth == 0) {
                            if (d.avatar_setting != "SHOW") {
                                return (-1) * d.height / 2 + textSize[0] - (imgSize[0] + 5 * textSize[0]) + name_height[d.id + d.depth] + birth_height[d.id + d.depth]
                            }
                            return (-1) * d.height / 2 + imgSize[0] + textSize[0] - (imgSize[0] + 5 * textSize[0]) + name_height[d.id + d.depth] + birth_height[d.id + d.depth]
                        } else if (d.depth < 6) {
                            if (d.avatar_setting != "SHOW") {
                                return (-1) * d.height / 2 + textSize[d.depth] + name_height[d.id + d.depth] + birth_height[d.id + d.depth]
                            }
                            if ((profile_setting != "SHOW" || d.avatar_setting != "SHOW") && flag_setting == "SHOW") return (-1) * d.height / 2 + flagSize[d.depth] + textSize[d.depth] + name_height[d.id + d.depth] + birth_height[d.id + d.depth]
                            return (-1) * d.height / 2 + imgSize[d.depth] + textSize[d.depth] + name_height[d.id + d.depth] + birth_height[d.id + d.depth]
                        } else if (d.depth <= 9) {
                            return (-1) * d.height / 2 + textSize[d.depth] + name_height[d.id + d.depth] + birth_height[d.id + d.depth]
                        } else {
                            return (-1) * d.height / 2 + textSize[9] + name_height[d.id + d.depth] + birth_height[d.id + d.depth]
                        }
                    }

                },
                display: function (d) {
                    if (marriageSetting == "none" || d.depth == 0 || d.depth > 6) {
                        return "none"
                    }

                    if (d.id.substring(0, 5) == 'fake_') {
                        return empty_node_setting
                    }
                }
            })
            node.selectAll(".death").attr({
                dy: function (d) {
                    var temp = 0
                    if (d.depth == 0) {
                        if (d.avatar_setting != "SHOW") {
                            if (flag_setting == "SHOW") {
                                temp = flagSize[d.depth] + textSize[d.depth] + name_height[d.id + d.depth] - (imgSize[0] + 5 * textSize[0])
                            } else {
                                temp = textSize[d.depth] + name_height[d.id + d.depth] - (imgSize[0] + 5 * textSize[0])
                            }
                        } else if (profile_setting != "SHOW" && flag_setting == "SHOW") {
                            temp = flagSize[d.depth] + textSize[d.depth] + name_height[d.id + d.depth] - (imgSize[0] + 5 * textSize[0])
                        } else {
                            temp = imgSize[d.depth] + textSize[d.depth] + name_height[d.id + d.depth] - (imgSize[0] + 5 * textSize[0])
                        }
                    } else if (d.depth < 6) {
                        if (d.avatar_setting != "SHOW") {
                            if (flag_setting == "SHOW") {
                                temp = flagSize[d.depth] + textSize[d.depth] + name_height[d.id + d.depth]
                            } else {
                                temp = textSize[d.depth] + name_height[d.id + d.depth]
                            }
                        } else if (profile_setting != "SHOW" && flag_setting == "SHOW") {
                            temp = flagSize[d.depth] + textSize[d.depth] + name_height[d.id + d.depth]
                        } else {
                            temp = imgSize[d.depth] + textSize[d.depth] + name_height[d.id + d.depth]
                        }

                    } else if (d.depth <= 9) {
                        temp = textSize[d.depth] + name_height[d.id + d.depth]
                    } else {
                        temp = textSize[9] + name_height[d.id + d.depth]
                    }

                    if (birthSetting != 'none') {
                        temp += birth_height[d.id + d.depth]
                    }
                    if (marriageSetting != 'none') {
                        if (d.depth > 0 && d.depth < 7) {
                            temp += marriage_height[d.id + d.depth]
                        }
                    }

                    return (-1) * d.height / 2 + temp
                },
                display: function (d) {
                    if (deathSetting == "none" || d.depth > 8) {
                        return "none"
                    }

                    if (d.id.substring(0, 5) == 'fake_') {
                        return empty_node_setting
                    }
                }
            })

            node.selectAll(".note").attr({
                dy: function (d) {
                    var temp = 0
                    if (d.depth == 0) {
                        if (d.avatar_setting != "SHOW") {
                            if (flag_setting == "SHOW") {
                                temp = flagSize[d.depth] + textSize[d.depth] / 2 + name_height[d.id + d.depth] - (imgSize[0] + 5 * textSize[0])
                            } else {
                                temp = textSize[d.depth] / 2 + name_height[d.id + d.depth] - (imgSize[0] + 5 * textSize[0])
                            }
                        } else if (profile_setting != "SHOW" && flag_setting == "SHOW") {
                            temp = flagSize[d.depth] + textSize[d.depth] / 2 + name_height[d.id + d.depth] - (imgSize[0] + 5 * textSize[0])
                        } else {
                            temp = imgSize[d.depth] + textSize[d.depth] / 2 + name_height[d.id + d.depth] - (imgSize[0] + 5 * textSize[0])
                        }
                    } else if (d.depth < 6) {
                        if (d.avatar_setting != "SHOW") {
                            if (flag_setting == "SHOW") {
                                temp = flagSize[d.depth] + textSize[d.depth] / 2 + name_height[d.id + d.depth]
                            } else {
                                temp = textSize[d.depth] / 2 + name_height[d.id + d.depth]
                            }
                        } else if (profile_setting != "SHOW" && flag_setting == "SHOW") {
                            temp = flagSize[d.depth] + textSize[d.depth] / 2 + name_height[d.id + d.depth]
                        } else {
                            temp = imgSize[d.depth] + textSize[d.depth] / 2 + name_height[d.id + d.depth]
                        }

                    } else if (d.depth <= 9) {
                        temp = textSize[d.depth] / 2 + name_height[d.id + d.depth]
                    } else {
                        temp = textSize[9] / 2 + name_height[d.id + d.depth]
                    }

                    if (birthSetting != 'none' && d.depth < 9) {
                        temp += birth_height[d.id + d.depth]
                    }
                    if (marriageSetting != 'none') {
                        if (d.depth > 0 && d.depth < 7) {
                            temp += marriage_height[d.id + d.depth]
                        }
                    }
                    if (deathSetting != 'none' && d.depth < 9) {
                        temp += death_height[d.id + d.depth]
                    }

                    return (-1) * d.height / 2 + temp
                },
            })

            nodeUpdate
                .select("rect")
                .attr({
                    x: function (d) {
                        return -(d.width * 1.1 + 20) / 2;
                    },
                    y: function (d) {
                        return d.depth == 0 ? -(d.height + 20) / 2 - (imgSize[0] + 5 * textSize[0]) : -(d.height + 20) / 2;
                    },
                    width: function (d) {
                        return d.width * 1.1 + 20;
                    },
                    height: function (d) {
                        return d.height + 20;
                    },
                    stroke: borderColor,
                    fill: function (d) {
                        if (d.sex == 'M') return maleNodeColor
                        else return femaleNodeColor
                    },
                    "rx": borderRadius,
                    "stroke-width": function (d) { return borderWidth; },
                    "fill-opacity": function (d) {
                        if (d.id.substring(0, 5) == 'fake_' && empty_node_setting == 'none') {
                            return 0
                        }
                    },
                    // display: function (d) {
                    //     if (d.id.substring(0, 5) == 'fake_') {
                    //         return empty_node_setting
                    //     }
                    // },
                }).each(function (d) {
                    if (d.depth == 0) {
                        if (start_x == null) start_x = -d.x / 10
                        if (start_y == null) start_y = -d.y / 10
                    }
                });

            node
                .append('image')
                .attr({
                    'class': 'warning',
                    'xlink:href': function (d) {
                        return GlobalConstants.warning
                    },
                    'width': function (d) {
                        if (d.depth > 5) return imgSize[5] / d.depth
                        return imgSize[d.depth] / 2
                    },
                    'height': function (d) {
                        if (d.depth > 5) return imgSize[5] / d.depth
                        return imgSize[d.depth] / 2
                    },
                    "x": function (d) {
                        if (d.depth > 5) return -(d.width * 1.1 + 20) / 2 - imgSize[5] / d.depth / 2
                        return -(d.width * 1.1 + 20) / 2 - imgSize[d.depth] / 4;
                    },
                    y: function (d) {
                        return d.depth == 0 ? -(d.height + 20) / 2 - (imgSize[0] + 5 * textSize[0]) : -(d.height + 20) / 2;
                    },
                    "display": function (d) {
                        if (d.warning && warning_setting == "SHOW") {
                            if (d.id.substring(0, 5) == 'fake_') {
                                return empty_node_setting
                            }
                            return 'block';
                        } else {
                            return 'none';
                        }
                    },

                })

            d3
                .select('svg')
                .select('g')
                .attr("transform", "translate(" + start_y + "," + start_x + ") scale(0.1)")
            zoom.translate([start_y, start_x]);

            nodes.forEach(function (person) {
                person.x0 = person.x;
                person.y0 = person.y;
            });
        }

        function elbow(d, direction) {
            switch (dirction_t) {
                case 1:
                    return "M" + direction * d.source.y + "," + d.source.x + "H" + direction * (d.source.y + (d.target.y - d.source.y) / 2) + "V" + d.target.x + "H" + direction * d.target.y;
                default:
                    return "M" + d.source.x + "," + direction * d.source.y + "V" + direction * (d.source.y + (d.target.y - d.source.y) / 2) + "H" + d.target.x + "V" + direction * d.target.y;
            }
        }

        if (this.partner_setting == 'SHOW') {
            this.addwife()
        }

        if (this.children_setting == 'SHOW') {
            this.addchildren()
        }
        this.showLoader = false; console.log('Loader off')
        this.bg = localStorage.getItem('background');
        setTimeout(() => {
            if (this.bg) {
                this.addbackground(this.bg)
            }
        }, 1000);
        console.log('Background', this.bg)

    }

    async buildTree(direction) {

        let bornText = this.nodeBornText
        let marriedText = this.nodeMarriedText
        let deceasedText = this.nodeDeceasedText

        node_width = treeHeight / maxGeneration
        this.relation = this.nodeinfos[this._id];
        this.generateRelation(this.nodeinfos[this._id], 0);

        // Setup zoom and pan
        zoom = d3
            .behavior
            .zoom()
            .scaleExtent([.01, 10])
            .on('zoom', function () {
                svg.attr("transform", "translate(" + d3.event.translate + ") scale(" + d3.event.scale / 10 + ")");
                start_x = d3.event.translate[0];
                start_y = d3.event.translate[1];
                start_scale = d3.event.scale / 10;
            })

        var svg = d3
            .select('body .tree-body')
            .append('svg')
            .attr('width', '100%')
            .attr('height', '100%')
            .call(zoom)
            .append('g')
            .attr("transform", "scale(.1)")
            .attr("padding", 100)
            .attr('class', 'treebody')

        svg.append('rect')
            .attr({
                width: 0,
                height: 0,
                x: 0,
                y: 0
            })

        svg
            .append('image')
            .attr('width', 0)
            .attr('height', 0)
            .attr('x', 0)
            .attr('y', 0)
            .attr('opacity', this.back_Opacity)

        svg
            .append('style')
            .text(`   
            text {
            }         
            .person {
                cursor: pointer;
            }
            
            .link {
                fill: none;
                stroke: #ccc;
                stroke-width: 10px;
            }`);

        var tree = d3
            .layout
            .tree()
            .nodeSize([treeWidth / (Math.pow(2, maxGeneration - 2)), treeHeight / maxGeneration])
            .separation(function () {
                return .5;
            })
            .children(function (person) {
                return person._parents;
            });

        var nodes = tree.nodes(this.relation);

        for (let index = 0; index < nodes.length; index++) {
            const element = nodes[index];
            const half = (maxGeneration - 2) / 2;
            if (element.depth != 0) {
                nodes[index].y += 800 * (half * element.depth - (Math.pow(element.depth - 1, 2) + element.depth + 1) / 2)
            }
        }

        var links = tree.links(nodes);

        svg
            .selectAll("path.link")
            .data(links)
            .enter()
            .append("path")
            .attr({
                "class": "link",
                "d": elbow,
                "display": function (d) {
                    if (d.target.id.substring(0, 5) == 'fake_') {
                        return empty_node_setting
                    } else {
                        return "block"
                    }
                }
            })

        // Style nodes
        var node = svg
            .selectAll("g.person")
            .data(nodes)
            .enter()
            .append("g")
            .attr("class", "person")
            .attr("transform", function (d) {
                switch (direction) {
                    case 2:
                        return "translate(" + (-1) * d.y + "," + d.x + ")";
                    case 3:
                        return "translate(" + d.x + "," + d.y + ")";
                    case 4:
                        return "translate(" + d.x + "," + (-1) * d.y + ")";
                    default:
                        return "translate(" + d.y + "," + d.x + ")";
                }
            })
            .on('click', this.openEditModal);


        node
            .append("rect")

        node.attr({
            "opacity": function (d) {
                if (d.id.substring(0, 5) == 'fake_' && empty_node_setting == 'none') {
                    return 0
                }
                else {
                    return 1
                }
            },
            "fill-opacity": nodeOpacity,
        })

        let nodeData
        await this.dbService.getByKey('nodes', 1).subscribe((nodes: any) => {
            nodeData = JSON.parse(nodes.nodeinfos)
      
            node.each(function (d) {
                if (nodeData[d.id]) {
                    nodeData[d.id].mainDisplay = true
                    let warning = false
                    let name = (d.firstName ? d.firstName : 'n/a') + " " + (d.lastName ? d.lastName : 'n/a')

                    if (name.includes('n/a')) {
                        warning = true;
                    }

                    let place = (d.birth && d.birth.place) ? d.birth.place : "n/a";
                    let birth_info = (d.birthday ? d.birthday : '-.-.-') + ", " + place
                    if (birthSetting != "none" && d.depth <= 8) {
                        if (birth_info.includes('n/a') || birth_info.includes('.-') || birth_info.includes('-.')) {
                            warning = true;
                        }
                    }

                    let marriage_day = getMarriageDay(d);
                    let marriage_place = d.c_fam && d.marriage[d.c_fam] && d.marriage[d.c_fam]['place'] ? d.marriage[d.c_fam]['place'] : "n/a";
                    let marriage_info = (marriage_day ? marriage_day : '-.-.-') + ", " + marriage_place
                    if (marriageSetting != "none" && d.depth != 0 && d.depth <= 6) {
                        if (marriage_info.includes('n/a') || marriage_info.includes('.-') || marriage_info.includes('-.')) {
                            warning = true;
                        }
                    }

                    let deathplace = (d.death && d.death.place) ? d.death.place : "n/a";
                    let death_info = (d.deathday ? d.deathday : '-.-.-') + ", " + deathplace
                    if (deathSetting != "none" && d.depth <= 8) {
                        if (death_info.includes('n/a') || death_info.includes('.-') || death_info.includes('-.')) {
                            warning = true;
                        }
                    }

                    if (warning) {
                        nodeData[d.id].warning = true
                        d.warning = true
                    } else {
                        nodeData[d.id].warning = false
                        d.warning = false
                    }
                }
            })

        }, err => console.log(err));
        //image
        node
            .append('image')
            .attr({
                'class': 'avatar',
                'xlink:href': function (d) {
                    if (d.avatar_type == "sample") {
                        if (d.sex == 'M') {
                            return maleAvatar[parseInt(d.url)]
                        } else {
                            return femaleAvatar[parseInt(d.url)]
                        }
                    } else {
                        return d.url;
                    }
                },
                'width': function (d) {
                    if (d.depth < 6) {
                        return imgSize[d.depth]
                    } else {
                        return 0
                    }
                },
                'height': function (d) {
                    if (d.depth < 6) {
                        return imgSize[d.depth]
                    } else {
                        return 0
                    }
                },
                "x": function (d) {
                    if (d.depth < 6) {
                        if (flag_setting != "SHOW" || d.country == "NoFlag" || d.depth > 5) {
                            return -imgSize[d.depth] / 2
                        }
                        return -imgSize[d.depth] / 2 - flagSize[d.depth] / 2
                    } else {
                        return 0
                    }
                },
                "display": function (d) {
                    if (profile_setting != "SHOW") {
                        return "none"
                    }
                    if (d.depth > 5) {
                        return "none"
                    }
                    if (d.avatar_setting != "SHOW") {
                        return "none"
                    }
                    if (d.id.substring(0, 5) == 'fake_') {
                        return empty_node_setting
                    }

                },
                "transform": function (d) {
                    if (d.depth > 5 && (direction == 3 || direction == 4)) {
                        return "rotate(90)"
                    }
                },

            }).each(function (d) {
                d.height = this.getBBox().height
                if (d.depth < 6) {
                    return d.width = this.getBBox().width + flagSize[d.depth] + 200
                } else {
                    return d.width = this.getBBox().width
                }
            })
        //flag
        node
            .append('image')
            .attr({
                'class': 'flag',
                'xlink:href': function (d) {
                    if (!d.country || d.country == "") {
                        return Flags.flags['Sweden']
                    } else if (d.country == "NoFlag") {
                        return Flags.flags['Sweden']
                    }
                    else if (d.country == "custom") {
                        return d.c_flag
                    }
                    else {
                        return Flags.flags[d.country]
                    }
                },
                'width': function (d) {
                    if (d.depth < 6) {
                        return flagSize[d.depth]
                    } else {
                        return 0
                    }
                },
                "x": function (d) {
                    if (d.depth < 6) {
                        if (d.avatar_setting != "SHOW") return -flagSize[d.depth] / 2
                        return imgSize[d.depth] / 2 - flagSize[d.depth] / 2 + 100
                    } else {
                        return 0
                    }
                },
                "display": function (d) {
                    if (flag_setting != "SHOW") {
                        return "none"
                    }
                    else if (d.country == "NoFlag") {
                        return "none"
                    }
                    else if (d.depth > 5) {
                        return "none"
                    }
                    else if (d.id.substring(0, 5) == 'fake_') {
                        return empty_node_setting
                    } else {
                        return "block"
                    }
                },

            })
            .each(function (d) {
                if (profile_setting != "SHOW" || d.avatar_setting != "SHOW") {
                    d.height = this.getBBox().height
                }
            })
        // first and last name
        node
            .append("text")
            .attr({
                'class': 'name',
                'fill': function (d) {
                    if (d.sex == 'M') return manColor
                    else return womanColor
                },
                "display": function (d) {
                    if (d.id.substring(0, 5) == 'fake_') {
                        return empty_node_setting
                    }
                },
                'font-size': function (d) {
                    if (d.depth <= 9) {
                        return textSize[d.depth]
                    } else {
                        return textSize[9]
                    }
                },
                'font-family': fontFamily,
                "transform": function (d) {
                    if (d.depth > 5 && (direction == 3 || direction == 4)) {
                        return "rotate(90)"
                    }
                },
            })
            .each(function (d) {
                let font_size
                if (d.depth <= 9) {
                    font_size = textSize[d.depth]
                } else {
                    font_size = textSize[9]
                }
                let name = (d.firstName ? d.firstName : 'n/a') + " " + (d.lastName ? d.lastName : 'n/a')

                // if (name.includes('n/a')) {
                //     d.warning = true;
                // }

                let length = Math.floor((node_width + 800 * ((maxGeneration / 2 - 1) - d.depth)) / font_size * 1.5)

                if (d.depth >= 8) {
                    length = name.length + 2
                }

                if (direction == '3' || direction == '4') {
                    if (d.depth == 0) {
                        length = Math.floor(treeHeight / maxGeneration / font_size * 2)
                    }
                    else if (d.depth <= 5) {
                        length = Math.floor((treeWidth / Math.pow(2, d.depth)) / font_size * 1) + 2
                    } else {
                        length = name.length + 2
                    }
                }

                var res_text = spliteText(name, length, 0);
                for (let index = 0; index < res_text.length; index++) {
                    const element = res_text[index];
                    d3.select(this)
                        .append("tspan")
                        .text(function () {
                            return element;
                        })
                        .attr({
                            x: function () {
                                if (index > 0) return 0
                            },
                            dy: function () {
                                if (index > 0) return '1em'
                            },
                            'class': 'name_span',
                        })

                }

                if (d.width < this.getBBox().width) d.width = this.getBBox().width;
                d.height = this.getBBox().height + d.height;
                if (!name_height[d.id + d.depth]) name_height[d.id + d.depth] = this.getBBox().height

            });


        // birthday and place
        node
            .append("text")
            .attr({
                'class': 'birth',
                'fill': function (d) {
                    if (d.sex == 'M') return manColor
                    else return womanColor
                },
                'font-size': function (d) {
                    if (d.depth <= 9) {
                        return textSize[d.depth]
                    } else {
                        return textSize[9]
                    }
                },
                'font-family': fontFamily,
                "transform": function (d) {
                    if (d.depth > 5 && (direction == 3 || direction == 4)) {
                        return "rotate(90)"
                    }
                },
            })
            .each(function (d) {
                let place = (d.birth && d.birth.place) ? d.birth.place : "n/a";

                let font_size
                if (d.depth <= 9) {
                    font_size = textSize[d.depth]
                } else {
                    font_size = textSize[9]
                }
                let birth_info = (d.birthday ? d.birthday : '-.-.-') + ", " + place

                let length = Math.floor((node_width + 800 * ((maxGeneration / 2 - 1) - d.depth)) / font_size * 1.5)

                if (d.depth >= 8) {
                    length = birth_info.length + 2
                }

                if (direction == '3' || direction == '4') {
                    if (d.depth == 0) {
                        length = Math.floor(treeHeight / maxGeneration / font_size * 2)
                    }
                    else if (d.depth <= 5) {
                        length = Math.floor((treeWidth / Math.pow(2, d.depth)) / font_size * 1) + 2
                    } else {
                        length = birth_info.length + 2
                    }
                }
                if ((localStorage.getItem('birth_hide_empty') === 'true') && birth_info === '-.-.-, n/a') {
                    console.log('empty')
                }
                else {
                    if (d.depth < 6) {
                        d3.select(this)
                            .append("tspan")
                            .text(function () {
                                return bornText;
                            })
                            .attr({
                                'font-weight': "bold"
                            })

                        var res_text = spliteText(birth_info, length, 6);
                        for (let index = 0; index < res_text.length; index++) {
                            const element = res_text[index];
                            d3.select(this)
                                .append("tspan")
                                .text(function () {
                                    return element;
                                })
                                .attr({
                                    x: function () {
                                        if (index > 0) return 0
                                    },
                                    dy: function () {
                                        if (index > 0) return '1em'
                                    },
                                    'class': function () {
                                        if (index == 0) return 'nextString'
                                    },
                                })
                        }

                    } else {
                        d3.select(this)
                            .append("tspan")
                            .text(function () {
                                return "" + bornText.slice(0, 1) + ": ";
                            })
                            .attr({
                                'font-weight': "bold"
                            })
                        d3.select(this)
                            .append("tspan")
                            .text(function () {
                                return birth_info;
                            })
                    }

                    if (birthSetting != "none" && d.depth <= 8) {
                        if (d.width < this.getBBox().width) d.width = this.getBBox().width;
                        if (d.depth <= 8) d.height = this.getBBox().height + d.height
                    }
                    if (!birth_height[d.id + d.depth]) birth_height[d.id + d.depth] = this.getBBox().height
                }
            })

        //marriage day and place
        node
            .append("text")
            .attr({
                'class': 'marriage',
                'fill': function (d) {
                    if (d.sex == 'M') return manColor
                    else return womanColor
                },
                'font-size': function (d) {
                    if (d.depth <= 9) {
                        return textSize[d.depth]
                    } else {
                        return textSize[9]
                    }
                },
                'font-family': fontFamily,
                "transform": function (d) {
                    if (d.depth > 5 && (direction == 3 || direction == 4)) {
                        return "rotate(90)"
                    }
                },
            })
            .each(function (d) {
                if (d.depth != 0 && d.depth <= 6) {
                    let marriage_day = getMarriageDay(d);
                    let marriage_place = d.c_fam && d.marriage[d.c_fam] && d.marriage[d.c_fam]['place'] ? d.marriage[d.c_fam]['place'] : "n/a";
                    let font_size
                    if (d.depth <= 9) {
                        font_size = textSize[d.depth]
                    } else {
                        font_size = textSize[9]
                    }
                    let marriage_info = (marriage_day ? marriage_day : '-.-.-') + ", " + marriage_place

                    // if (marriageSetting != "none" && d.depth != 0 && d.depth <= 6) {
                    //     if (marriage_info.includes('n/a') || marriage_info.includes('.-') || marriage_info.includes('-.')) {
                    //         d.warning = true;
                    //     }
                    // }


                    let length = Math.floor((node_width + 800 * ((maxGeneration / 2 - 1) - d.depth)) / font_size * 1.5)

                    if (d.depth >= 8) {
                        length = marriage_info.length + 2
                    }

                    if (direction == '3' || direction == '4') {
                        if (d.depth == 0) {
                            length = Math.floor(treeHeight / maxGeneration / font_size * 2)
                        }
                        else if (d.depth <= 5) {
                            length = Math.floor((treeWidth / Math.pow(2, d.depth)) / font_size * 1) + 2
                        } else {
                            length = marriage_info.length + 2
                        }
                    }

                    if ((localStorage.getItem('marriage_hide_empty') === 'true') && marriage_info === '-.-.-, n/a') {
                        console.log('empty')
                    }
                    else {
                        if (d.depth < 6) {
                            d3.select(this)
                                .append("tspan")
                                .text(function () {
                                    return marriedText;
                                })
                                .attr({
                                    'font-weight': "bold"
                                })
                            var res_text = spliteText(marriage_info, length, 9);
                            for (let index = 0; index < res_text.length; index++) {
                                const element = res_text[index];
                                d3.select(this)
                                    .append("tspan")
                                    .text(function () {
                                        return element;
                                    })
                                    .attr({
                                        x: function () {
                                            if (index > 0) return 0
                                        },
                                        dy: function () {
                                            if (index > 0) return '1em'
                                        },
                                        'class': function () {
                                            if (index == 0) return 'nextString'
                                        },
                                    })

                            }
                        } else {
                            d3.select(this)
                                .append("tspan")
                                .text(function () {
                                    return "" + marriedText.slice(0, 1) + ": ";
                                })
                                .attr({
                                    'font-weight': "bold"
                                })
                            var res_text = spliteText(marriage_info, length, 3);
                            for (let index = 0; index < res_text.length; index++) {
                                const element = res_text[index];
                                d3.select(this)
                                    .append("tspan")
                                    .text(function () {
                                        return element;
                                    })
                                    .attr({
                                        x: function () {
                                            if (index > 0) return 0
                                        },
                                        dy: function () {
                                            if (index > 0) return '1em'
                                        },
                                        'class': function () {
                                            if (index == 0) return 'nextString'
                                        },
                                    })

                            }
                        }
                    }
                }

                if (marriageSetting != "none" && d.depth != 0 && d.depth <= 6) {
                    if (d.width < this.getBBox().width) d.width = this.getBBox().width;
                    if (d.depth != 0 && d.depth <= 6) d.height = this.getBBox().height + d.height
                }
                if (!marriage_height[d.id + d.depth]) marriage_height[d.id + d.depth] = this.getBBox().height
            });
        // death day and place
        node
            .append("text")
            .attr({
                'class': 'death',
                'fill': function (d) {
                    if (d.sex == 'M') return manColor
                    else return womanColor
                },
                'font-size': function (d) {
                    if (d.depth <= 9) {
                        return textSize[d.depth]
                    } else {
                        return textSize[9]
                    }
                },
                'font-family': fontFamily,
                "transform": function (d) {
                    if (d.depth > 5 && (direction == 3 || direction == 4)) {
                        return "rotate(90)"
                    }
                },
            })
            .each(function (d) {
                let place = (d.death && d.death.place) ? d.death.place : "n/a";
                let font_size
                if (d.depth <= 9) {
                    font_size = textSize[d.depth]
                } else {
                    font_size = textSize[9]
                }
                let death_info = (d.deathday ? d.deathday : '-.-.-') + ", " + place


                let length = Math.floor((node_width + 800 * ((maxGeneration / 2 - 1) - d.depth)) / font_size * 1.5)

                if (d.depth >= 8) {
                    length = death_info.length + 2
                }

                if (direction == '3' || direction == '4') {
                    if (d.depth == 0) {
                        length = Math.floor(treeHeight / maxGeneration / font_size * 2)
                    }
                    else if (d.depth <= 5) {
                        length = Math.floor((treeWidth / Math.pow(2, d.depth)) / font_size * 1) + 2
                    } else {
                        length = death_info.length + 2
                    }
                }
                if ((localStorage.getItem('death_hide_empty') === 'true') && death_info === '-.-.-, n/a') {
                    console.log('empty')
                }
                else {
                    if (d.depth < 6) {
                        d3.select(this)
                            .append("tspan")
                            .text(function () {
                                return deceasedText;
                            })
                            .attr({
                                'font-weight': "bold"
                            })
                        var res_text = spliteText(death_info, length, 9);
                        for (let index = 0; index < res_text.length; index++) {
                            const element = res_text[index];
                            d3.select(this)
                                .append("tspan")
                                .text(function () {
                                    return element;
                                })
                                .attr({
                                    x: function () {
                                        if (index > 0) return 0
                                    },
                                    dy: function () {
                                        if (index > 0) return '1em'
                                    },
                                    'class': function () {
                                        if (index == 0) return 'nextString'
                                    },
                                })

                        }
                    } else {
                        d3.select(this)
                            .append("tspan")
                            .text(function () {
                                return "" + deceasedText.slice(0, 1) + ": ";
                            })
                            .attr({
                                'font-weight': "bold"
                            })
                        d3.select(this)
                            .append("tspan")
                            .text(function () {
                                return death_info;
                            })
                    }

                    if (deathSetting != "none" && d.depth <= 8) {
                        if (d.width < this.getBBox().width) d.width = this.getBBox().width;
                        if (d.depth <= 8) d.height = this.getBBox().height + d.height
                    }
                    if (!death_height[d.id + d.depth]) death_height[d.id + d.depth] = this.getBBox().height
                }
            });

        // note
        node
            .append("text")
            .attr({
                'class': 'note',
                'fill': function (d) {
                    if (d.sex == 'M') return manColor
                    else return womanColor
                },
                'font-size': function (d) {
                    if (d.depth <= 9) {
                        return textSize[d.depth] / 2
                    } else {
                        return textSize[9] / 2
                    }
                },
                'font-family': fontFamily,
                "display": function (d) {
                    if (d.note == "") return 'none'
                    else return 'block'
                },
            })
            .each(function (d) {
                let note = d.note;
                let font_size
                if (d.depth < 9) {
                    font_size = textSize[d.depth] / 2
                } else {
                    font_size = textSize[9] / 2
                }

                if (d.depth == 0) {
                    length = Math.floor((node_width + 400 * ((maxGeneration / 2 - 1) - d.depth)) / font_size * 1.5) * 1.6
                } else if (d.depth >= 8) {
                    length = 70
                } else {
                    length = Math.floor((node_width + 400 * ((maxGeneration / 2 - 1) - d.depth)) / font_size * 1.6)
                }
                if (d.depth == 0 && (direction == 3 || direction == 4)) length = Math.floor(treeHeight / maxGeneration / font_size * 2)

                var res_text = [""]
                if (note != "" && note != null) {
                    res_text = spliteText(note, length, 1);
                }

                for (let index = 0; index < res_text.length; index++) {
                    const element = res_text[index];
                    d3.select(this)
                        .append("tspan")
                        .text(function () {
                            return element;
                        })
                        .attr({
                            x: function () {
                                return 0
                            },
                            dy: function () {
                                if (index > 0) return '1em'
                            },
                        })

                }
                if (d.note != "") {
                    if (d.width < this.getBBox().width) d.width = this.getBBox().width;
                    d.height = this.getBBox().height + d.height
                    note_height[d.id] = this.getBBox().height
                } else {
                    note_height[d.id] = 0
                }
            });

        node.selectAll(".avatar").attr({
            y: function (d) {
                return (-1) * d.height / 2
            },
            // opacity: nodeOpacity,
        })

        node.selectAll(".flag").attr({
            y: function (d) {
                return (-1) * d.height / 2
            },
            // opacity: nodeOpacity,
        })

        node.selectAll("tspan").attr({
            dx: function (d) {
                switch (text_align) {
                    case 'middle':
                        return 0;
                    case 'start':
                        return (-1) * d.width / 2;
                    default:
                        return d.width / 2;
                }
            },
            "text-anchor": text_align,
            // opacity: nodeOpacity,
        })

        node.selectAll(".name_span").attr({
            dx: function (d) {
                switch (name_text_align) {
                    case 'middle':
                        return 0;
                    case 'start':
                        return (-1) * d.width / 2;
                    default:
                        return d.width / 2;
                }
            },
            "text-anchor": name_text_align
        })

        node.selectAll(".nextString").attr({
            dx: 0
        })

        node.selectAll(".name").attr({
            dy: function (d) {
                if (d.depth < 6) {
                    if (d.avatar_setting != "SHOW" || profile_setting != "SHOW") {
                        if (flag_setting != "SHOW" || d.country == "NoFlag") {
                            return (-1) * d.height / 2 + textSize[d.depth]
                        } else {
                            return (-1) * d.height / 2 + flagSize[d.depth] + textSize[d.depth]
                        }
                    } else {
                        return (-1) * d.height / 2 + imgSize[d.depth] + textSize[d.depth]
                    }
                } else if (d.depth <= 9) {
                    return (-1) * d.height / 2 + textSize[d.depth]
                } else {
                    return (-1) * d.height / 2 + textSize[9]
                }
            },
        })

        node.selectAll(".birth").attr({
            dy: function (d) {
                if (d.depth < 6) {
                    if (d.avatar_setting != "SHOW" || profile_setting != "SHOW") {
                        if (flag_setting != "SHOW" || d.country == "NoFlag") {
                            return (-1) * d.height / 2 + textSize[d.depth] + name_height[d.id + d.depth]
                        } else {
                            return (-1) * d.height / 2 + flagSize[d.depth] + textSize[d.depth] + name_height[d.id + d.depth]
                        }
                    } else {
                        return (-1) * d.height / 2 + imgSize[d.depth] + textSize[d.depth] + name_height[d.id + d.depth]
                    }
                } else if (d.depth <= 9) {
                    return (-1) * d.height / 2 + textSize[d.depth] + name_height[d.id + d.depth]
                } else {
                    return (-1) * d.height / 2 + textSize[9] + name_height[d.id + d.depth]
                }
            },
            display: function (d) {
                if (birthSetting == "none" || d.depth > 8) {
                    return "none"
                }

                if (d.id.substring(0, 5) == 'fake_') {
                    return empty_node_setting
                }
            }
        })

        node.selectAll(".marriage").attr({
            dy: function (d) {
                if (birthSetting == 'none') {
                    if (d.depth < 6) {
                        if (d.avatar_setting != "SHOW" || profile_setting != "SHOW") {
                            if (flag_setting != "SHOW" || d.country == "NoFlag") {
                                return (-1) * d.height / 2 + textSize[d.depth] + name_height[d.id + d.depth]
                            } else {
                                return (-1) * d.height / 2 + flagSize[d.depth] + textSize[d.depth] + name_height[d.id + d.depth]
                            }
                        } else {
                            return (-1) * d.height / 2 + imgSize[d.depth] + textSize[d.depth] + name_height[d.id + d.depth]
                        }
                    } else if (d.depth <= 9) {
                        return (-1) * d.height / 2 + textSize[d.depth] + name_height[d.id + d.depth]
                    } else {
                        return (-1) * d.height / 2 + textSize[9] + name_height[d.id + d.depth]
                    }

                } else {
                    if (d.depth < 6) {
                        if (d.avatar_setting != "SHOW" || profile_setting != "SHOW") {
                            if (flag_setting != "SHOW" || d.country == "NoFlag") {
                                return (-1) * d.height / 2 + textSize[d.depth] + name_height[d.id + d.depth] + birth_height[d.id + d.depth]
                            } else {
                                return (-1) * d.height / 2 + flagSize[d.depth] + textSize[d.depth] + name_height[d.id + d.depth] + birth_height[d.id + d.depth]
                            }
                        } else {
                            return (-1) * d.height / 2 + imgSize[d.depth] + textSize[d.depth] + name_height[d.id + d.depth] + birth_height[d.id + d.depth]
                        }
                    } else if (d.depth <= 9) {
                        return (-1) * d.height / 2 + textSize[d.depth] + name_height[d.id + d.depth] + birth_height[d.id + d.depth]
                    } else {
                        return (-1) * d.height / 2 + textSize[9] + name_height[d.id + d.depth] + birth_height[d.id + d.depth]
                    }
                }

            },
            display: function (d) {
                if (marriageSetting == "none" || d.depth == 0 || d.depth > 6) {
                    return "none"
                }

                if (d.id.substring(0, 5) == 'fake_') {
                    return empty_node_setting
                }
            }
        })

        node.selectAll(".death").attr({
            dy: function (d) {
                var temp = 0
                if (d.depth < 6) {
                    if (d.avatar_setting != "SHOW" || profile_setting != "SHOW") {
                        if (flag_setting == "SHOW" && d.country != "NoFlag") {
                            temp = flagSize[d.depth] + textSize[d.depth] + name_height[d.id + d.depth]
                        } else {
                            temp = textSize[d.depth] + name_height[d.id + d.depth]
                        }
                    } else {
                        temp = imgSize[d.depth] + textSize[d.depth] + name_height[d.id + d.depth]
                    }
                } else if (d.depth <= 9) {
                    temp = textSize[d.depth] + name_height[d.id + d.depth]
                } else {
                    temp = textSize[9] + name_height[d.id + d.depth]
                }

                if (birthSetting != 'none') {
                    temp += birth_height[d.id + d.depth]
                }
                if (marriageSetting != 'none') {
                    if (d.depth > 0 && d.depth < 7) {
                        temp += marriage_height[d.id + d.depth]
                    }
                }

                return (-1) * d.height / 2 + temp
            },
            display: function (d) {
                if (deathSetting == "none" || d.depth > 8) {
                    return "none"
                }

                if (d.id.substring(0, 5) == 'fake_') {
                    return empty_node_setting
                }
            }
        })

        node.selectAll(".note").attr({
            dy: function (d) {
                var temp = 0
                if (d.depth < 6) {
                    if (d.avatar_setting != "SHOW") {
                        if (flag_setting == "SHOW" && d.country != "NoFlag") {
                            temp = flagSize[d.depth] + textSize[d.depth] / 2 + name_height[d.id + d.depth]
                        } else {
                            temp = textSize[d.depth] / 2 + name_height[d.id + d.depth]
                        }
                    } else if (profile_setting != "SHOW" && flag_setting == "SHOW") {
                        temp = flagSize[d.depth] + textSize[d.depth] / 2 + name_height[d.id + d.depth]
                    } else {
                        temp = imgSize[d.depth] + textSize[d.depth] / 2 + name_height[d.id + d.depth]
                    }

                } else if (d.depth <= 9) {
                    temp = textSize[d.depth] / 2 + name_height[d.id + d.depth]
                } else {
                    temp = textSize[9] / 2 + name_height[d.id + d.depth]
                }

                if (birthSetting != 'none' && d.depth < 9) {
                    temp += birth_height[d.id + d.depth]
                }
                if (marriageSetting != 'none') {
                    if (d.depth > 0 && d.depth < 7) {
                        temp += marriage_height[d.id + d.depth]
                    }
                }
                if (deathSetting != 'none' && d.depth < 9) {
                    temp += death_height[d.id + d.depth]
                }

                return (-1) * d.height / 2 + temp
            },
        })

        node
            .select("rect")
            .attr({
                x: function (d) {
                    return -(d.width * 1.1 + 20) / 2;
                },
                fill: function (d) {
                    if (d.sex == 'M') return maleNodeColor
                    else return femaleNodeColor
                },
                y: function (d) {
                    return -(d.height + 20) / 2;
                },
                width: function (d) {
                    return d.width * 1.1 + 20;
                },
                height: function (d) {
                    return d.height + 20;
                },
                "transform": function (d) {
                    if (d.depth > 5 && (direction == 3 || direction == 4)) {
                        return "rotate(90)"
                    }
                },
                stroke: function (d) {
                    return borderColor
                },
                display: function (d) {
                    if (d.id.substring(0, 5) == 'fake_') {
                        return empty_node_setting
                    }
                },
                rx: function (d) {
                    return borderRadius;
                },
                "stroke-width": function (d) {
                    return borderWidth;
                },
                "fill-opacity": function (d) {
                    if (d.id.substring(0, 5) == 'fake_' && empty_node_setting == 'none') {
                        return 0
                    }
                },
            }).each(function (d) {
                if (d.depth == 0) {
                    if (start_x == null) {
                        start_x = -d.x / 10
                    }
                    if (start_y == null) {
                        start_y = -d.y / 10
                    }
                }
            });

        node
            .append('image')
            .attr({
                'class': 'warning',
                'xlink:href': function (d) {
                    return GlobalConstants.warning
                },
                'width': function (d) {
                    if (d.depth > 5) return imgSize[5] / d.depth
                    return imgSize[d.depth] / 2
                },
                'height': function (d) {
                    if (d.depth > 5) return imgSize[5] / d.depth
                    return imgSize[d.depth] / 2
                },
                "x": function (d) {
                    if (d.depth > 5) return -(d.width * 1.1 + 20) / 2 - imgSize[5] / d.depth / 2
                    return -(d.width * 1.1 + 20) / 2 - imgSize[d.depth] / 4;
                },
                y: function (d) {
                    return -(d.height + 20) / 2;
                },
                "display": function (d) {
                    if (d.warning && warning_setting == "SHOW") {
                        if (d.id.substring(0, 5) == 'fake_') {
                            return empty_node_setting
                        }
                        return 'block';
                    } else {
                        return 'none';
                    }
                },
                "transform": function (d) {
                    if (d.depth > 5 && (direction == 3 || direction == 4)) {
                        return "rotate(90)"
                    }
                },
            })

        function elbow(d) {
            switch (direction) {
                case 2:
                    return "M" + (-1) * d.source.y + "," + d.source.x + "H" + (-1) * (d.source.y + (d.target.y - d.source.y) / 2) + "V" + d.target.x + "H" + (-1) * d.target.y;
                case 3:
                    return "M" + d.source.x + "," + d.source.y + "V" + (d.source.y + (d.target.y - d.source.y) / 2) + "H" + d.target.x + "V" + d.target.y;
                case 4:
                    return "M" + d.source.x + "," + (-1) * d.source.y + "V" + (-1) * (d.source.y + (d.target.y - d.source.y) / 2) + "H" + d.target.x + "V" + (-1) * d.target.y;
                default:
                    return "M" + d.source.y + "," + d.source.x + "H" + (d.source.y + (d.target.y - d.source.y) / 2) + "V" + d.target.x + "H" + d.target.y;
            }
        }

        if (direction == 1 || direction == 2) {
            d3
                .select('svg')
                .select('g')
                .attr("transform", "translate(" + start_y + "," + start_x + ") scale(" + start_scale + ")")
            zoom.translate([start_y, start_x]);
            zoom.scale(start_scale * 10);
        } else {
            d3
                .select('svg')
                .select('g')
                .attr("transform", "translate(" + start_x + "," + start_y + ") scale(" + start_scale + ")")
            zoom.translate([start_x, start_y]);
            zoom.scale(start_scale * 10);
        }

        d3.select('svg').select('g').selectAll('g.person')
            .attr({
                transform: function (d) {
                    switch (direction) {
                        case 1:
                            return d.depth < maxGeneration - 1 ? "translate(" + (d.y - 200) + "," + d.x + ")" : "translate(" + d.y + "," + d.x + ")"
                        case 2:
                            return d.depth < maxGeneration - 1 ? "translate(" + (-d.y + 200) + "," + d.x + ")" : "translate(" + (-d.y) + "," + d.x + ")"
                        case 3:
                            return d.depth < maxGeneration - 1 ? "translate(" + (d.x) + "," + (d.y - 200) + ")" : "translate(" + d.x + "," + d.y + ")"
                        case 4:
                            return d.depth < maxGeneration - 1 ? "translate(" + d.x + "," + (-d.y + 200) + ")" : "translate(" + (d.x) + "," + (-d.y) + ")"
                        default:
                            break;
                    }
                }
            })

        if (this.partner_setting == 'SHOW') {
            this.addwife()
        }

        if (this.children_setting == 'SHOW') {
            this.addchildren()
        }
        this.showLoader = false; console.log('Loader off')

        this.bg = localStorage.getItem('background');
        setTimeout(() => {
            if (this.bg) {
                this.addbackground(this.bg)
            }
        }, 1000);
    }

    change_size() {
        const dialogConfig = new MatDialogConfig();
        // The user can't close the dialog by clicking outside its body
        dialogConfig.disableClose = false;
        dialogConfig.id = "modal-component";
        dialogConfig.width = "500px";

        let settingDialog = this.matDialog.open(ChangeSizeComponent, dialogConfig);

        settingDialog.afterClosed().subscribe((result) => {
            if (result) {
                this.settingUpdate();
                this.reloadtree()
            }
        });
    }

    ngOnInit() {

        this.nodeBornText = document.getElementById("born").textContent;
        this.nodeMarriedText = document.getElementById("married").textContent;
        this.nodeDeceasedText = document.getElementById("deceased").textContent;

        this.existingDesignId = localStorage.getItem('doc_id')

        d3
            .select('svg')
            .remove()
        let direction = localStorage.getItem('direction') ? parseInt(localStorage.getItem('direction')) : 1;

        papertype = localStorage.getItem('papertype') ? localStorage.getItem('papertype') : 'A0';
        manColor = localStorage.getItem('manColor') ? localStorage.getItem('manColor') : '#000';
        womanColor = localStorage.getItem('womanColor') ? localStorage.getItem('womanColor') : '#000';;
        borderColor = localStorage.getItem('borderColor') ? localStorage.getItem('borderColor') : '#000';
        maleNodeColor = localStorage.getItem('maleNodeColor') ? localStorage.getItem('maleNodeColor') : '#fff';
        femaleNodeColor = localStorage.getItem('femaleNodeColor') ? localStorage.getItem('femaleNodeColor') : '#fff';
        borderRadius = parseInt(localStorage.getItem('cornerRound') ? localStorage.getItem('cornerRound') : '50');
        borderWidth = parseInt(localStorage.getItem('borderWidth') ? localStorage.getItem('borderWidth') : '2');
        backOpacity = parseFloat(localStorage.getItem('backOpacity') ? localStorage.getItem('backOpacity') : '1');
        nodeOpacity = parseFloat(localStorage.getItem('nodeOpacity') ? localStorage.getItem('nodeOpacity') : '1');
        maxGeneration = parseInt(localStorage.getItem('maxGeneration') ? localStorage.getItem('maxGeneration') : '10');
        treeWidth = localStorage.getItem('tree_width') ? localStorage.getItem('tree_width') : 67408;
        treeHeight = localStorage.getItem('tree_height') ? localStorage.getItem('tree_height') : 47679;
        empty_node_setting = localStorage.getItem('empty_node_setting') ? localStorage.getItem('empty_node_setting') : "block";
        text_align = localStorage.getItem('text_align') ? localStorage.getItem('text_align') : "middle";
        name_text_align = localStorage.getItem('name_text_align') ? localStorage.getItem('name_text_align') : "middle";
        birthSetting = localStorage.getItem('birth_setting') ? localStorage.getItem('birth_setting') : "block";
        marriageSetting = localStorage.getItem('marriage_setting') ? localStorage.getItem('marriage_setting') : "block";
        deathSetting = localStorage.getItem('death_setting') ? localStorage.getItem('death_setting') : "block";
        flag_setting = localStorage.getItem('flag_setting') ? localStorage.getItem('flag_setting') : "SHOW";
        profile_setting = localStorage.getItem('profile_setting') ? localStorage.getItem('profile_setting') : "SHOW";
        warning_setting = localStorage.getItem('warning_setting') ? localStorage.getItem('warning_setting') : "SHOW";
        global_padding = localStorage.getItem('global_padding') ? localStorage.getItem('global_padding') : '5';

        this.p_type = papertype
        this.m_Color = manColor
        this.w_Color = womanColor
        this.m_b_Color = maleNodeColor
        this.w_b_Color = femaleNodeColor
        this.b_Color = borderColor
        this.b_Width = borderWidth
        this.back_Opacity = backOpacity
        this.node_Opacity = nodeOpacity
        this.max_generation = maxGeneration
        this.cornerRound = borderRadius
        this.empty_node = empty_node_setting == "block" ? "SHOW" : "HIDE"
        this.birthSetting = birthSetting == "block" ? "SHOW" : "HIDE"
        this.marriageSetting = marriageSetting == "block" ? "SHOW" : "HIDE"
        this.deathSetting = deathSetting == "block" ? "SHOW" : "HIDE"
        this.partner_setting = localStorage.getItem('partner_setting') && localStorage.getItem('partner_setting') == "SHOW" ? "SHOW" : "HIDE";
        this.children_setting = localStorage.getItem('children_setting') && localStorage.getItem('children_setting') == "SHOW" ? "SHOW" : "HIDE";
        this.flag_setting = flag_setting == "SHOW" ? "SHOW" : "HIDE"
        this.profile_setting = profile_setting == "SHOW" ? "SHOW" : "HIDE"
        this.warning_setting = warning_setting == "SHOW" ? "SHOW" : "HIDE"
        this.global_padding = global_padding

        singleModal = this.matDialog;

        this._id = localStorage.getItem("id");
        this.type = localStorage.getItem("type");

        if (direction == 5) {
            imgSizeGroup = imgSizeGroup3, flagSizeGroup = flagSizeGroup3, textSizeGroup = textSizeGroup3;
        }
        else {
            if (direction == 1 || direction == 2) {
                imgSizeGroup = imgSizeGroup1, flagSizeGroup = flagSizeGroup1, textSizeGroup = textSizeGroup1;
            } else if (direction == 3 || direction == 4) {
                imgSizeGroup = imgSizeGroup2, flagSizeGroup = flagSizeGroup2, textSizeGroup = textSizeGroup2;
            }
        }

        if (profile_setting == "SHOW") {
            imgSize = imgSizeGroup[papertype]
            textSize = textSizeGroup[papertype]
            flagSize = flagSizeGroup[papertype]
        } else {
            imgSize = [0, 0, 0, 0, 0, 0]
            textSize = textSizeGroup[papertype]
            flagSize = flagSizeGroup[papertype]
        }

        switch (text_align) {
            case 'start':
                this.text_align = "LEFT"
                break;

            case 'end':
                this.text_align = "RIGHT"
                break;

            default:
                this.text_align = "CENTER"
                break;
        }

        switch (name_text_align) {
            case 'start':
                this.name_text_align = "LEFT"
                break;

            case 'end':
                this.name_text_align = "RIGHT"
                break;

            default:
                this.name_text_align = "CENTER"
                break;
        }

        // this.nodeinfos = JSON.parse(localStorage.getItem('nodeinfos'));
        // this.coupleinfos = JSON.parse(localStorage.getItem('coupleinfos'));

        this.dbService.getByKey('nodes', 1).subscribe((nodes: any) => {
            this.nodeinfos = JSON.parse(nodes.nodeinfos)
            this.coupleinfos = JSON.parse(nodes.coupleinfos)

            this.selectTreeType(direction);
            this.admin = localStorage.getItem('admin')
            localStorage.removeItem('admin')
            if (this.admin) {
                setTimeout(() => {
                    this.saveSvg()
                }, 4000);
            }
        }, err => console.log(err));

    }
}
